<template>
  <div>
    <a-spin :spinning="spinning">
      <h2 v-if="productType == '' && profileId == 0">
        Create Regular Product - {{ product.name }}
      </h2>
      <h2 v-if="productType == 'G' && profileId == 0">
        Create Gift Certificate Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'P' && profileId == 0">
        Create Package Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'N' && profileId == 0">
        Create Non-Inventory Tracking Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'S' && profileId == 0">
        Create Serial Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'K' && profileId == 0">
        Create Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'V' && profileId == 0">
        Create Virtual Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'M' && profileId == 0">
        Create Matrix Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'B' && profileId == 0">
        Create Combo Item - {{ product.name }}
      </h2>

      <h2 v-else-if="productType == '' && profileId > 0 && btnValue == 1">
        View Regular Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'G' && profileId > 0 && btnValue == 1">
        View Gift Certificate Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'P' && profileId > 0 && btnValue == 1">
        View Package Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'N' && profileId > 0 && btnValue == 1">
        View Non-Inventory Tracking Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'S' && profileId > 0 && btnValue == 1">
        View Serial Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'K' && profileId > 0 && btnValue == 1">
        View Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'V' && profileId > 0 && btnValue == 1">
        View Virtual Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'M' && profileId > 0 && btnValue == 1">
        View Matrix Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'B' && profileId > 0 && btnValue == 1">
        View Combo Item - {{ product.name }}
      </h2>

      <h2 v-else-if="productType == '' && profileId > 0">
        Update Regular Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'G' && profileId > 0">
        Update Gift Certificate Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'P' && profileId > 0">
        Update Package Product - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'N' && profileId > 0">
        Update Non-Inventory Tracking Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'S' && profileId > 0">
        Update Serial Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'K' && profileId > 0">
        Update Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'V' && profileId > 0">
        Update Virtual Kit Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'M' && profileId > 0">
        Update Matrix Item - {{ product.name }}
      </h2>
      <h2 v-else-if="productType == 'B' && profileId > 0">
        Update Combo Item - {{ product.name }}
      </h2>

      <hr />
      <div class="row no-gutters">
        <div class="col-md-2">
          <a-collapse v-model="activeKey" :accordion="accordion">
            <a-collapse-panel header="Basic" key="1">
              <a-menu
                @click="handleClick"
                class="ml-3"
                :defaultSelectedKeys="['1']"
                :selectedKeys="basicSelectedKeys"
              >
                <a-menu-item key="1" :class="selectedBasicKey('1')"> Product Definition </a-menu-item>
                <a-menu-item key="2" :class="selectedBasicKey('2')"> Pricing </a-menu-item>
                <a-menu-item key="3" v-if="!['I', 'G'].includes(product.product_type)" :class="selectedBasicKey('3')"> Classification </a-menu-item>
                <a-menu-item key="4" v-if="product.product_type === ''" :class="selectedBasicKey('4')"> Packages </a-menu-item>
                <a-menu-item key="5" v-if="!['I', 'G'].includes(product.product_type)" :class="selectedBasicKey('5')"> Other </a-menu-item>
              </a-menu>
            </a-collapse-panel>
            <a-collapse-panel header="Advanced" key="2"
            v-if="!['I', 'G'].includes(product.product_type)">
              <a-menu
                @click="handleClick"
                class="ml-3"
                :defaultSelectedKeys="advanceSelectedKey"
                :selectedKeys="advanceSelectedKeys"
              >
                <a-menu-item
                  v-if="
                    productType == '' ||
                    productType == 'K' ||
                    productType == 'N'
                  "
                  key="1"
                  :class="selectedAdvanceKey('1')"
                >
                  Alternate Barcode
                </a-menu-item>
                <a-menu-item key="2" :class="selectedAdvanceKey('2')"> Product Series </a-menu-item>
                <a-menu-item key="3" :class="selectedAdvanceKey('3')"> Product Group Grade </a-menu-item>
                <a-menu-item key="4" :class="selectedAdvanceKey('4')" :disabled="!sitePricingEnabled" > Site Price </a-menu-item>
                <a-menu-item key="5" :class="selectedAdvanceKey('5')" v-if="isSiteProductEnabled"> Site Product </a-menu-item>
                <a-menu-item key="6" :class="selectedAdvanceKey('6')"> Re-order Control </a-menu-item>
                <a-menu-item key="7" :class="selectedAdvanceKey('7')"> Selling </a-menu-item>
                <a-menu-item key="8" :class="selectedAdvanceKey('8')"> SC/NA/PWD </a-menu-item>
                <a-menu-item key="9" :class="selectedAdvanceKey('9')"> CLP </a-menu-item>
                <a-menu-item key="10" :class="selectedAdvanceKey('10')"> Commission </a-menu-item>
                <a-menu-item key="11" :class="selectedAdvanceKey('11')"> Shelf Code </a-menu-item>
                <a-menu-item key="12" :class="selectedAdvanceKey('12')"> Dimension </a-menu-item>
              </a-menu>
            </a-collapse-panel>
            <a-collapse-panel
              v-if="customFormMode == 3 && product.product_type != 'I'"
              header="Others"
              key="3"
            >
              <a-menu
                @click="handleClick"
                class="ml-3"
                :defaultSelectedKeys="['1']"
              >
                <a-menu-item key="1"> User Defined Fields </a-menu-item>
                <a-menu-item key="boxme"> Boxme Integration Settings </a-menu-item>
              </a-menu>
            </a-collapse-panel>
          </a-collapse>
        </div>
        <div class="col-md-10">
          <div class="card mb-3 border-0">
            <base-alert
              v-if="errors.length || tableErrors.length"
              type="danger"
            >
              <b>You have the following error(s):</b>
              <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
              <li v-for="error in tableErrors" v-bind:key="error">
                {{ error }}
              </li>
            </base-alert>

            <form id="form-proper">
              <div v-if="activeKey == '1' && basicKey == '1'" class="card-body">
                <h2 class="card-title">Product Info</h2>
                <div class="row ml-3">
                  <div class="col-md-12">
                    <p v-if="productType == ''">
                      Add pertinent information for this product
                    </p>
                    <p v-else-if="productType == 'P'">
                      Packaged Product will automatically inherit information
                      from the parent regular product
                    </p>
                    <div class="row">
                      <div class="col-md-8 border-right">
                        <template v-if="productType == 'P'">
                          <a-table style="margin-bottom: 15px;"
                           v-if="base_product_name != ''"
                           :columns="baseProductColumns"
                            :dataSource="baseProductData"
                            :pagination="false"
                            bordered>
                          </a-table>
                          <base-input
                            v-else
                            label="Select Regular Product for Packing"
                            required
                          >
                            <a-input-group compact>
                              <a-select
                                v-model="searchFilter"
                                defaultValue="name"
                                style="width: 35%"
                                size="large"
                              >
                                <a-select-option value="name"
                                  >Search by Name</a-select-option
                                >
                                <a-select-option value="barcode"
                                  >Search by Barcode</a-select-option
                                >
                                <a-select-option value="stock_no"
                                  >Search by Stock No.</a-select-option
                                >
                                <a-select-option value="reference_code"
                                  >Search by Reference Code</a-select-option
                                >
                              </a-select>

                              <autocomplete
                                style="width: 65%; margin-top: 2px"
                                ref="autocomplete"
                                placeholder="Search Products"
                                :source="productsEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getProduct"
                              >
                              </autocomplete>
                            </a-input-group>
                          </base-input>
                        </template>

                        <base-input
                          v-if="product == 'P'"
                          label="Product Name"
                          v-model="product.name"
                          input-classes="form-control"
                          placeholder="Enter product name"
                          :disabled="btnValue == 1"
                          required
                        />
                        <base-input
                          v-else
                          label="Product Name"
                          v-model="product.name"
                          input-classes="form-control"
                          placeholder="Enter product name"
                          :disabled="btnValue == 1"
                          required
                        />

                        <base-input
                          label="Short Name"
                          v-model="product.short_name"
                          input-classes="form-control"
                          style="margin-bottom: 0px"
                          placeholder="Enter shortname"
                          :disabled="btnValue == 1"
                          required
                        />
                        <small
                          >Limit to {{ short_name_length }} characters
                          only</small
                        >

                        <div class="row mt-3">
                          <div class="col-md-6">
                            <base-input
                              label="Stock No."
                              v-model="product.stock_no"
                              :disabled="btnValue == 1 || productType == 'P' || product.product_type=='I' || enableAutoBarcodeAndStock == true"
                              required
                            />
                          </div>
                          <div class="col-md-6">
                            <base-input
                              label="Barcode"
                              v-model="product.barcode"
                              :disabled="btnValue == 1 || enableAutoBarcodeAndStock == true"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <base-input label="Unit" required>
                              <a-select
                                v-model="product.unit_id"
                                showSearch
                                placeholder="Select Unit"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="getUnitCode"
                                :disabled="btnValue == 1"
                                :updateKey="updateKey"
                              >
                                <a-select-option
                                  v-for="option in unitOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                          </div>

                          <div v-if="productType == 'P'" class="col-md-6">
                            <base-input
                              type="number"
                              placeholder="Enter Quantity"
                              label="Quantity in Pack"
                              v-model="product.content_quantity"
                              @change="updatePackagePrice"
                              :disabled="btnValue == 1"
                              required
                            />
                          </div>

                          <!-- modal/prompt if Quantity in Pack change -->
                          <a-modal title="Package Quantity Change" okText="Yes" cancelText="No"
                            :visible="modalPackageQuantity"
                            @cancel="handleCancel"
                            @ok="confirmPackageQuantityModal" >
                                 Package Quantity has changed, do you want to recompute the cost and price?
                          </a-modal>

                          <div v-if="productType == 'P'" class="col-md-12">
                            <base-checkbox
                              class="mb-3 mt-3"
                              v-model="product.is_ordering_unit"
                              :disabled="btnValue == 1"
                            >
                              Set as default ordering unit
                            </base-checkbox>
                            <!-- <base-input type="number" placeholder="Enter Quantity" label="Quantity in Pack" v-model="product.content_quantity" @change="updatePackagePrice" required /> -->
                          </div>

                          <div
                            v-if="disable_blank_refcode == true"
                            class="col-md-6"
                          >
                            <base-input
                              placeholder="Enter Reference Code"
                              label="Reference Code"
                              v-model="product.erp_code"
                              :disabled="btnValue == 1"
                              required
                            />
                          </div>
                          <div v-else class="col-md-6">
                            <base-input
                              v-if="lock_refcode == true"
                              placeholder="Enter Reference Code"
                              label="Reference Code"
                              v-model="product.erp_code"
                              :disabled="btnValue == 1"
                            />
                            <base-input
                              v-else
                              :disabled="true"
                              placeholder="Enter Reference Code"
                              label="Reference Code"
                              v-model="product.erp_code"
                            />
                          </div>
                        </div>

                         <div class="col-md-6">
                            <base-input
                              placeholder="Auto-generated Product Code (refcode)"
                              label="Product Code"
                              v-model="product.reference_code"
                              disabled="true"
                            />
                          </div>

                        <div class="row">
                          <div class="col-md-6">
                            <template v-if="formSettings.allow_vat_type_update != true && product.tax_type != null && profileId != 0">
                              <label class="form-control-label">
                                {{product.tax_type == 'V' ? "Vat Type: VAT" : "Vat Type: VAT-EXEMPT"}}
                              </label>
                            </template>
                            <template v-else>
                              <base-input
                                label="VAT Type"
                              >
                                <base-radio name="V" v-model="tax_type" :disabled="btnValue == 1" default>
                                  VAT
                                </base-radio>
                                <base-radio name="N" v-model="tax_type" :disabled="btnValue == 1">
                                  VAT-Exempt
                                </base-radio>
                              </base-input>

                            </template>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <h5 v-if="profileId>0" class="mb-3">Product ID:{{profileId}}</h5>
                        <h4>Product Image</h4>
                        <div class="clearfix">
                          <a-tooltip title="Recommended image size: 1000px x 1000px" placement="leftTop">
                            <a-upload
                              accept="image/png, image/jpeg"
                              listType="picture-card"
                              :file-list="fileList"
                              @preview="handlePreview"
                              @change="handleChange"
                              :disabled="btnValue == 1"
                              :before-upload="beforeUpload"
                            >
                              <div
                                v-if="fileList.length < 5 && imageLoaded == true"
                              >
                                +
                                <div class="ant-upload-text">Upload</div>
                              </div>
                            </a-upload>
                          </a-tooltip>
                          <a-modal
                            :visible="previewVisible"
                            :footer="null"
                            @cancel="handleCancel"
                          >
                            <img
                              alt="example"
                              style="width: 100%"
                              :src="previewImage"
                            />
                          </a-modal>
                        </div>

                        <base-input label="Status" required>
                          <select
                            size="large"
                            class="form-control"
                            v-model="product.status"
                            :disabled="btnValue == 1"
                            style="width: 50%"
                          >
                            <option
                              v-for="option in statusOptions"
                              v-bind:value="option.key"
                              v-bind:key="option.key"
                            >
                              {{ option.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>

                    <br />
                    <!-- <small><span class="fa fa-info-circle"/> Prod</small> -->
                    <div v-if="productType == 'B'">
                      <combo-product-form />
                    </div>

                    <div
                      v-if="productType == 'K' || productType == 'V'"
                      class="row"
                    >
                      <div class="col-md-12">
                        <hr />
                        <base-input
                          v-if="productType == 'K'"
                          label="Select Regular Product for Kit"
                          required
                        >
                          <a-input-group compact>
                            <a-select
                              v-model="searchFilter"
                              defaultValue="name"
                              style="width: 25%"
                              size="large"
                            >
                              <a-select-option value="name"
                                >Search by Name</a-select-option
                              >
                              <a-select-option value="barcode"
                                >Search by Barcode</a-select-option
                              >
                              <a-select-option value="stock_no"
                                >Search by Stock No.</a-select-option
                              >
                              <a-select-option value="reference_code"
                                >Search by Reference Code</a-select-option
                              >
                            </a-select>

                            <autocomplete
                              style="width: 75%; margin-top: 2px"
                              ref="autocomplete"
                              placeholder="Search Products"
                              :source="productsEndpoint"
                              input-class="form-control"
                              results-property="data"
                              :results-display="formattedDisplay"
                              :request-headers="authHeaders"
                              @selected="getProductForKit"
                            >
                            </autocomplete>
                          </a-input-group>
                        </base-input>
                        <base-input
                          v-else-if="productType == 'V'"
                          label="Select Regular Product for Virtual Kit"
                          required
                        >
                          <a-input-group compact>
                            <a-select
                              v-model="searchFilter"
                              defaultValue="name"
                              style="width: 25%"
                              size="large"
                            >
                              <a-select-option value="name"
                                >Search by Name</a-select-option
                              >
                              <a-select-option value="barcode"
                                >Search by Barcode</a-select-option
                              >
                              <a-select-option value="stock_no"
                                >Search by Stock No.</a-select-option
                              >
                              <a-select-option value="reference_code"
                                >Search by Reference Code</a-select-option
                              >
                            </a-select>

                            <autocomplete
                              style="width: 75%; margin-top: 2px"
                              ref="autocomplete"
                              placeholder="Search Products"
                              :source="productsEndpoint"
                              input-class="form-control"
                              results-property="data"
                              :results-display="formattedDisplay"
                              :request-headers="authHeaders"
                              @selected="getProductForKit"
                            >
                            </autocomplete>
                          </a-input-group>
                        </base-input>
                        <h3>Components</h3>
                        <a-table
                          :columns="kitColumns"
                          :dataSource="kitData"
                          :pagination="false"
                          :scroll="{ y: 400 }"
                        >
                          <template
                            v-for="col in ['quantity']"
                            :slot="col"
                            slot-scope="text, record"
                          >
                            <div :key="col">
                              <a-input
                                v-if="record.editable"
                                style="margin: -5px 0"
                                :value="text"
                                @change="
                                  (e) =>
                                    kitHandleChangeTable(
                                      e.target.value,
                                      record.key,
                                      col
                                    )
                                "
                              />
                              <template v-else>{{ text }}</template>
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a
                                  class="btn btn-success btn-sm"
                                  style="color: #fff"
                                  @click="() => kitSave(record.key)"
                                  >Save</a
                                >
                                <a-popconfirm
                                  title="Sure to cancel?"
                                  @confirm="() => kitCancel(record.key)"
                                >
                                  <a
                                    class="btn btn-warning btn-sm"
                                    style="color: #fff"
                                    >Cancel</a
                                  >
                                </a-popconfirm>
                              </span>

                              <a-dropdown v-else>
                                <a class="ant-dropdown-link">
                                  <span class="fa fa-ellipsis-v"></span>
                                </a>
                                <a-menu slot="overlay">
                                  <a-menu-item key="1">
                                    <a @click="() => kitEdit(record.key)"
                                      >Edit</a
                                    >
                                  </a-menu-item>
                                  <a-menu-item key="2" v-if="kitData.length">
                                    <a-popconfirm
                                      title="Sure to delete?"
                                      @confirm="() => kitOnDelete(record.key)"
                                    >
                                      <a href="javascript:;">Delete</a>
                                    </a-popconfirm>
                                  </a-menu-item>
                                </a-menu>
                              </a-dropdown>
                            </div>
                          </template>
                        </a-table>

                        <base-checkbox
                          class="mb-3 mt-3"
                          v-model="recompute_cost"
                        >
                          Automatically Recompute Total Kit Cost
                        </base-checkbox>

                        <base-checkbox class="mb-3" v-model="recompute_price">
                          Automatically Recompute Total Kit Price
                        </base-checkbox>
                      </div>
                    </div>
                    <br />
                    <hr />

                    <matrix-form
                      v-if="productType == 'M'"
                      :formSettings="formSettings"
                      :matrixTemp="matrixData"
                      @setMatrixData="setMatrixData"
                      :key="componentKey"
                      :product="product"
                    ></matrix-form>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '1' && basicKey == '2'" class="card-body">
                <a-tabs defaultActiveKey="1">
                  <a-tab-pane tab="Supplier" key="2">
                    <div class="row">
                      <div class="col-md-12">
                        <p>Set supplier and costing for this product</p>
                        <div class="row">
                          <div v-if="productType == 'P'" class="col-md-8 ml-3">
                            <base-input
                              v-if="disable_blank_supplier == true"
                              label="Primary Supplier"
                              :disabled="btnValue == 1"
                              required
                            >
                              <a-select
                                v-model="product.supplier_id"
                                showSearch
                                placeholder="Enter Primary Supplier"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="updateAlternateSupplier"
                                :disabled="btnValue == 1 || productType == 'P'"
                              >
                                <a-select-option
                                  v-for="option in supplierOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                            <base-input v-else label="Primary Supplier">
                              <a-select
                                v-model="product.supplier_id"
                                showSearch
                                placeholder="Enter Primary Supplier"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="updateAlternateSupplier"
                                :disabled="btnValue == 1 || productType == 'P'"
                              >
                                <a-select-option
                                  v-for="option in supplierOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                            <base-checkbox
                              class="mb-3"
                              v-model="product.is_alternate_supplier"
                              :disabled="btnValue == 1 || productType == 'P'"
                            >
                              Enable alternate supplier
                            </base-checkbox>

                            <div v-if="product.is_alternate_supplier == true">
                              <div class="row">
                                <div class="col-md-10">
                                  <base-input label="Add Alternate Supplier">
                                    <a-select
                                      v-model="alternate_supplier_id"
                                      showSearch
                                      placeholder="Enter Supplier"
                                      optionFilterProp="children"
                                      style="width: 100%"
                                      :filterOption="filterOption"
                                      :disabled="btnValue == 1"
                                    >
                                      <a-select-option
                                        v-for="option in supplierOptions"
                                        :key="option.id"
                                        :value="option.id"
                                        >{{ option.name }}</a-select-option
                                      >
                                    </a-select>
                                  </base-input>
                                </div>
                                <div class="col-md-2">
                                  <button
                                    v-if="tableErrors.length"
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    style="margin-top: 30px"
                                    :disabled="btnValue == 1"
                                  >
                                    Add
                                  </button>
                                  <button
                                    v-else
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    style="margin-top: 30px"
                                    @click.prevent="handleAdd"
                                    :disabled="btnValue == 1"
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>

                              <a-table
                                :columns="columns"
                                :dataSource="data"
                                :pagination="false"
                                :scroll="{ y: 400 }"
                              >
                                <template
                                  v-for="col in ['ordering_cost']"
                                  :slot="col"
                                  slot-scope="text, record"
                                >
                                  <div :key="col">
                                    <a-input
                                      v-if="record.editable"
                                      style="margin: -5px 0"
                                      :value="text"
                                      @change="
                                        (e) =>
                                          handleChangeTable(
                                            e.target.value,
                                            record.key,
                                            col
                                          )
                                      "
                                    />
                                    <template v-else>{{ text }}</template>
                                  </div>
                                </template>
                              </a-table>
                            </div>
                          </div>

                          <div v-else class="col-md-8 ml-3">
                            <base-input
                              v-if="this.disable_blank_supplier == true"
                              label="Primary Supplier"
                              required
                            >
                              <a-select
                                v-model="product.supplier_id"
                                showSearch
                                placeholder="Enter Primary Supplier"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="updateAlternateSupplier"
                                :disabled="btnValue == 1"
                              >
                                <a-select-option
                                  v-for="option in supplierOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                            <base-input v-else label="Primary Supplier">
                              <a-select
                                v-model="product.supplier_id"
                                showSearch
                                placeholder="Enter Primary Supplier"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="updateAlternateSupplier"
                                :disabled="btnValue == 1"
                              >
                                <a-select-option
                                  v-for="option in supplierOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                            <base-input label="Foreign  Supplier">
                              <a-select
                                v-model="foreign_supplier_products.foreign_supplier_id"
                                showSearch
                                placeholder="Enter Foreing Supplier" 
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                @change="updateAlternateForeignSupplier"
                                :disabled="btnValue == 1"
                              >
                                <a-select-option
                                  v-for="option in foreignSupplierOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>

                            <base-checkbox
                              class="mb-3"
                              v-model="product.is_alternate_supplier"
                              :disabled="btnValue == 1"
                            >
                              Enable alternate supplier
                            </base-checkbox>

                            <div v-if="product.is_alternate_supplier == true">
                              <div class="row">
                                <div class="col-md-10">
                                  <base-input label="Add Alternate Supplier">
                                    <a-select
                                      v-model="alternate_supplier_id"
                                      showSearch
                                      placeholder="Enter Supplier"
                                      optionFilterProp="children"
                                      style="width: 100%"
                                      :filterOption="filterOption"
                                      :disabled="btnValue == 1"
                                    >
                                      <a-select-option
                                        v-for="option in supplierOptions"
                                        :key="option.id"
                                        :value="option.id"
                                        >{{ option.name }}</a-select-option
                                      >
                                    </a-select>
                                  </base-input>
                                </div>
                                <div class="col-md-2">
                                  <button
                                    v-if="tableErrors.length"
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    style="margin-top: 30px"
                                    :disabled="btnValue == 1"
                                  >
                                    Add
                                  </button>
                                  <button
                                    v-else
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    style="margin-top: 30px"
                                    @click.prevent="handleAdd"
                                    :disabled="btnValue == 1"
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>

                              <a-table
                                :columns="columns"
                                :dataSource="data"
                                :pagination="false"
                                :scroll="{ y: 400 }"
                              >
                                <template
                                  v-for="col in ['ordering_cost']"
                                  :slot="col"
                                  slot-scope="text, record"
                                >
                                  <div :key="col">
                                    <a-input
                                      v-if="record.editable"
                                      style="margin: -5px 0"
                                      :value="text"
                                      @change="
                                        (e) =>
                                          handleChangeTable(
                                            e.target.value,
                                            record.key,
                                            col
                                          )
                                      "
                                    />
                                    <template v-else>{{ text }}</template>
                                  </div>
                                </template>
                                <template
                                  slot="operation"
                                  slot-scope="text, record"
                                >
                                  <div class="editable-row-operations">
                                    <span v-if="record.editable">
                                      <a
                                        class="btn btn-success btn-sm"
                                        style="color: #fff"
                                        @click="() => save(record.key)"
                                        :disabled="btnValue == 1"
                                        >Save</a
                                      >
                                      <a-popconfirm
                                        title="Sure to cancel?"
                                        @confirm="() => cancel(record.key)"
                                      >
                                        <a
                                          class="btn btn-warning btn-sm"
                                          style="color: #fff"
                                          :disabled="btnValue == 1"
                                          >Cancel</a
                                        >
                                      </a-popconfirm>
                                    </span>

                                    <a-dropdown v-else>
                                      <a class="ant-dropdown-link" :disabled="btnValue == 1">
                                        <span class="fa fa-ellipsis-v"></span>
                                      </a>
                                      <a-menu slot="overlay">
                                        <a-menu-item key="1">
                                          <a @click="() => edit(record.key)"
                                            >Edit</a
                                          >
                                        </a-menu-item>
                                        <a-menu-item key="2" v-if="data.length">
                                          <a-popconfirm
                                            title="Sure to delete?"
                                            @confirm="
                                              () => onDelete(record.key)
                                            "
                                          >
                                            <a href="javascript:;">Delete</a>
                                          </a-popconfirm>
                                        </a-menu-item>
                                      </a-menu>
                                    </a-dropdown>
                                  </div>
                                </template>
                              </a-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane tab="Costing" key="1">
                    <div class="row">
                      <div class="col-md-8 ml-3">
                        <div class="row ml-3">
                          <h3 v-if="!['G'].includes(product.product_type)">Costing </h3>
                          <div class="col-md-12" v-if="!['G'].includes(product.product_type)">
                            <div v-if="costing_mode == '2'" class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Original Cost"
                                  label="Original Cost"
                                  v-model="formattedOriginalCost"
                                  name="original"
                                  @change="changeAmount"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Ordering Cost"
                                  :label="product.currency_code!=null ? 'Ordering Cost (' + product.currency_code + ')' : 'Ordering Cost'"
                                  v-model="formattedOrderingCost"
                                  name="ordering"
                                  @change="changeAmount"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                  required
                                />
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Landed Cost"
                                  :label="'Landed Cost'"
                                  v-model="formattedLandedCost"
                                  name="landed"
                                  @change="changeAmount"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                  required
                                />
                              </div>
                              <div v-if="costing_method == 'BLENDED'" class="col-md-3">
                                <base-input
                                  :label="'Blended Average Cost'"
                                  v-model="formattedBlendedCost"
                                  :disabled="true"
                                />
                              </div>
                              <div v-if="costing_method == 'BLENDED'" class="col-md-3">
                                <base-input
                                  :label="'Standby Landed Cost'"
                                  v-model="formattedStandbyLandedCost"
                                  :disabled="true"
                                />
                              </div>
                              <div v-if="costing_mode == '2'" class="col-md-6 d-none">
                                <base-input
                                  type="number"
                                  min="0"
                                  placeholder="Enter Landed Cost (no VAT)"
                                  label="Landed Cost (No VAT)"
                                  v-model="product.landed_cost_no_vat"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>

                            <div v-if="costing_mode == '2'" class="row">
                              <div class="col-md-6">
                                <base-input
                                  placeholder="Enter Last Discount"
                                  label="Last Discount"
                                  v-model="product.last_discount_text"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>

                            <div v-if="costing_mode == '1'" class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Markup"
                                  label="Markup Percentage"
                                  v-model="formattedMarkupPercent"
                                  name="retail"
                                  @blur="formatValue('markup_percent')"
                                  @change="computePrice"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <h3>Pricing</h3>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Retail Price"
                                  label="Retail Price"
                                  v-model="formattedRetailPrice"
                                  name="percent_retail"
                                  @blur="formatValue('retail_price')"
                                  @change="computeMarkup"
                                  required
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                              <div v-if="costing_mode == '2'" class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Markup "
                                  label="Markup"
                                  v-model="formattedMarkupPercent"
                                  name="retail"
                                  @blur="formatValue('markup_percent')"
                                  @change="computePrice"
                                  required
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                              <br />
                            </div>

                            <div class="row" v-if="!['G'].includes(product.product_type)">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter Original Price"
                                  label="Original Price"
                                  v-model="formattedOriginalPrice"
                                  name="original_price"
                                  @blur="formatValue('original_price')"
                                  required
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter PIML Price 1"
                                  label="PIML Price 1"
                                  v-model="formattedPimlPrice1"
                                  name="piml_price1"
                                  @blur="formatValue('piml_price1')"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter PIML Price 2"
                                  label="PIML Price 2"
                                  v-model="formattedPimlPrice2"
                                  name="piml_price2"
                                  @blur="formatValue('piml_price2')"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="text"
                                  min="0"
                                  placeholder="Enter PIML Price 3"
                                  label="PIML Price 3"
                                  v-model="formattedPimlPrice3"
                                  name="piml_price3"
                                  @blur="formatValue('piml_price3')"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>
                          </div>

                            <div v-if="costing_mode == '2'">
                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-if="disable_blank_wholesale_price == true"
                                    placeholder="Enter Wholesale Price"
                                    label="Wholesale Price"
                                    v-model="formattedWholesalePrice"
                                    name="percent_wholesale"
                                    @blur="formatValue('wholesale_price')"
                                    @change="computeMarkup"
                                    required
                                    :disabled="btnValue == 1 || disablePriceCost"
                                  />

                                  <base-input
                                    type="text"
                                    min="0"
                                    v-else
                                    placeholder="Enter Wholesale Price"
                                    label="Wholesale Price"
                                    v-model="formattedWholesalePrice"
                                    name="percent_wholesale"
                                    @blur="formatValue('wholesale_price')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                  />
                                </div>

                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    placeholder="Enter Markup"
                                    label="Markup"
                                    v-model="markup_wholesale_price"
                                    name="wholesale"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @focus="onFocus('markup_wholesale_price')"
                                    @blur="onBlur('markup_wholesale_price')"
                                    @change="computePrice"
                                  />
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-if="disable_blank_least_price == true"
                                    placeholder="Enter Least Price"
                                    label="Least Price"
                                    v-model="formattedLeastPrice"
                                    name="percent_least"
                                    @blur="formatValue('least_price')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    required
                                  />

                                  <base-input
                                    type="text"
                                    min="0"
                                    v-else
                                    placeholder="Enter Least Price"
                                    label="Least Price"
                                    v-model="formattedLeastPrice"
                                    name="percent_least"
                                    @blur="formatValue('least_price')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    placeholder="Enter Markup"
                                    label="Markup"
                                    v-model="markup_least_price"
                                    name="least"
                                    @change="computePrice"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @focus="onFocus('markup_least_price')"
                                    @blur="onBlur('markup_least_price')"
                                  />
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-if="disable_blank_special_price == true"
                                    placeholder="Enter Special Price"
                                    label="Special Price"
                                    v-model="formattedSpecialPrice"
                                    name="percent_special"
                                    @blur="formatValue('special_price')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    required
                                  />

                                  <base-input
                                    type="text"
                                    min="0"
                                    v-else
                                    placeholder="Enter Special Price"
                                    label="Special Price"
                                    v-model="formattedSpecialPrice"
                                    name="percent_special"
                                    @blur="formatValue('special_price')"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @change="computeMarkup"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    placeholder="Enter Markup"
                                    label="Markup"
                                    v-model="markup_special_price"
                                    name="special"
                                    @change="computePrice"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @focus="onFocus('markup_special_price')"
                                    @blur="onBlur('markup_special_price')"
                                  />
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-if="disable_blank_price4 == true"
                                    placeholder="Enter Price 4"
                                    label="Price 4"
                                    v-model="formattedPrice4"
                                    name="percent_price4"
                                    @blur="formatValue('price4')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    required
                                  />

                                  <base-input
                                    type="text"
                                    min="0"
                                    v-else
                                    placeholder="Enter Price 4"
                                    label="Price 4"
                                    v-model="formattedPrice4"
                                    name="percent_price4"
                                    @blur="formatValue('price4')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    placeholder="Enter Markup"
                                    label="Markup"
                                    v-model="markup_price4"
                                    name="price4"
                                    @change="computePrice"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @focus="onFocus('markup_price4')"
                                    @blur="onBlur('markup_price4')"
                                  />
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-if="disable_blank_price5 == true || ['G'].includes(product.product_type)"
                                    placeholder="Enter Price 5"
                                    label="Price 5"
                                    v-model="formattedPrice5"
                                    name="percent_price5"
                                    @blur="formatValue('price5')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    required
                                  />
                                  <base-input
                                    type="text"
                                    min="0"
                                    v-else
                                    placeholder="Enter Price 5"
                                    label="Price 5"
                                    v-model="formattedPrice5"
                                    name="percent_price5"
                                    @blur="formatValue('price5')"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @change="computeMarkup"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    placeholder="Enter Markup"
                                    label="Markup"
                                    v-model="markup_price5"
                                    name="price5"
                                    @change="computePrice"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    @focus="onFocus('markup_price5')"
                                    @blur="onBlur('markup_price5')"
                                  />
                                </div>
                              </div>
                            <div v-if="['G'].includes(product.product_type)">        
                              <div class="row">
                                <div class="col-md-6">
                                  <base-input
                                    type="text"
                                    min="0"
                                    placeholder="Enter GC Value"
                                    label="GC Value"
                                    v-model="formattedPrice5"
                                    name="percent_price5"
                                    @blur="formatValue('price5')"
                                    @change="computeMarkup"
                                    :disabled="btnValue == 1 || disablePriceCost"
                                    required
                                  />
                                </div>
                              </div>
                            </div>

                          </div>
                          <h3 v-if="!['G'].includes(product.product_type)">Maximum Allowed Discount</h3>
                          <div class="col-md-12" v-if="!['G'].includes(product.product_type)">
                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="number"
                                  min="0"
                                  placeholder="Enter Maximum Percent Discount"
                                  label="Maximum Percentage Discount"
                                  v-model="product.max_percent_discount"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <base-input
                                  type="number"
                                  min="0"
                                  placeholder="Enter Maximum Amount Discount"
                                  label="Maximum Amount Discount"
                                  v-model="product.max_amount_discount"
                                  :disabled="btnValue == 1 || disablePriceCost"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </div>

              <div v-if="activeKey == '1' && basicKey == '3'" class="card-body">
                <h2 class="card-title">Product Classification</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set categorization for this product</p>
                    <h3>Assign Product Category</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Category">
                          <a-cascader
                            :options="categoryOptions"
                            :showSearch="{ filter }"
                            v-model="cascader_category"
                            placeholder="Please select category"
                            style="width: 100%"
                            :disabled="btnValue == 1 || productType == 'P'"
                            @change="updateParams"
                            changeOnSelect
                          />
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Brand</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <a-select
                          v-model="product.brand_id"
                          showSearch
                          placeholder="Select Brand"
                          optionFilterProp="children"
                          style="width: 100%"
                          :filterOption="filterOption"
                          :notFoundContent="fetching ? undefined : null"
                          :disabled="btnValue == 1 || productType == 'P'"
                          @search="handleSearch"
                          @dropdownVisibleChange="handleSearch"
                        >
                          <a-spin
                            v-if="fetching"
                            slot="notFoundContent"
                            size="small"
                          />
                          <a-select-option
                            v-for="option in brandOptions"
                            :key="option.id"
                            :value="option.id"
                            >{{ option.name }}</a-select-option
                          >
                        </a-select>
                      </div>
                    </div>

                    <h3>Assign Tag / Property</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Tags">
                          <a-select
                            v-model="product_properties.property_id"
                            showSearch
                            mode="multiple"
                            placeholder="Select Tags"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            :disabled="btnValue == 1 || productType == 'P'"
                          >
                            <a-select-option
                              v-for="option in propertyOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Product Line</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Product Line">
                          <a-select
                            v-model="product.product_line_id"
                            showSearch
                            placeholder="Select Product Line"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            @change="getIntroDate"
                            :disabled="btnValue == 1 || productType == 'P'"
                            :key="updateKey"
                          >
                            <a-select-option
                              v-for="option in productLineOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>

                        <base-input
                          v-if="product.product_line_id > 0"
                          label="Intro Date"
                        >
                          <br /><a-date-picker
                            v-model="product.intro_date"
                            :format="dateFormat"
                            style="width: 100%"
                            @change="updateIntroDate"
                            :disabled="btnValue == 1"
                            :key="updateKey"
                          />
                        </base-input>
                      </div>
                    </div>

                    <div class="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="showAdvancedInfoDiv"
                      >
                        More Classifications {{ showAdvancedInfo ? "↟" : "↡" }}
                      </button>
                    </div>

                    <div v-if="showAdvancedInfo" class="row mt-2 ml-3">
                      <h3>Assign Color</h3>
                      <div class="col-md-12">
                        <base-input label="Color">
                          <a-select
                            v-model="product.color_id"
                            showSearch
                            placeholder="Select Color"
                            optionFilterProp="children"
                            style="width: 100%"
                            :disabled="btnValue == 1 || productType == 'P'"
                            :filterOption="filterOption"
                          >
                            <a-select-option
                              v-for="option in colorOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>
                      </div>
                    </div>
                  </div>

                  <div v-else class="col-md-8">
                    <p>Set categorization for this product</p>
                    <h3>Assign Product Category</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input
                          v-if="
                            disable_blank_department == true ||
                            disable_blank_division == true ||
                            disable_blank_section == true ||
                            disable_blank_category == true
                          "
                          label="Category"
                          required
                        >
                          <a-cascader
                            :disabled="btnValue == 1"
                            :options="categoryOptions"
                            :showSearch="{ filter }"
                            v-model="cascader_category"
                            placeholder="Please select category"
                            style="width: 100%"
                            @change="updateParams"
                            changeOnSelect
                          />
                        </base-input>
                        <base-input v-else label="Category">
                          <a-cascader
                            :disabled="btnValue == 1"
                            :options="categoryOptions"
                            :showSearch="{ filter }"
                            v-model="cascader_category"
                            placeholder="Please select category"
                            style="width: 100%"
                            @change="updateParams"
                            changeOnSelect
                          />
                        </base-input>
                      </div>
                    </div>
                    <h3>Assign Brand</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <div v-if="disable_blank_brand == true">
                          <div>
                            <base-input label="Brand" required>
                              <a-select
                                v-model="product.brand_id"
                                showSearch
                                placeholder="Select Brand"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                :notFoundContent="fetching ? undefined : null"
                                @search="handleSearch"
                                @dropdownVisibleChange="handleSearch"
                                @select="getSubBrandData"
                                @change="clearSubBrand"
                                :disabled="btnValue == 1"
                                required
                              >
                                <a-spin
                                  v-if="fetching"
                                  slot="notFoundContent"
                                  size="small"
                                />
                                <a-select-option
                                  v-for="option in brandOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                          </div>
                          <!-- sub brand condition: disable_blank_brand : disable_blank_brand true-->
                          <div v-if="subbrandOptions.length > 0">
                            <base-input
                              label="Sub Brand"
                              v-if="productType == '' || productType == 'M'"
                            >
                              <a-select
                                v-model="product.sub_brand_id"
                                placeholder="Select Sub Brands"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                :disabled="btnValue == 1"
                                showSearch
                              >
                                <a-select-option
                                  v-for="sub_brand_option in subbrandOptions"
                                  :key="sub_brand_option.id"
                                  :value="sub_brand_option.id"
                                  >{{ sub_brand_option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                          </div>
                          <!-- end sub brand condition: PRODUCT_TYPE=P : disable_blank_brand true-->
                        </div>

                        <div v-else>
                          <div>
                            <base-input label="Brand">
                              <a-select
                                v-model="product.brand_id"
                                showSearch
                                placeholder="Select Brand"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                :notFoundContent="fetching ? undefined : null"
                                @search="handleSearch"
                                @dropdownVisibleChange="handleSearch"
                                @select="getSubBrandData"
                                :disabled="btnValue == 1"
                                @change="clearSubBrand"
                              >
                                <a-spin
                                  v-if="fetching"
                                  slot="notFoundContent"
                                  size="small"
                                />
                                <a-select-option
                                  v-for="option in brandOptions"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                          </div>
                          <!-- sub brand condition: PRODUCT_TYPE=P : disable_blank_brand false-->
                          <div v-if="subbrandOptions.length > 0">
                            <base-input
                              label="Sub Brand"
                              v-if="productType == '' || productType == 'M'"
                            >
                              <a-select
                                v-model="product.sub_brand_id"
                                placeholder="Select Sub Brands"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="filterOption"
                                :disabled="btnValue == 1"
                                showSearch
                              >
                                <a-select-option
                                  v-for="sub_brand_option in subbrandOptions"
                                  :key="sub_brand_option.id"
                                  :value="sub_brand_option.id"
                                  >{{ sub_brand_option.name }}</a-select-option
                                >
                              </a-select>
                            </base-input>
                          </div>
                          <!-- end sub brand condition: PRODUCT_TYPE=P : disable_blank_brand false-->
                        </div>
                      </div>
                    </div>

                    <h3>Assign Tag / Property</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Tags">
                          <a-select
                            v-model="product_properties.property_id"
                            showSearch
                            mode="multiple"
                            placeholder="Select Tags"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            :disabled="btnValue == 1"
                          >
                            <a-select-option
                              v-for="option in propertyOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Product Line</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input
                          v-if="disable_blank_product_line == true"
                          label="Product Line"
                          required
                        >
                          <a-select
                            v-model="product.product_line_id"
                            showSearch
                            placeholder="Select Product Line"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            @change="getIntroDate"
                            :disabled="btnValue == 1"
                            :key="updateKey"
                          >
                            <a-select-option
                              v-for="option in productLineOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>
                        <base-input v-else label="Product Line">
                          <a-select
                            v-model="product.product_line_id"
                            showSearch
                            placeholder="Select Product Line"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            @change="getIntroDate"
                            :disabled="btnValue == 1"
                            :key="updateKey"
                          >
                            <a-select-option
                              v-for="option in productLineOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>

                        <base-input
                          v-if="product.product_line_id > 0"
                          label="Intro Date"
                        >
                          <br /><a-date-picker
                            v-model="product.intro_date"
                            :format="dateFormat"
                            style="width: 100%"
                            @change="updateIntroDate"
                            :disabled="btnValue == 1"
                            :key="updateKey"
                          />
                        </base-input>
                      </div>
                    </div>

                    <div
                      class="d-flex justify-content-center mt-4"
                      v-if="productType != 'M'"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="showAdvancedInfoDiv"
                      >
                        More Classifications {{ showAdvancedInfo ? "↟" : "↡" }}
                      </button>
                    </div>

                    <div v-if="showAdvancedInfo" class="row mt-2 ml-3">
                      <h3>Assign Color</h3>
                      <div class="col-md-12">
                        <base-input label="Color">
                          <a-select
                            v-model="product.color_id"
                            showSearch
                            placeholder="Select Color"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            :disabled="btnValue == 1"
                          >
                            <a-select-option
                              v-for="option in colorOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '1' && basicKey == '4'" class="card-body">
                <h2 class="card-title">Packages</h2>
                <div class="col-md-12">
                  <!-- <a-spin :spinning="spinning"> -->
                    <a-table
                      :loading="loading"
                      :columns="packagesColumns"
                      :dataSource="packages"
                      :pagination="false"
                      :scroll="{ y: 400 }"
                    >
                    <span slot="isOrderingUnit" slot-scope="record">
                      <a-checkbox :checked="selectedOrderingUnitId == record.id" @click="updateIsOrderingUnit(record)" >
                      </a-checkbox>
                    </span>
                    <span slot="saveIsOrderingUnit" slot-scope="record">
                      <button type="button" class="btn btn-sm btn-primary " v-if="selectedOrderingUnitId == record.id" @click="setOrderingUnit">
                        Save
                      </button>
                    </span>
                    </a-table>
                    <!-- </a-spin> -->
                  </div>
                  <div class="row ml-3">

                  </div>
              </div>

              <div v-if="activeKey == '1' && basicKey == '5'" class="card-body">
                <h2 class="card-title">Additional Information</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <base-input
                      placeholder="Enter Remark"
                      label="Remark"
                      v-model="product.remark"
                      :disabled="btnValue == 1"
                    />

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_require_lotcode"
                      :disabled="btnValue == 1"
                    >
                      This product requires Lot Codes & Expiry Date
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_require_remark"
                      :disabled="btnValue == 1"
                    >
                      This product requires Item Remarks
                    </base-checkbox>

                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="allow_zero">
                      This product allows zero prices
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_non_trade" :disabled="btnValue == 1">
                      This product is a non-trade
                    </base-checkbox>
                    <base-checkbox class="mb-3" v-model="product.is_non_saleable" :disabled="btnValue == 1">
                      This product is a non-saleable
                    </base-checkbox>
                  </div>
                  <div v-else class="col-md-8">
                    <base-input
                      placeholder="Enter Remark"
                      label="Remark"
                      v-model="product.remark"
                      :disabled="btnValue == 1"
                    />

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_require_lotcode"
                      :disabled="btnValue == 1"
                    >
                      This product requires Lot Codes & Expiry Date
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_require_remark"
                      :disabled="btnValue == 1"
                    >
                      This product requires Item Remarks
                    </base-checkbox>

                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="allow_zero">
                      This product allows zero prices
                    </base-checkbox>

                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="product.is_non_trade">
                      This product is a non-trade
                    </base-checkbox>
                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="product.is_non_saleable">
                      This product is a non-saleable
                    </base-checkbox>
                  </div>
                </div>

                <h2 class="card-title">Integrations</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set reference date for integration</p>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input label="Reference Date">
                          <br /><a-date-picker
                            v-model="product.reference_date"
                            :format="dateFormat"
                            style="width: 100%"
                            @change="updateRefDate"
                            :disabled="btnValue == 1"
                            :key="updateKey"
                          />
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-md-8">
                    <p>Set reference date for integration</p>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input label="Reference Date">
                          <br /><a-date-picker
                            v-model="product.reference_date"
                            :format="dateFormat"
                            style="width: 100%"
                            @change="updateRefDate"
                            :key="updateKey"
                            :disabled="btnValue == 1"
                          />
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  activeKey == '2' &&
                  advanceKey == '1' &&
                  (productType == '' ||
                    productType == 'K' ||
                    productType == 'N')
                "
                class="card-body"
              >
                <h2 class="card-title">Alternate Barcode</h2>
                <div class="row ml-3">
                  <div class="col-md-12">
                    <p>Add alternate barcode for your product</p>
                    <h3>Alternate Barcode</h3>
                    <button
                      :disabled="btnValue == 1"
                      v-if="tableErrors.length"
                      type="button"
                      class="btn btn-sm btn-primary float-right"
                      style="margin-bottom: 10px"
                    >
                      Add
                    </button>
                    <button
                      :disabled="btnValue == 1"
                      v-else
                      type="button"
                      class="btn btn-sm btn-primary float-right"
                      style="margin-bottom: 10px"
                      @click.prevent="barcodeHandleAdd"
                    >
                      Add
                    </button>
                    <br /><br />
                    <a-table
                      :columns="barcodeColumns"
                      :dataSource="barcodeData"
                      :pagination="false"
                      :scroll="{ x: 3000, y: 400 }"
                    >
                      <template
                        v-for="col in ['barcode', 'status', 'mall_group_id', 'supplier_code', 'description', 'pel', 'dept', 'sub_dept', 'class_code', 'sub_class', 'vendpart', 'quantity']"
                        :slot="col"
                        slot-scope="text, record"
                      >
                        <div :key="col">
                          <div v-if="col == 'status'">
                            <a-switch
                              v-if="record.editable"
                              :checked="record.status == 'A'"
                              @change="
                                (e) =>
                                  barcodeHandleChangeTable(e, record.key, col)
                              "
                            />
                            <a-switch
                              v-else
                              :checked="record.status == 'A'"
                              :disabled="true"
                            />
                          </div>
                          <div v-else-if="col == 'mall_group_id'">
                                <select class="form-control" v-if="record.editable" :value="text"
                                  @change="
                                  (e) =>
                                    barcodeHandleChangeTable(
                                      e.target.value,
                                      record.key,
                                      col
                                    )
                                ">
                                    <option value="">Select Mall Group</option>
                                    <option v-for="option in mallGroupOptions" v-bind:key="'mallGroupOptions'+option.id" v-bind:value="option.id">
                                        {{option.code}} - {{option.name}}
                                    </option>
                                </select>
                          
                            <template v-else-if="text == undefined || text == ''">{{ '-' }}</template>
                            <template v-else>{{ alternateBarcodeMallName(text) }}</template>
                          </div>
                          <div v-else-if="isReadOnlyAlternateBarcodeField(col)">
                            <template v-if="isAlternateBarcodeFieldAllowed(record, col)">{{ text }}</template>
                            <template v-else>-</template>
                          </div>
                          <div v-else>
                            <a-input
                              v-if="record.editable && isAlternateBarcodeFieldAllowed(record, col)"
                              style="margin: -5px 0"
                              :value="text"
                              @change="
                                (e) =>
                                  barcodeHandleChangeTable(
                                    e.target.value,
                                    record.key,
                                    col
                                  )
                              "
                            />
                            <template v-else-if="record.editable">-</template>
                            <template v-else>{{ text }}</template>
                          </div>
                        </div>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations alternate-barcode-actions">
                          <span v-if="record.editable">
                            <a
                              class="btn btn-success btn-sm"
                              style="color: #fff"
                              @click="() => barcodeSave(record.key)"
                              >Save</a
                            >
                            <a-popconfirm
                              title="Sure to cancel?"
                              @confirm="() => barcodeCancel(record.key)"
                            >
                              <a
                                class="btn btn-warning btn-sm"
                                style="color: #fff"
                                >Cancel</a
                              >
                            </a-popconfirm>
                          </span>

                          <a-dropdown v-else>
                            <a class="ant-dropdown-link" :disabled="btnValue == 1">
                              <span class="fa fa-ellipsis-v"></span>
                            </a>
                            <a-menu slot="overlay">
                              <a-menu-item key="1">
                                <a @click="() => barcodeEdit(record.key)"
                                  >Edit</a
                                >
                              </a-menu-item>
                              <a-menu-item key="2" v-if="barcodeData.length">
                                <a-popconfirm
                                  title="Sure to delete?"
                                  @confirm="() => barcodeOnDelete(record.key)"
                                >
                                  <a href="javascript:;">Delete</a>
                                </a-popconfirm>
                              </a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>

              <!-- Product Series Form -->
              <div
                v-if="activeKey == '2' && advanceKey == '2'"
                class="card-body"
              >
                <h2 class="card-title">Product Series</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>
                      Tracking of the introduction date of item, as well as the
                      repeat orders
                    </p>

                    <div class="row">
                      <div class="col">
                        <base-input label="Series Name">
                          <a-select
                            v-model="product_series.series_name"
                            showSearch
                            placeholder="Select Series Name"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            :disabled="btnValue == 1"
                          >
                          <a-select-option
                            v-for="product_series_option in productSeriesOptions"
                            :key="product_series_option.key"
                            :value="product_series_option.name"

                          > {{product_series_option.name}}
                          </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                      <div class="col">
                        <base-input label="Series Date">
                          <a-date-picker
                            name="series_date"
                            class="series_date_field"
                            :format="dateFormat"
                            v-model="product_series.series_date"
                            placeholder="Select date"
                            @change="updateProductSeriesSeriesDate"
                            :disabled="btnValue == 1"
                            required
                          />
                        </base-input>
                      </div>
                    </div>
                    <div class="float-right">
                      <template v-if="productseriesButton === 'add'">
                        <button
                          type="button"
                          class="btn btn-sm btn-primary float-right"
                          name="submit"
                          :disabled="btnValue == 1"
                          @click="productseriesHandleAdd"
                        >
                          Add
                        </button>
                      </template>

                      <template v-else-if="productseriesButton === 'delete'">
                        <a-popconfirm :disabled="btnValue == 1"
                          title="Delete Product Series?"
                          @confirm="() => productseriesDelete(productseriesKey)"
                        >
                          <a
                            href="javascript:;"
                            class="btn btn-warning btn-sm"
                            style="color: #fff"
                            >Delete</a
                          >
                        </a-popconfirm>
                      </template>
                    </div>

                    <br />
                    <br />
                  </div>
                  <!-- product series table -->
                  <div class="col-md-8">
                    <a-table
                      :columns="productseriesColumns"
                      :dataSource="productseriesData"
                      :pagination="false"
                      :scroll="{ y: 400 }"
                      :customRow="changeProductSeriesButton"
                    >
                    </a-table>
                  </div>
                  <!-- end product series table -->
                </div>
              </div>
              <!-- End of Product Series Form -->

              <!-- Product Group Grade Form -->
              <div
                v-if="activeKey == '2' && advanceKey == '3'"
                class="card-body"
              >
                <h2 class="card-title">Product Group Grade</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Tracking of Product Status Grade</p>
                    <div v-if="btnValue !=1 && product.product_type=='M'">
                      <base-checkbox v-if="product.product_group == null ||
                        formSettings.allow_product_group_update == true"
                        class="mb-3" v-model="product.include_product_group_to_children">
                        Add/Update Matrix Children Product Group
                      </base-checkbox>
                      <base-checkbox class="mb-3" v-model="product.include_product_grade_to_children">
                        Add/Update Matrix Children Product Grade
                      </base-checkbox>
                    </div>
                    <base-input
                      v-if="
                        product.product_group != null &&
                        formSettings.allow_product_group_update != true
                      "
                      label="Product Group"
                    >
                      <h1>{{ product.product_group.name }}</h1>
                    </base-input>
                    <base-input v-else label="Product Group">
                      <a-select
                        v-model="product.product_group_id"
                        showSearch
                        placeholder="Select Product Group"
                        optionFilterProp="children"
                        style="width: 100%"
                        :filterOption="filterOption"
                        :disabled="btnValue == 1"
                      >
                        <a-select-option
                          v-for="product_group_option in productGroupOptions"
                          :key="product_group_option.id"
                          :value="product_group_option.id"
                          >{{ product_group_option.name }}</a-select-option
                        >
                      </a-select>
                    </base-input>

                    <div class="row">
                      <div class="col-6">
                        <base-input label="Date">
                          <a-date-picker
                            name="product_grade_effectivity_date"
                            class="product_grade_field"
                            :format="dateFormat"
                            :disabled-date="disabledDate"
                            :disabled="btnValue == 1"
                            v-model="product_grade.effectivity_date"
                            placeholder="Select date"
                            @change="updateProductGradeEffectivityDate"
                            required
                          />
                        </base-input>
                      </div>
                    </div>
                    <div class="float-right">
                      <button
                        v-if="btnValue != 1"
                        type="button"
                        class="btn btn-sm btn-primary float-right"
                        name="submit"
                        @click="productGradeHandleAdd"
                      >
                        Add
                      </button>
                    </div>

                    <br />
                    <br />
                  </div>

                  <!-- product group grade table -->
                  <div class="col-md-8">
                    <a-table
                      :columns="productGradeColumns"
                      :dataSource="productGradeData"
                      :pagination="false"
                      :scroll="{ y: 400 }"
                    >
                    </a-table>
                  </div>
                  <!-- end product group grade table -->
                </div>
              </div>
              <!-- End of Product Group Grade Form -->

              <div
                v-if="activeKey == '2' && advanceKey == '4'"
                class="card-body"
              >
                <h2 class="card-title">Site Price</h2>
                <div class="row ml-3">
                  <div class="col-md-10">
                    <p>
                      Set different prices for this product on different sites
                    </p>
                    <!-- bryan -->
                    <template>
                      <a-modal
                      :visible="sitePriceModalVisible"
                      title="Warning"
                      @ok="closeModal('ok')"
                      @cancel="closeModal('cancel')"
                      centered
                      :closable="false"
                      :maskClosable="false"
                      >
                        <p>Disabling will reset the price per site of this product to default. </p>
                        <p> Would you like to proceed?</p>
                      </a-modal>
                    </template>
                    <!-- <base-checkbox class="mb-3"  v-model="is_site_price" :disabled="btnValue == 1">
                      Enable Site Pricing
                    </base-checkbox> -->
                    <div v-if="sitePricingEnabled">
                      <h3>Site Prices</h3>
                      <button
                        v-if="tableErrors.length"
                        type="button"
                        class="btn btn-sm btn-primary float-right"
                        style="margin-bottom: 10px"
                        :disabled="btnValue == 1"
                      >
                        Add
                      </button>
                      <button
                        v-else
                        type="button"
                        class="btn btn-sm btn-primary float-right"
                        style="margin-bottom: 10px"
                        @click.prevent="showDrawer(-1)"
                        :disabled="btnValue == 1"
                      >
                        Add
                      </button>
                      <br /><br />
                      <a-table
                        :columns="priceColumns"
                        :dataSource="priceData"
                        :pagination="false"
                        :scroll="{ y: 400 }"
                      >
                        <template slot="operation" slot-scope="text, record">
                          <div class="editable-row-operations">
                            <a-dropdown :disabled="btnValue == 1">
                              <a class="ant-dropdown-link">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay" :disabled="btnValue == 1">
                                <a-menu-item key="1">
                                  <a @click="() => showDrawer(record.key)"
                                    >Edit</a
                                  >
                                </a-menu-item>
                                <a-menu-item key="2" v-if="priceData.length">
                                  <a-popconfirm
                                    title="Sure to delete?"
                                    @confirm="() => priceOnDelete(record.key)"
                                  >
                                    <a href="javascript:;">Delete</a>
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                          </div>
                        </template>
                      </a-table>

                      <a-drawer
                        title=""
                        :width="480"
                        placement="right"
                        @close="onClose"
                        :visible="visible"
                      >
                        <div>
                          <site-price-form
                            :targetKey="targetKey"
                            :product="product"
                            :targetData="priceData"
                            @closeDrawer="closeDrawer"
                            @setTargetData="setTargetData"
                            @updateTargetData="updateTargetData"
                            :key="componentKey"
                            :formSettings="formSettings"
                          ></site-price-form>
                        </div>
                      </a-drawer>
                    </div>
                  </div>
                </div>
              </div>
              <!-- site products location tagging -->
              <div
                v-if="activeKey == '2' && advanceKey == '5' && isSiteProductEnabled"
                class="card-body"
              >
                <h2 class="card-title">Site Product</h2>

                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Set which sites this product is available for selling</p>
                    <h5>
                      Atleast one site should be selected (all sites selected by
                      default)
                    </h5>
                    <!--
                          * selected row keys accepts parents key
                          * parent_key change to location name which is string .
                          * filter selected row keys to remove string which is the parent key on create and update method
                        -->
                    <a-tree
                      checkable
                      :defaultCheckedKeys="selectedRowKeys"
                      :treeData="productData"
                      @check="onCheckSiteId"
                      :disabled="btnValue == 1 || productType == 'P'"
                    />
                  </div>
                </div>
              </div>
              <!-- end site products location tagging -->

              <div
                v-if="activeKey == '2' && advanceKey == '6'"
                class="card-body"
              >
                <h2 class="card-title">Re-order Control</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <!-- <p>
                      Ensure that optimum stock quantity for this product is met
                      by setting up alerts
                    </p>
                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_notification"
                      :disabled="btnValue == 1"
                    >
                      Send a notification when stock for this item has reached
                      minimum/maximum quantity
                    </base-checkbox> -->

                    <div class="row">
                      <div class="col-md-6">
                        <base-input
                          type= "number"
                          min="0"
                          placeholder="Enter Quantity"
                          label="Minimum Quantity"
                          :error="checkMinMaxMsg"
                          :valid="checkMinMax"
                          v-model="product.min_quantity"
                          :disabled="btnValue == 1"

                        />

                      </div>
                      <div class="col-md-6">
                        <base-input
                          class=""
                          type="number"
                          min="0"
                          placeholder="Enter Quantity"
                          label="Maximum Quantity"
                          :valid="checkMinMax"
                          v-model="product.max_quantity"
                          :disabled="btnValue == 1"

                        />
                      </div>
                    </div>

                    <base-input label="Turn on this function">
                      <select
                        size="large"
                        class="form-control"
                        v-model="reorder_mode"
                        :disabled="btnValue == 1"
                      >
                        <option
                          v-for="option in reorderOptions"
                          v-bind:value="option.key"
                          v-bind:key="option.key"
                        >
                          {{ option.value }}
                        </option>
                      </select>
                    </base-input>

                    <div v-if="reorder_mode == '2'" class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Select Site">
                          <a-select
                            v-model="site_products.site_id"
                            showSearch
                            placeholder="Enter Site"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="filterOption"
                            :disabled="btnValue == 1"
                          >
                            <a-select-option
                              v-for="option in siteOptions"
                              :key="option.id"
                              :value="option.id"
                              >{{ option.name }}</a-select-option
                            >
                          </a-select>
                        </base-input>

                        <button
                          v-if="tableErrors.length"
                          type="button"
                          class="btn btn-sm btn-primary float-right"
                          style="margin-bottom: 10px"
                          :disabled="btnValue == 1"
                        >
                          Add
                        </button>
                        <button
                          v-else
                          type="button"
                          class="btn btn-sm btn-primary float-right"
                          style="margin-bottom: 10px"
                          @click.prevent="reorderHandleAdd"
                          :disabled="btnValue == 1"
                        >
                          Add
                        </button>
                        <br /><br />
                        <b-alert v-if="!perSiteCheckMinMax && perSiteMinMaxMsg" show variant="danger">{{this.perSiteMinMaxMsg}}</b-alert>
                        <a-table
                          :columns="reorderColumns"
                          :dataSource="reorderData"
                          :pagination="false"
                          :scroll="{ y: 400 }"
                        >
                          <template
                            v-for="col in ['min_quantity', 'max_quantity']"
                            :slot="col"
                            slot-scope="text, record"
                          >
                            <div :key="col">
                              <base-input
                                type="number"
                                min="0"
                                :valid="perSiteCheckMinMax"
                                v-if="record.editable"
                                style="margin: -5px 0"
                                :value="text"
                                :disabled="btnValue == 1"
                                @change="
                                  (e) =>
                                    reorderHandleChangeTable(
                                      e.target.value,
                                      record.key,
                                      col
                                    )
                                "
                              />
                              <template v-else>{{ text }}</template>
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a
                                  class="btn btn-success btn-sm"
                                  style="color: #fff"
                                  @click="() => reorderSave(record.key)"
                                  :disabled="btnValue == 1"
                                  >Save</a
                                >
                                <a-popconfirm
                                  title="Sure to cancel?"
                                  @confirm="() => reorderCancel(record.key)"
                                >
                                  <a
                                    class="btn btn-warning btn-sm"
                                    style="color: #fff"
                                    :disabled="btnValue == 1"
                                    >Cancel</a
                                  >
                                </a-popconfirm>
                              </span>

                              <a-dropdown v-else>
                                <a :disabled="btnValue == 1" class="ant-dropdown-link">
                                  <span class="fa fa-ellipsis-v"></span>
                                </a>
                                <a-menu slot="overlay">
                                  <a-menu-item key="1">
                                    <a @click="() => reorderEdit(record.key)"
                                      >Edit</a
                                    >
                                  </a-menu-item>
                                  <a-menu-item
                                    key="2"
                                    v-if="reorderData.length"
                                  >
                                    <a-popconfirm
                                      title="Sure to delete?"
                                      @confirm="
                                        () => reorderOnDelete(record.key)
                                      "
                                    >
                                      <a href="javascript:;">Delete</a>
                                    </a-popconfirm>
                                  </a-menu-item>
                                </a-menu>
                              </a-dropdown>
                            </div>
                          </template>
                        </a-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '7'"
                class="card-body"
              >
                <h2 class="card-title">Selling</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set properties for this item at point of sale</p>
                    <h4>Mark item as</h4>
                    <base-checkbox class="mb-3" v-model="product.is_concession" :disabled="btnValue == 1">
                      Concession Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_weighted" :disabled="btnValue == 1">
                      Weighted Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_grocery" :disabled="btnValue == 1">
                      Grocery Item
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_open_department"
                      :disabled="btnValue == 1"
                    >
                      Open Department Item
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_ecomm_product"
                      :disabled="btnValue == 1"
                    >
                      Ecomm Product
                    </base-checkbox>
                  </div>

                  <div v-else class="col-md-8">
                    <p>Set properties for this item at point of sale</p>
                    <h4>Mark item as</h4>
                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="product.is_concession">
                      Concession Item
                    </base-checkbox>

                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="product.is_weighted">
                      Weighted Item
                    </base-checkbox>

                    <base-checkbox :disabled="btnValue == 1" class="mb-3" v-model="product.is_grocery">
                      Grocery Item
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_open_department"
                      :disabled="btnValue == 1"
                    >
                      Open Department Item
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_ecomm_product"
                      :disabled="btnValue == 1"
                    >
                      Ecomm Product
                    </base-checkbox>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '8'"
                class="card-body"
              >
                <h2 class="card-title">SC/NA/PWD</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <h3>SC/NA/PWD Discounting</h3>
                    <p>Set how this item handles SC/NA/PWD Discounts</p>
                    <hr />

                    <h4>Senior Citizen Discounting</h4>
                    <base-input label="SC Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.sc_discount_percent"
                        disabled
                        addonAfter="%"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_senior_vatex"
                      disabled
                    >
                      SC VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_senior_nolimit"
                      disabled
                    >
                      Disable SC Limit for this item
                    </base-checkbox>

                    <hr />

                    <h4>National Athlete Discounting</h4>
                    <base-input label="NA Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.pnstm_discount_percent"
                        disabled
                        addonAfter="%"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pnstm_vatex"
                      disabled
                    >
                      NA VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pnstm_nolimit"
                      disabled
                    >
                      Disable NA Limit for this item
                    </base-checkbox>

                    <hr />

                    <h4>PWD Discounting</h4>
                    <base-input label="Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.pwd_discount_percent"
                        addonAfter="%"
                        disabled
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pwd_vatex"
                      disabled
                    >
                      PWD VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pwd_nolimit"
                      disabled
                    >
                      Disable PWD Limit for this item
                    </base-checkbox>

                    <base-input label="SP Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.sp_discount_percent"
                        disabled
                        addonAfter="%"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_sp_vatex"
                      disabled
                    >
                      SP VAT-Exempt
                    </base-checkbox>
                  </div>



                  <div v-else class="col-md-8">
                    <h3>SC/NA/PWD Discounting</h3>
                    <p>Set how this item handles discounts</p>
                    <hr />

                    <h4>Senior Citizen Discounting</h4>
                    <base-input label="SC Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.sc_discount_percent"
                        addonAfter="%"
                        @change="onSetVatex"
                        :disabled="btnValue == 1"
                        name="sc_discount"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_senior_vatex"
                      disabled
                    >
                      SC VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_senior_nolimit"
                      disabled
                    >
                      Disable SC Limit for this item
                    </base-checkbox>

                    <hr />

                    <h4>National Athlete Discounting</h4>
                    <base-input label="NA Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.pnstm_discount_percent"
                        addonAfter="%"
                        @change="onSetVatex"
                        :disabled="btnValue == 1"
                        name="na_discount"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pnstm_vatex"
                      disabled
                    >
                      NA VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pnstm_nolimit"
                      disabled
                    >
                      Disable NA Limit for this item
                    </base-checkbox>

                    <hr />

                    <h4>PWD Discounting</h4>
                    <base-input label="Discount">
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.pwd_discount_percent"
                        addonAfter="%"
                        @change="onSetVatex"
                        :disabled="btnValue == 1"
                        name="pwd_discount"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pwd_vatex"
                      disabled
                    >
                      PWD VAT-Exempt
                    </base-checkbox>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_pwd_nolimit"
                      disabled
                    >
                      Disable PWD Limit for this item
                    </base-checkbox>

                    <hr> </hr>
                    <h4>SP Discounting</h4>
                    <base-input label="Discount">

                      <a-input
                        type="number"
                        min="0"
                        v-model="product.sp_discount_percent"
                        addonAfter="%"
                        @change="onSetVatex"
                        :disabled="btnValue == 1"
                        name="sp_discount"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_sp_vatex"
                      disabled
                    >
                      SP VAT-Exempt
                    </base-checkbox>

                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '9'"
                class="card-body"
              >
                <h2 class="card-title">CLP</h2>
                <div v-if="productType == 'P'" class="row ml-3">
                  <div class="col-md-8">
                    <p>Apply CLP configuration to this item</p>
                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_reward_item"
                      :disabled="btnValue == 1"
                    >
                      Use this item as a reward
                    </base-checkbox>

                    <base-input
                      class="ml-3"
                      v-if="product.is_reward_item == true"
                      placeholder="Enter Points"
                      label="Reward Required Points"
                      v-model="product.reward_required_points"
                      :disabled="btnValue == 1"
                    />

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_no_clp_points"
                      :disabled="btnValue == 1"
                    >
                      This product will not earn points
                    </base-checkbox>
                  </div>
                </div>
                <div v-else class="row ml-3">
                  <div class="col-md-8">
                    <p>Apply CLP configuration to this item</p>
                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_reward_item"
                      :disabled="btnValue == 1"
                    >
                      Use this item as a reward
                    </base-checkbox>

                    <base-input
                      type="number"
                      min="0"
                      class="ml-3"
                      v-if="product.is_reward_item == true"
                      placeholder="Enter Points"
                      label="Reward Required Points"
                      v-model="product.reward_required_points"
                      :disabled="btnValue == 1"
                    />

                    <base-checkbox
                      class="mb-3"
                      v-model="product.is_no_clp_points"
                      :disabled="btnValue == 1"
                    >
                      This product will not earn points
                    </base-checkbox>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '10'"
                class="card-body"
              >
                <h2 class="card-title">Commission</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set commission earned from this product</p>
                    <base-checkbox
                      class="mb-3"
                      v-model="is_enable_sales_commission"
                      :disabled="btnValue == 1"
                    >
                      Enable Salesman Commission
                    </base-checkbox>

                    <base-input
                      class="ml-3"
                      v-if="is_enable_sales_commission == true"
                      label="Salesman Commission"
                    >
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.salesman_commission"
                        :disabled="btnValue == 1"
                        addonAfter="%"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="is_enable_supplier_commission"
                      :disabled="btnValue == 1"
                    >
                      Enable Supplier Commission
                    </base-checkbox>

                    <base-input
                      class="ml-3"
                      v-if="is_enable_supplier_commission == true"
                      label="Supplier Commission"
                    >
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.supplier_commission"
                        :disabled="btnValue == 1"
                        addonAfter="%"
                      />
                    </base-input>
                  </div>
                  <div v-else class="col-md-8">
                    <p>Set commission earned from this product</p>
                    <base-checkbox
                      class="mb-3"
                      v-model="is_enable_sales_commission"
                      :disabled="btnValue == 1"
                    >
                      Enable Salesman Commission
                    </base-checkbox>

                    <base-input
                      class="ml-3"
                      v-if="is_enable_sales_commission == true"
                      label="Salesman Commission"
                    >
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.salesman_commission"
                        addonAfter="%"
                        :disabled="btnValue == 1"
                      />
                    </base-input>

                    <base-checkbox
                      class="mb-3"
                      v-model="is_enable_supplier_commission"
                      :disabled="btnValue == 1"
                    >
                      Enable Supplier Commission
                    </base-checkbox>

                    <base-input
                      class="ml-3"
                      v-if="is_enable_supplier_commission == true"
                      label="Supplier Commission"
                    >
                      <a-input
                        type="number"
                        min="0"
                        v-model="product.supplier_commission"
                        :disabled="btnValue == 1"
                        addonAfter="%"
                      />
                    </base-input>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '11'"
                class="card-body"
              >
                <h2 class="card-title">Shelf Code</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Add a shelf code to this product</p>
                    <base-input
                      placeholder="Enter Shelf Code"
                      label="Shelf Code"
                      v-model="product.shelf_code"
                      :disabled="btnValue == 1"
                    />

                    <base-input label="Add a shelf code">
                      <select
                        size="large"
                        class="form-control"
                        v-model="shelf_code_mode"
                        :disabled="btnValue == 1"
                      >
                        <option
                          v-for="option in shelfCodeOptions"
                          v-bind:value="option.key"
                          v-bind:key="option.key"
                        >
                          {{ option.value }}
                        </option>
                      </select>
                    </base-input>

                    <div v-if="shelf_code_mode == '2'">
                      <base-input label="Select Site">
                        <a-select
                          v-model="site_products.site_id"
                          showSearch
                          placeholder="Enter Site"
                          optionFilterProp="children"
                          style="width: 100%"
                          :filterOption="filterOption"
                          :disabled="btnValue == 1"
                        >
                          <a-select-option
                            v-for="option in siteOptions"
                            :key="option.id"
                            :value="option.id"
                            >{{ option.name }}</a-select-option
                          >
                        </a-select>
                      </base-input>

                      <button
                        v-if="tableErrors.length"
                        type="button"
                        class="btn btn-sm btn-primary float-right"
                        style="margin-bottom: 10px"
                        :disabled="btnValue == 1"
                      >
                        Add
                      </button>
                      <button
                        v-else
                        type="button"
                        class="btn btn-sm btn-primary float-right"
                        style="margin-bottom: 10px"
                        @click.prevent="shelfHandleAdd"
                        :disabled="btnValue == 1"
                      >
                        Add
                      </button>
                      <br /><br />
                      <a-table
                        :columns="shelfColumns"
                        :dataSource="shelfData"
                        :pagination="false"
                        :scroll="{ y: 400 }"
                      >
                        <template
                          v-for="col in ['shelf_code']"
                          :slot="col"
                          slot-scope="text, record"
                        >
                          <div :key="col">
                            <a-input
                              v-if="record.editable"
                              style="margin: -5px 0"
                              :value="text"
                              @change="
                                (e) =>
                                  shelfHandleChangeTable(
                                    e.target.value,
                                    record.key,
                                    col
                                  )
                              "
                            />
                            <template v-else>{{ text }}</template>
                          </div>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                          <div class="editable-row-operations">
                            <span v-if="record.editable">
                              <a
                                class="btn btn-success btn-sm"
                                style="color: #fff"
                                @click="() => shelfSave(record.key)"
                                :disabled="btnValue == 1"
                                >Save</a
                              >
                              <a-popconfirm
                                title="Sure to cancel?"
                                @confirm="() => shelfCancel(record.key)"
                              >
                                <a
                                  class="btn btn-warning btn-sm"
                                  :disabled="btnValue == 1"
                                  style="color: #fff"
                                  >Cancel</a
                                >
                              </a-popconfirm>
                            </span>

                            <a-dropdown v-else>
                              <a class="ant-dropdown-link">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay" :disabled="btnValue == 1">
                                <a-menu-item key="1">
                                  <a @click="() => shelfEdit(record.key)"
                                    >Edit</a
                                  >
                                </a-menu-item>
                                <a-menu-item key="2" v-if="shelfData.length">
                                  <a-popconfirm
                                    title="Sure to delete?"
                                    @confirm="() => shelfOnDelete(record.key)"
                                  >
                                    <a href="javascript:;">Delete</a>
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                          </div>
                        </template>
                      </a-table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '2' && advanceKey == '12'"
                class="card-body"
              >
                <h2 class="card-title">Dimension</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>
                      Add product dimension for computation of warehouse capacity
                    </p>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Length *</label>
                          <a-input
                            v-model="product.length"
                            :disabled="btnValue == 1"
                            min="0"
                            type="number"
                            input-classes="form-control"
                            @change="limit"
                            name="length"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Width *</label>
                          <a-input
                            v-model="product.width"
                            :disabled="btnValue == 1"
                            min="0"
                            type="number"
                            input-classes="form-control"
                            @change="limit"
                            name="width"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Height *</label>
                          <a-input
                            v-model="product.height"
                            :disabled="btnValue == 1"
                            min="0"
                            type="number"
                            input-classes="form-control"
                            @change="limit"
                            name="height"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Volume</label>
                          <a-input
                            v-model="product.volume"
                            min="0"
                            type="number"
                            input-classes="form-control"
                            @change="limit"
                            name="volume"
                            :disabled="btnValue == 1"
                          />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Weight *</label>
                          <a-input
                            v-model="product.weight"
                            min="0"
                            type="number"
                            input-classes="form-control"
                            @change="limit"
                            name="weight"
                            :disabled="btnValue == 1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="activeKey == '3' && userKey == '1' && customFormMode == 3"
                class="card-body"
              >
                <h2 class="card-title">User Defined Fields</h2>
                <dynamic-form
                  :convertedJson="{
                    mode: customForm.mode,
                    groups: customForm.groups_append,
                  }"
                  :formSettings="product"
                  @valueUpdated="updateSettings"
                  :key="dynamicFormKey"
                  :showErrors="false"
                />
              </div>

              <div v-if="activeKey == '3' && userKey == 'boxme' && customFormMode == 3" class="card-body">
                <h2 class="card-title">Boxme Integration Settings</h2>
                <pre class="bg-light p-2 rounded" style="max-height: 600px; overflow: auto;"> {{ JSON.stringify({ integration_settings: product.integration_settings }, null, 2) }} </pre>
              </div>

              <br /><br /><br />
              <!-- <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;"> -->

              <div
                v-if="serverType == 'ho'"
                class="w-100 row d-flex justify-content-between px-2"
                style="position: absolute; bottom: 20px; right: 15px"
              >
                <div>
                  <button type="button" class="btn btn-primary" @click="handleBackButton" v-if="hideBackBtn">Back</button>
                  <button type="button" class="btn btn-primary" @click="handleNextButton" v-if="hideNextBtn" >Next</button>
                </div>
                <!-- <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;padding: 10px;"> -->
                <div>
                  <button
                    v-if="profileId == 0"
                    type="button"
                    class="btn btn-primary float-right"
                    @click.prevent="showModal('create')"
                  >
                    Create
                  </button>
                  <button
                    v-else-if="profileId != 0 && btnValue != 1"
                    type="button"
                    class="btn btn-primary float-right"
                    @click.prevent="showModal('update')"
                  >
                    Update
                  </button>
                </div>
              </div>
              <div
                v-else
                style="
                  position: absolute;
                  bottom: 0px;
                  right: 0px;
                  width: -webkit-fill-available;
                  padding: 10px;
                "
              >
                <button
                  type="button"
                  class="btn btn-primary float-right"
                  @click.prevent="$emit('closeDrawer', null)"
                >
                  Close
                </button>
              </div>

              <a-modal title="Warning" v-model="modalVisible" @ok="handleOk">
                <p>You have the following warning(s):</p>
                <ul>
                  <li v-for="warning in warnings" v-bind:key="warning">
                    {{ warning }}
                  </li>
                </ul>
              </a-modal>
            </form>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage.js";
import ValidateField from "../../components/validateFormUtils.js";
import SitePriceForm from "../../views/Products/SitePriceForm";
import MatrixForm from "../../views/Products/MatrixForm";
import ComboProductForm from "../../views/Products/ComboProductForm";
import DynamicForm from "../DynamicForm.vue";
import { mapState } from "vuex";
import moment from "moment";
import Autocomplete from "vuejs-auto-complete";
import axios from "axios";
import ForeignSupplierForm from "../Product Profiles V2/ForeignSupplierForm.vue";

const columns = [
  {
    title: "SUPPLIER",
    dataIndex: "supplier_name",
    width: "25%",
    scopedSlots: {
      customRender: "supplier_name",
    },
  },
  {
    title: "CODE",
    dataIndex: "supplier_code",
    width: "15%",
    scopedSlots: {
      customRender: "supplier_code",
    },
  },
  {
    title: "ORDERING COST",
    dataIndex: "ordering_cost",
    width: "40%",
    scopedSlots: {
      customRender: "ordering_cost",
    },
  },
  {
    title: "",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const barcodeColumns = [
  {
    title: "COMPANY CODE",
    dataIndex: "company_code",
    width: 140,
  },
  {
    title: "PRIMER SKU",
    dataIndex: "stock_no",
    width: 140,
  },
  {
    title: "MALL CODE / UPC / ROBITEM",
    dataIndex: "barcode",
    width: 220,
    scopedSlots: {
      customRender: "barcode",
    },
  },
  {
    title: "MALL GROUP",
    dataIndex: "mall_group_id",
    width: 180,
    scopedSlots: {
      customRender: "mall_group_id",
    },
  },
  // {
  //  title: "MALL GROUP CODE",
  //  dataIndex: "mall_group_code",
  //  width: 160,
  // },
  {
    title: "VENDOR ID / SUPPLIER CODE",
    dataIndex: "supplier_code",
    width: 220,
    scopedSlots: {
      customRender: "supplier_code",
    },
  },
  {
    title: "BRAND",
    dataIndex: "brand_code",
    width: 150,
  },
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    width: 280,
    scopedSlots: {
      customRender: "description",
    },
  },
  {
    title: "ITEM PRICE",
    dataIndex: "item_price",
    width: 130,
  },
  {
    title: "PEL",
    dataIndex: "pel",
    width: 120,
    scopedSlots: {
      customRender: "pel",
    },
  },
  {
    title: "DEPT",
    dataIndex: "dept",
    width: 120,
    scopedSlots: {
      customRender: "dept",
    },
  },
  {
    title: "SUB DEPT",
    dataIndex: "sub_dept",
    width: 130,
    scopedSlots: {
      customRender: "sub_dept",
    },
  },
  {
    title: "CLASS",
    dataIndex: "class_code",
    width: 120,
    scopedSlots: {
      customRender: "class_code",
    },
  },
  {
    title: "SUB CLASS",
    dataIndex: "sub_class",
    width: 130,
    scopedSlots: {
      customRender: "sub_class",
    },
  },
  {
    title: "VENDPART",
    dataIndex: "vendpart",
    width: 140,
    scopedSlots: {
      customRender: "vendpart",
    },
  },
  {
    title: "QTY",
    dataIndex: "quantity",
    width: 100,
    scopedSlots: {
      customRender: "quantity",
    },
  },
  {
    title: "ACTIVE",
    dataIndex: "status",
    width: 100,
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "ACTION",
    dataIndex: "operation",
    width: 150,
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const shelfColumns = [
  {
    title: "SITE",
    dataIndex: "site_name",
    width: "25%",
    scopedSlots: {
      customRender: "site_name",
    },
  },
  {
    title: "SHELF CODE",
    dataIndex: "shelf_code",
    width: "40%",
    scopedSlots: {
      customRender: "shelf_code",
    },
  },
  {
    title: "",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const reorderColumns = [
  {
    title: "SITE",
    dataIndex: "site_name",
    width: "25%",
    scopedSlots: {
      customRender: "site_name",
    },
  },
  {
    title: "MINIMUM QUANTITY",
    dataIndex: "min_quantity",
    width: "25%",
    scopedSlots: {
      customRender: "min_quantity",
    },
  },
  {
    title: "MAXIMUM QUANTITY",
    dataIndex: "max_quantity",
    width: "25%",
    scopedSlots: {
      customRender: "max_quantity",
    },
  },
  {
    title: "",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const priceColumns = [
  {
    title: "SITE",
    dataIndex: "site_name",
    width: "20%",
    scopedSlots: {
      customRender: "site_name",
    },
  },
  {
    title: "RETAIL PRICE",
    dataIndex: "retail_price",
    width: "15%",
    scopedSlots: {
      customRender: "retail_price",
    },
  },
  {
    title: "WHOLESALE PRICE",
    dataIndex: "wholesale_price",
    width: "15%",
    scopedSlots: {
      customRender: "wholesale_price",
    },
  },
  {
    title: "LEAST PRICE",
    dataIndex: "least_price",
    width: "15%",
    scopedSlots: {
      customRender: "least_price",
    },
  },
  {
    title: "SPECIAL PRICE",
    dataIndex: "special_price",
    width: "15%",
    scopedSlots: {
      customRender: "special_price",
    },
  },
  {
    title: "LANDED COST",
    dataIndex: "landed_cost",
    width: "15%",
    scopedSlots: {
      customRender: "landed_cost",
    },
  },
  {
    title: "ORDERING COST",
    dataIndex: "ordering_cost",
    width: "15%",
    scopedSlots: {
      customRender: "ordering_cost",
    },
  },
  {
    title: "",
    width: "5%",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const kitColumns = [
  {
    title: "QTY",
    dataIndex: "quantity",
    width: "10%",
    scopedSlots: {
      customRender: "quantity",
    },
  },
  {
    title: "BARCODE",
    dataIndex: "barcode",
    width: "10%",
    scopedSlots: {
      customRender: "barcode",
    },
  },
  {
    title: "SHORT NAME",
    dataIndex: "short_name",
    width: "20%",
    scopedSlots: {
      customRender: "short_name",
    },
  },
  {
    title: "PRODUCT TYPE",
    dataIndex: "product_type",
    width: "10%",
    scopedSlots: {
      customRender: "product_type",
    },
  },
  {
    title: "UNIT",
    dataIndex: "unit_code",
    width: "10%",
    scopedSlots: {
      customRender: "unit_code",
    },
  },
  {
    title: "COST",
    dataIndex: "cost",
    width: "10%",
    scopedSlots: {
      customRender: "cost",
    },
  },
  {
    title: "PRICE",
    dataIndex: "retail_price",
    width: "10%",
    scopedSlots: {
      customRender: "retail_price",
    },
  },
  {
    title: "",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

const productColumns = [
  {
    title: "SITE",
    dataIndex: "site_name",
    scopedSlots: {
      customRender: "site_name",
    },
  },
];

// product series columns
const productseriesColumns = [
  {
    title: "Series Name",
    dataIndex: "series_name",
    scopedSlots: {
      customRender: "series_name",
    },
  },
  {
    title: "Series Date",
    dataIndex: "series_date",
    scopedSlots: {
      customRender: "series_date",
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    scopedSlots: {
      customRender: "status",
    },
  }
];
// end product series columns

const productGradeColumns = [
  {
    title: "Level",
    dataIndex: "level",
    scopedSlots: {
      customRender: "level",
    },
  },
  {
    title: "Effectivity Date",
    dataIndex: "effectivity_date",
    scopedSlots: {
      customRender: "effectivity_date",
    },
  },
];


// base product columns for package product
const baseProductColumns = [
  {
    title: "Base Product Name",
    dataIndex: "product_name"
  },
  {
    title: "Base Product Barcode",
    dataIndex: "barcode"
  },
  {
    title: "Base Product Stock No",
    dataIndex: "stock_no"
  },
]

const packagesColumns = [
  {
    title: 'Barcode',
      dataIndex: 'barcode',
      scopedSlots: {
        dataIndex: 'barcode'
      }
  },
  {
    title: 'Content Quantity',
      dataIndex: 'content_quantity',
    scopedSlots: {
      dataIndex: 'content_quantity'
    }
  },
  {
    title: 'Unit',
      dataIndex: 'unit',
    scopedSlots: {
      dataIndex: 'unit'
    }
  },
  {
    title: 'Cost',
      dataIndex: 'cost',
    scopedSlots: {
      dataIndex: 'cost'
    }
  },
  {
    title: 'Ordering Cost',
      dataIndex: 'ordering_cost',
    scopedSlots: {
      dataIndex: 'ordering_cost'
    }
  },
  {
    title: 'Landed Cost',
      dataIndex: 'landed_cost',
    scopedSlots: {
      dataIndex: 'landed_cost'
    }
  },
  {
    title: 'Retail Price',
      dataIndex: 'retail_price',
    scopedSlots: {
      dataIndex: 'retail_price'
    }
  },
  {
    title: "Is Ordering",
    key: "checkbox",
    scopedSlots: { customRender: "isOrderingUnit" }
  },
  // bryan
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "saveIsOrderingUnit" }
  }
]

const data = [];
const barcodeData = [];
const shelfData = [];
const reorderData = [];
const priceData = [];
const productData = []; // site products
const kitData = [];
const productseriesData = []; // product series array
const productGradeData = []; // product group array
const baseProductData = []; // base product array

export default {
  components: {
    SitePriceForm,
    MatrixForm,
    ComboProductForm,
    Autocomplete,
    DynamicForm,
  },
  computed: {

    ...mapState([
      "endPoint",
      "serverType",
      "profileId",
      "publicUrl",
      "categoriesOptions",
    ]),
     hideBackBtn(){
      if(this.activeKey == '1'){
        if(this.basicKey !== '1'){
          return true;
        }else{
          return false;
        }
      }else{
        if(this.productType == '' || this.productType == 'K' || this.productType == 'N'){
          if(this.advanceKey !== '1'){
          return true;
          }else{
            return false;
          }
        }else{
          if(this.advanceKey !== '2'){
          return true;
          }else{
            return false;
          }
        }
      }
    },
    hideNextBtn(){
      if(this.product.product_type == 'I' && this.basicKey == '2'){
        return false;
      }
      if(this.activeKey == '1'){
        if(this.basicKey !== '5'){
          return true;
        }else{
          return false;
        }
      }else{
        if(this.advanceKey !== '12'){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  mounted: async function () {
    var component_x = this;
    component_x.spinning = true;

    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Products?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );

      var response = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/stock_card_access_rights?system_module_id=123", null);

      if (_.isEmpty(response.access_rights) == false) {
        let mergedAccessRights = [];
        // iterate over the keys of access_rights to find user_group_ids
        for (let userGroupId in response.access_rights) {
          // checking if user_group_id exists in the response
          if (response.access_rights.hasOwnProperty(userGroupId)) {
            try {
              let userGroupAccessRights = response.access_rights[userGroupId][0].split(',');
              mergedAccessRights = mergedAccessRights.concat(userGroupAccessRights);
            } catch (error) {
              
            }
            
          }
        }
        this.accessCostRights = [...new Set(mergedAccessRights)]; // remove duplicates rights
      } else {
        this.accessCostRights = [];
      }
      
    // Get mall groups
    var mallGroupOptions = await HTTPRequest.getRequest(this.endPoint + 'mall_groups?per_page=500' , null)
    this.mallGroupOptions = mallGroupOptions['data']
    
    // bryan
    // await HTTPRequest.getRequest(this.endPoint + `settings/accountSettings?field_name=code&account_id=${account_id}` , null)
    var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
    var _creds = JSON.parse(credentials.value)
    this.sitePricingEnabled = _creds.sitePricingEnabled
    this.isSiteProductEnabled = (_creds.productPriority != null && _creds.productPriority!=undefined) ? (_creds.productPriority == "SBrand") ? false : true : true

    this.$watch(vm => [vm.product.max_quantity, vm.product.min_quantity], val => {
      this.checkMinMaxMsg = ""
      if(val[0] && val[1]){
        var max = Number(val[0])
        var min = Number(val[1])
        if(max < min && min !=0 && max == max && min == min){
          this.checkMinMax = false;
          this.checkMinMaxMsg = "Minimum Quantity should not be greater than Maximum Quantity";
        } else if (max == min && max != 0 && min !=0) {
          this.checkMinMax = false
          this.checkMinMaxMsg = "Minimum Quantity should not be equal to Maximum Quantity";
        } else if (max == 0 || min ==0 || max != max || min != min) {
          this.checkMinMax = null
        } else {
          this.checkMinMax = null
        }
      }
    }, {
      immediate: true, // run immediately
      deep: true // detects changes inside objects
    })

    this.$watch(vm => [vm.reorderData, vm.persiteKey], val => {
      this.perSiteMinMaxMsg = ""
      if(val[0]){
        var key = val[1]
        var data = val[0]
        if(key < 1){
          key = 0
        }else{
          key = key
        }
        var dataOnKey = data[key]
        if(dataOnKey){
          var max = Number(dataOnKey.max_quantity)
          var min = Number(dataOnKey.min_quantity)
          if(max < min ){
            this.perSiteCheckMinMax = false;
            this.perSiteMinMaxMsg = "Minimum Quantity should not be greater than Maximum Quantity";
          } else if (max == min && max != 0 && min !=0) {
            this.perSiteCheckMinMax = false
            this.perSiteMinMaxMsg = "Minimum Quantity should not be equal to Maximum Quantity";
          } else if (max == 0 || min ==0) {
            this.perSiteCheckMinMax = null
          } else {
            this.perSiteCheckMinMax = null
        }
        }
      }
    }, {
      immediate: true, // run immediately
      deep: true // detects changes inside objects
    })

    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        this.userDefinedFields = accSystemModule.customized_fields;
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }

        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
      const requiredCodes = this.customForm.groups_append ? this.customForm.groups_append.flatMap(group => {
        return group.terminalSettings.filter(setting => setting.required).map(setting => ({ code: setting.code, label: setting.label }))
      }) : [];

      this.requiredCustomFields = requiredCodes

    }

    if (this.serverType == "branch") {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }

    if (
      this.productType == "P" ||
      this.productType == "M" ||
      this.productType == "V" ||
      this.productType == "S"
    ) {
      this.advanceKey = "3";
      this.advanceSelectedKey = ["3"];
    }

    var userId = secureStorage.getItem("userId");
    let siteId = secureStorage.getItem("defaultSiteId");
    var response;

    response = await HTTPRequest.getRequest(
      this.endPoint + "/user_settings?module_name=kit&user_id=" + userId,
      null
    );
    var kitSettings;
    if (response.data[0] != undefined) {
      kitSettings = JSON.parse(response.data[0].settings_json);
      component_x.recompute_cost = kitSettings.recompute_kit_cost;
      component_x.recompute_price = kitSettings.recompute_kit_price;
    } else {
      kitSettings = {};
    }

    response = await HTTPRequest.getRequest(
      this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
      null
    );
    var userSettings;
    if (response.data[0] != undefined) {
      userSettings = JSON.parse(response.data[0].settings_json);
    } else {
      userSettings = {};
    }

    response = await HTTPRequest.getRequest(
      this.endPoint + "/system_settings?module_name=px",
      null
    );
    var systemSettings;
    if (response.data[0] != undefined) {
      systemSettings = JSON.parse(response.data[0].settings_json);
    } else {
      systemSettings = {};
    }

    if(systemSettings && systemSettings["enable_auto_barcode_and_stock_no"] != null){
      this.enableAutoBarcodeAndStock = systemSettings["enable_auto_barcode_and_stock_no"]
    }

    var mergedHash = Object.assign({}, systemSettings, userSettings);
    component_x.formSettings = mergedHash;

    var units = await HTTPRequest.getRequest(
      component_x.endPoint + "units/get_valid_units",
      null
    );
    component_x.unitOptions = units;
    component_x.sort(component_x.unitOptions);

    var properties = await HTTPRequest.getRequest(
      component_x.endPoint + "properties/get_valid_properties",
      null
    );
    component_x.propertyOptions = properties;
    component_x.sort(component_x.propertyOptions);

    var brands = await HTTPRequest.getRequest(
      component_x.endPoint + "brands/get_valid_brands",
      null
    );
    if (brands.length > 100) {
      component_x.brandOptions = [];
    } else {
      component_x.brandOptions = brands;
      component_x.sort(component_x.brandOptions);
    }

    var suppliers = await HTTPRequest.getRequest(
      component_x.endPoint + "suppliers/get_valid_suppliers",
      null
    );
    component_x.supplierOptions = suppliers;
    component_x.sort(component_x.supplierOptions);

    var foreign_suppliers = await HTTPRequest.getRequest(
      component_x.endPoint + "foreign_suppliers/get_valid_foreign_suppliers",
      null
    );
    component_x.foreignSupplierOptions = foreign_suppliers;
    component_x.sort(component_x.foreignSupplierOptions);

    var product_lines = await HTTPRequest.getRequest(
      component_x.endPoint + "product_lines/get_valid_tags",
      null
    );
    component_x.productLineOptions = product_lines;
    component_x.sort(component_x.productLineOptions);

    var colors = await HTTPRequest.getRequest(
      component_x.endPoint + "colors/get_valid_colors",
      null
    );
    component_x.colorOptions = colors;
    component_x.sort(component_x.colorOptions);

    var sites = await HTTPRequest.getRequest(
      component_x.endPoint + "sites/get_valid_sites?mode=all",
      null
    );
    component_x.siteOptions = sites;
    component_x.sort(component_x.siteOptions);

    component_x.categoryOptions = component_x.categoriesOptions;
    component_x.alternateBarcodeCategoryOptions = await HTTPRequest.getRequest(
      component_x.endPoint + "categories/cascader_view_2",
      null
    );

    //set default settings
    if (component_x.formSettings.default_vat_rate != undefined) {
      component_x.default_vat_rate = component_x.formSettings.default_vat_rate;
    }
    if (component_x.formSettings.markup_computation != undefined) {
      component_x.markup_computation =
        component_x.formSettings.markup_computation;
    }
    if (component_x.formSettings.markup_roundup != undefined) {
      component_x.markup_roundup = component_x.formSettings.markup_roundup;
    }
    if (component_x.formSettings.short_name_length != undefined) {
      component_x.short_name_length =
        component_x.formSettings.short_name_length;
    }
    if (
      component_x.formSettings.enable_auto_compute_price_on_markup != undefined
    ) {
      component_x.enable_auto_compute_price_on_markup =
        component_x.formSettings.enable_auto_compute_price_on_markup;
    }
    if (component_x.formSettings.default_markup != undefined) {
      component_x.default_markup = component_x.formSettings.default_markup;
      // if (component_x.enable_auto_compute_price_on_markup == true){
      component_x.product.markup_percent = component_x.default_markup;
      // }
    }
    if (component_x.formSettings.disable_blank_division != undefined) {
      component_x.disable_blank_division =
        component_x.formSettings.disable_blank_division;
    }
    if (component_x.formSettings.disable_blank_department != undefined) {
      component_x.disable_blank_department =
        component_x.formSettings.disable_blank_department;
    }
    if (component_x.formSettings.disable_blank_section != undefined) {
      component_x.disable_blank_section =
        component_x.formSettings.disable_blank_section;
    }
    if(component_x.formSettings.disable_width_and_length_validation!=undefined){
      component_x.disable_width_and_length_validation =
        component_x.formSettings.disable_width_and_length_validation;
    }
    if (component_x.formSettings.disable_blank_category != undefined) {
      component_x.disable_blank_category =
        component_x.formSettings.disable_blank_category;
    }
    if (component_x.formSettings.disable_blank_product_line != undefined) {
      component_x.disable_blank_product_line =
        component_x.formSettings.disable_blank_product_line;
    }
    if (component_x.formSettings.disable_blank_supplier != undefined) {
      component_x.disable_blank_supplier =
        component_x.formSettings.disable_blank_supplier;
    }
    if (component_x.formSettings.disable_blank_brand != undefined) {
      component_x.disable_blank_brand =
        component_x.formSettings.disable_blank_brand;
    }
    if (component_x.formSettings.disable_blank_wholesale_price != undefined) {
      component_x.disable_blank_wholesale_price =
        component_x.formSettings.disable_blank_wholesale_price;
    }
    if (component_x.formSettings.disable_blank_least_price != undefined) {
      component_x.disable_blank_least_price =
        component_x.formSettings.disable_blank_least_price;
    }
    if (component_x.formSettings.disable_blank_special_price != undefined) {
      component_x.disable_blank_special_price =
        component_x.formSettings.disable_blank_special_price;
    }
    if (component_x.formSettings.disable_blank_price4 != undefined) {
      component_x.disable_blank_price4 =
        component_x.formSettings.disable_blank_price4;
    }
    if (component_x.formSettings.disable_blank_price5 != undefined) {
      component_x.disable_blank_price5 =
        component_x.formSettings.disable_blank_price5;
    }
    if (component_x.formSettings.disable_blank_refcode != undefined) {
      component_x.disable_blank_refcode =
        component_x.formSettings.disable_blank_refcode;

      if (component_x.disable_blank_refcode == false) {
        if (component_x.formSettings.lock_refcode != undefined) {
          component_x.lock_refcode = component_x.formSettings.lock_refcode;
        }
      }
    }

    if (component_x.formSettings.enable_multiple_price != undefined) {
      component_x.enable_multiple_price =
        component_x.formSettings.enable_multiple_price;
      if (component_x.enable_multiple_price == true) {
        component_x.costing_mode = "2";
      } else {
        component_x.costing_mode = "1";
      }
    }

    if (component_x.formSettings.package_name_format != undefined) {
      component_x.package_name_format =
        component_x.formSettings.package_name_format;
    }

    if (component_x.formSettings.package_name_format_base != undefined) {
      component_x.package_name_format_base =
        component_x.formSettings.package_name_format_base;
    }

    if (
      component_x.formSettings.change_price_cost_package_on_regular_update !=
      undefined
    ) {
      component_x.change_price_cost_package_on_regular_update =
        component_x.formSettings.change_price_cost_package_on_regular_update;
    }
    if (component_x.formSettings.cost_decimal_places != undefined) {
      if (component_x.formSettings.cost_decimal_places == "1") {
        component_x.cost_decimal_places = 2;
      } else {
        component_x.cost_decimal_places = 4;
      }
    }

    if (component_x.formSettings.warn_at_zero_cost_px != undefined) {
      component_x.warn_at_zero_cost_px =
        component_x.formSettings.warn_at_zero_cost_px;
    }

    if (component_x.formSettings.warn_at_zero_price_px != undefined) {
      component_x.warn_at_zero_price_px =
        component_x.formSettings.warn_at_zero_price_px;
    }

    if (component_x.formSettings.warn_at_price_below_cost_px != undefined) {
      component_x.warn_at_price_below_cost_px =
        component_x.formSettings.warn_at_price_below_cost_px;
    }

    if (component_x.formSettings.warn_at_kit_cost_change != undefined) {
      component_x.warn_at_kit_cost_change =
        component_x.formSettings.warn_at_kit_cost_change;
    }

    if (component_x.formSettings.warn_at_kit_price_change != undefined) {
      component_x.warn_at_kit_price_change =
        component_x.formSettings.warn_at_kit_price_change;
    }

    if (component_x.formSettings.warn_at_package_cost_change != undefined) {
      component_x.warn_at_package_cost_change =
        component_x.formSettings.warn_at_package_cost_change;
    }

    if (component_x.formSettings.warn_at_package_price_change != undefined) {
      component_x.warn_at_package_price_change =
        component_x.formSettings.warn_at_package_price_change;
    }

    component_x.data = [];
    component_x.barcodeData = [];
    component_x.productseriesData = []; //product series
    component_x.productGradeData = []; //product group
    component_x.kitData = [];
    component_x.shelfData = [];
    component_x.reorderData = [];
    component_x.priceData = [];
    component_x.productData = []; // site products
    component_x.productData.children = []; // site products
    component_x.selectedRowKeys = []; // site products

    var apiData = await HTTPRequest.getRequest(
      component_x.endPoint + "sites/get_valid_tree_sites?no_ho_site=true",
      null
    );

    let treeSites = function (data, root) {
    var r = [], o = {};
    data.forEach(function (a) {
      if (o[a.key] && o[a.key].children) {
          a.children = o[a.key] && o[a.key].children;
      }
      o[a.key] = a;
      if (a.parent_id === root) {
        r.push(a);
      } else {
          o[a.parent_id] = o[a.parent_id] || {};
          o[a.parent_id].children = o[a.parent_id].children || [];
          o[a.parent_id].children.push(a);
      }
    });
      return r;
    }(apiData, null);

    treeSites.forEach((el) => {
      component_x.productData.push({
        id: el.id,
        key: el.key,
        title: el.title,
        children: el.children
      });
    });


    const RemoveKeyandRenametoID = (object, deleteKey) => {
      // if object
      // delete object[deleteKey];
        if(object != null){
          if(object["key"] != null){
            if(!object["key"].includes("L",0)){
              object["key"] = parseInt(object["key"]);
            }
          }
          delete object["id"];

          Object.values(object).forEach((val) => {
            if (typeof val !== 'object') return;
            RemoveKeyandRenametoID(val, deleteKey);
            })
        }
      }


    RemoveKeyandRenametoID(component_x.productData, 'key');

    // sort so that unspecified first
    this.productData.sort((a, b) =>
      a.title < b.title ? -1 : Number(a.title > b.title)
    );

    // console.log(this.productData)
    // end location tagging convert children and parent || tree data for site products

    component_x.selectedRowKeys.push(siteId);
    component_x.cleanSiteIds.push(siteId);

    if (component_x.profileId > 0) {
      var product_data = await HTTPRequest.getRequest(
        component_x.endPoint + "products/" + component_x.profileId,
        null
      );
      if (product_data == undefined) {
        component_x.$router.go();
      } else {
        if (product_data["error"] == undefined) {
          if (product_data.product_type == "") {
            component_x.prev_original_cost = product_data.original_cost;
            component_x.prev_ordering_cost = product_data.ordering_cost;
            component_x.prev_landed_cost = product_data.landed_cost;
            component_x.prev_retail_price = product_data.retail_price;
            component_x.prev_wholesale_price = product_data.wholesale_price;
            component_x.prev_least_price = product_data.least_price;
            component_x.prev_special_price = product_data.special_price;
            component_x.prev_price4 = product_data.price4;
            component_x.prev_price5 = product_data.price5;
          }

          let credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
          if(credentials != null){
            try {
              let accountCredentials = JSON.parse(credentials.value)
              component_x.costing_method = accountCredentials.documentCostingMethod
            } catch (error) {
              // do nothing
            }
          }

          // Start
          // [Easyday Plus] Wrong data under Assign Brand in Products
          // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1764

          var brands = await HTTPRequest.getRequest(
            component_x.endPoint + "brands/get_valid_brands?id=" + product_data.brand_id,
            null
          );
          component_x.brandOptions = brands;
          component_x.sort(component_x.brandOptions);

          // [Easyday Plus] Wrong data under Assign Brand in Products
          // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1764
          // End

          component_x.product = product_data;
          component_x.product_properties = {
            property_id: [],
          };

          let e = { target: { name: "percent_wholesale" } };
          component_x.computeMarkup(e);
          e = { target: { name: "percent_least" } };
          component_x.computeMarkup(e);
          e = { target: { name: "percent_special" } };
          component_x.computeMarkup(e);
          e = { target: { name: "percent_price4" } };
          component_x.computeMarkup(e);
          e = { target: { name: "percent_price5" } };
          component_x.computeMarkup(e);

          //jng 01-10-2020
          if(component_x.profileId != 0){
            component_x.tax_type = product_data.tax_type;
          }else{
            component_x.tax_type = 'V';
          }

          component_x.product.sc_discount_percent =
            Number(product_data.sc_discount_percent) * 100;
          component_x.product.pnstm_discount_percent =
            Number(product_data.pnstm_discount_percent) * 100;
          component_x.product.pwd_discount_percent =
            Number(product_data.pwd_discount_percent) * 100;
          component_x.product.sp_discount_percent_discount_percent =
            Number(product_data.sp_discount_percent) * 100;

          var product_properties_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "product_properties?product_id=" +
              component_x.profileId,
            null
          );
          product_properties_data.data.forEach((element) => {
            component_x.product_properties.property_id.push(
              element.property_id
            );
          });

          component_x.data = [];
          var supplier_products_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "supplier_products?product_id=" +
              component_x.profileId,
            null
          );
          if (supplier_products_data.total) {
            supplier_products_data.data.forEach((element) => {
              component_x.data.push({
                key: component_x.count,
                supplier_id: element.supplier_id,
                supplier_name: component_x.supplierOptions.find(
                  (x) => x.id === element.supplier_id
                ).name,
                supplier_code: component_x.supplierOptions.find(
                  (x) => x.id === element.supplier_id
                ).code,
                ordering_cost: element.ordering_cost,
                status: element.status,
              });

              component_x.count = component_x.count + 1;
            });
            component_x.product.is_alternate_supplier = true;
          }

          var fs_products_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "foreign_supplier_products?product_id=" +
              component_x.profileId,
            null
          );

          if (fs_products_data.length > 0) {
            this.foreign_supplier_products.foreign_supplier_id = fs_products_data[0].foreign_supplier_id;
          }

          component_x.barcodeData = [];
          var product_barcodes_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "product_barcodes?product_id=" +
              component_x.profileId,
            null
          );
          if (product_barcodes_data.total) {
            product_barcodes_data.data.forEach((element) => {
              component_x.barcodeData.push({
                key: component_x.barcodeCount,
                company_code: product_data.company_code,
                stock_no: product_data.stock_no,
                barcode: element.barcode,
                // mall_group_code: this.alternateBarcodeMallCode(element.mall_group_id),
                supplier_code: product_data.supplier_code,
                brand_code: product_data.brand_code,
                description: element.description || "",
                item_price: product_data.retail_price,
                dept: element.dept_code == null ? product_data.division_code : element.dept_code,
                sub_dept: element.sub_dept_code == null ? product_data.department_code : element.sub_dept_code,
                class_code: element.class_code == null ? product_data.section_code : element.class_code,
                sub_class: element.sub_class_code == null ? product_data.category_code : element.sub_class_code,
                mall_group_id: element.mall_group_id,
                pel: element.pel,
                vendpart: element.vendpart,
                quantity: this.formatAlternateBarcodeQuantity(element.quantity),
                status: element.status,
              });

              component_x.barcodeCount = component_x.barcodeCount + 1;
            });
          }

          // product series mounted
          var productseries_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "product_series?product_id=" +
              component_x.profileId,
            null
          );
          if (productseries_data.total) {
            productseries_data.data.forEach((element) => {
              component_x.productseriesData.push({
                key: component_x.productseriesCount,
                series_name: element.series_name,
                series_date: moment(element.series_date).format(
                  "MMMM DD, YYYY"
                ),
                status: element.status
              });

              component_x.productseriesCount =
                component_x.productseriesCount + 1;
            });
          }
          // end product series mounted

          // product group mounted
          var product_grade_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "product_grades?product_id=" +
              component_x.profileId,
            null
          );

          if (product_grade_data.total) {
            product_grade_data.data.forEach((element) => {
              component_x.productGradeData.push({
                key: component_x.productGradeCount,
                effectivity_date: moment(element.effectivity_date).format(
                  "MMMM DD, YYYY"
                ),
                level: element.level,
              });

              component_x.productGradeCount = component_x.productGradeCount + 1;
            });
          }
          // end product group mounted

          component_x.shelfData = [];
          component_x.reorderData = [];
          component_x.selectedRowKeys = [];
          component_x.cleanSiteIds = [];
          component_x.priceData = [];

          var total_count_data = await HTTPRequest.getRequest(
            component_x.endPoint +
              "site_products?product_id=" +
              component_x.profileId +
              "&per_page=1",
            null
          );
          var total_count =
            total_count_data.total == 0 ? 1 : total_count_data.total;
          var site_products_data;
          if (total_count > 0) {
            site_products_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "site_products?product_id=" +
                component_x.profileId +
                "&per_page=" +
                total_count,
              null
            );
          } else {
            site_products_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "site_products?product_id=" +
                component_x.profileId,
              null
            );
          }

          if (site_products_data.total) {
            site_products_data.data.forEach((element) => {
              if (element.shelf_code != null) {
                component_x.shelfData.push({
                  key: component_x.shelfCount,
                  site_id: element.site_id,
                  site_name: component_x.siteOptions.find(
                    (x) => x.id === element.site_id
                  ).name,
                  shelf_code: element.shelf_code,
                });

                component_x.shelfCount = component_x.shelfCount + 1;
              }

              if (
                element.min_quantity == null &&
                element.max_quantity == null
              ) {
                //do nothing
              } else {
                component_x.reorderData.push({
                  key: component_x.reorderCount,
                  site_id: element.site_id,
                  site_name: component_x.siteOptions.find(
                    (x) => x.id === element.site_id
                  ).name,
                  min_quantity: element.min_quantity,
                  max_quantity: element.max_quantity,
                });

                component_x.reorderCount = component_x.reorderCount + 1;
              }

              if (element.retail_price == null) {
                //do nothing
              } else {
                if (
                  component_x.siteOptions.find(
                    (x) => x.id === element.site_id
                  ) != undefined
                ) {
                  component_x.priceData.push({
                    key: element.site_id,
                    site_id: element.site_id,
                    site_name: component_x.siteOptions.find(
                      (x) => x.id === element.site_id
                    ).name,
                    supplier_id: element.supplier_id,
                    original_cost: element.original_cost,
                    ordering_cost: element.ordering_cost,
                    landed_cost: element.landed_cost,
                    markup_percent: element.markup_percent,
                    retail_price: element.retail_price,
                    wholesale_price: element.wholesale_price,
                    least_price: element.least_price,
                    special_price: element.special_price,
                  });
                }
              }

              if (element.status == "A") {
                component_x.selectedRowKeys.push(element.site_id);
                component_x.cleanSiteIds.push(element.site_id);
              }
            });
          }

          if (component_x.shelfData.length > 0) {
            component_x.shelf_code_mode = "2";
          } else {
            component_x.shelf_code_mode = "1";
          }

          if (component_x.reorderData.length > 0) {
            component_x.reorder_mode = "2";
          } else {
            component_x.reorder_mode = "1";
          }

          component_x.is_site_price = component_x.sitePricingEnabled;
            
          const newData = [...component_x.data];
          component_x.cacheData = newData.map((item) => ({ ...item }));

          const newBarcodeData = [...component_x.barcodeData];
          component_x.barcodeCacheData = newBarcodeData.map((item) => ({
            ...item,
          }));

          const newShelfData = [...component_x.shelfData];
          component_x.shelfCacheData = newShelfData.map((item) => ({
            ...item,
          }));

          const newReorderData = [...component_x.reorderData];
          component_x.reorderCacheData = newReorderData.map((item) => ({
            ...item,
          }));

          const newPriceData = [...component_x.priceData];
          component_x.priceCacheData = newPriceData.map((item) => ({
            ...item,
          }));

          const newProductData = [...component_x.productData];
          component_x.productCacheData = newProductData.map((item) => ({
            ...item,
          }));

          // Unsave Data
          // Formula: x = Landed Cost, y = Landed Cost w/o VAT, z = VAT Rate
          // landed_cost_no_vat = x / ( 1 + ( z / 100) )
          if (product_data.landed_cost > 0) {
            component_x.product.landed_cost_no_vat =
              product_data.landed_cost /
              (1 + component_x.default_vat_rate / 100);
          } else {
            component_x.product.landed_cost_no_vat = 0;
          }
          var landed_cost_no_vat = Number(
            component_x.product.landed_cost_no_vat
          );
          component_x.product.landed_cost_no_vat = landed_cost_no_vat.toFixed(
            component_x.cost_decimal_places
          );

          if (product_data.intro_date == null) {
            component_x.product.intro_date = null;
          } else {
            component_x.product.intro_date = moment(product_data.intro_date);
          }

          if (product_data.reference_date == null) {
            component_x.product.reference_date = null;
          } else {
            component_x.product.reference_date = moment(
              product_data.reference_date
            );
          }

          component_x.fileList = product_data["images_url"] || []

          component_x.imageLoaded = true;

          if (component_x.categoryOptions.length > 0) {
            let parent_cat = component_x.categoryOptions[0].value;
            if (
              product_data.category_id != 0 &&
              product_data.category_id != null
            ) {
              component_x.cascader_category = [
                parent_cat,
                product_data.division_id,
                product_data.department_id,
                product_data.section_id,
                product_data.category_id,
              ];
            } else if (
              product_data.section_id != 0 &&
              product_data.section_id != null
            ) {
              component_x.cascader_category = [
                parent_cat,
                product_data.division_id,
                product_data.department_id,
                product_data.section_id,
              ];
            } else if (
              product_data.department_id != 0 &&
              product_data.department_id != null
            ) {
              component_x.cascader_category = [
                parent_cat,
                product_data.division_id,
                product_data.department_id,
              ];
            } else if (
              product_data.division_id != 0 &&
              product_data.division_id != null
            ) {
              component_x.cascader_category = [
                parent_cat,
                product_data.division_id,
              ];
            }
          }

          if (product_data.salesman_commission > 0) {
            component_x.is_enable_sales_commission = true;
          }

          if (product_data.supplier_commission > 0) {
            component_x.is_enable_supplier_commission = true;
          }

          if (
            product_data.retail_price == 0 ||
            product_data.wholesale_price == 0 ||
            product_data.least_price == 0 ||
            product_data.special_price == 0 ||
            product_data.price4 == 0 ||
            product_data.price5 == 0
          ) {
            component_x.allow_zero = true;
          }

          component_x.kitData = [];
          var product_compositions_data = [];
          if (product_data.product_type == "") {
            product_compositions_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "product_compositions?regular_product_id=" +
                component_x.profileId,
              null
            );
             this.packages = await HTTPRequest.getRequest(
              component_x.endPoint +
                "product_compositions/get_packages?regular_product_id=" +
                component_x.profileId,
              null
            );

            if(this.packages.length > 0){
              let orderingUnit = this.packages.filter(({is_ordering_unit}) => is_ordering_unit === 1)
              if(orderingUnit.length !== 0){
                this.selectedOrderingUnitId = orderingUnit[0].id
              }
            }
            if (product_compositions_data.total > 0) {
              component_x.has_package = true;
            }
          } else if (
            product_data.product_type == "K" ||
            product_data.product_type == "V"
          ) {
            product_compositions_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "product_compositions?package_product_id=" +
                component_x.profileId,
              null
            );
            if (product_compositions_data.total > 0) {
              product_compositions_data.data.forEach((element) => {
                component_x.kitData.push({
                  key: component_x.kitCount,
                  regular_product_id: element.regular_product_id,
                  quantity: element.quantity,
                  barcode: element.product_detail.barcode,
                  short_name: element.product_detail.short_name,
                  stock_no: element.product_detail.stock_no,
                  product_type: element.product_detail.product_type,
                  original_cost: element.product_detail.original_cost,
                  ordering_cost: element.product_detail.ordering_cost,
                  cost: element.product_detail.landed_cost,
                  retail_price: element.product_detail.retail_price,
                  wholesale_price: element.product_detail.wholesale_price,
                  least_price: element.product_detail.least_price,
                  special_price: element.product_detail.special_price,
                  price4: element.product_detail.price4,
                  price5: element.product_detail.price5,
                  status: element.status,
                });
                component_x.kitCount = component_x.kitCount + 1;
              });
            }
          } else if (product_data.product_type == "P") {
            product_compositions_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "product_compositions?package_product_id=" +
                component_x.profileId,
              null
            );
            // set data for base product table in package product
            this.baseProductData =[{
                key: 1,
                product_name: product_compositions_data.data[0].product_detail.name,
                barcode: product_compositions_data.data[0].product_detail.barcode,
                stock_no:product_compositions_data.data[0].product_detail.stock_no,
            }]

            if (product_compositions_data.total > 0) {
              component_x.regular_product_id =
                product_compositions_data.data[0].regular_product_id;
              component_x.base_product_name =
                product_compositions_data.data[0].product_detail.name;
              component_x.tmp_original_cost =
                product_compositions_data.data[0].product_detail.original_cost;
              component_x.tmp_ordering_cost =
                product_compositions_data.data[0].product_detail.ordering_cost;
              component_x.tmp_landed_cost =
                product_compositions_data.data[0].product_detail.landed_cost;
              component_x.tmp_retail_price =
                product_compositions_data.data[0].product_detail.retail_price;
              component_x.tmp_original_price =
                product_compositions_data.data[0].product_detail.original_price;
              component_x.tmp_wholesale_price =
                product_compositions_data.data[0].product_detail.wholesale_price;
              component_x.tmp_least_price =
                product_compositions_data.data[0].product_detail.least_price;
              component_x.tmp_special_price =
                product_compositions_data.data[0].product_detail.special_price;
              component_x.tmp_price4 =
                product_compositions_data.data[0].product_detail.price4;
              component_x.tmp_price5 =
                product_compositions_data.data[0].product_detail.price5;
            }
          } else if (product_data.product_type == "M") {
            product_compositions_data = await HTTPRequest.getRequest(
              component_x.endPoint +
                "products?matrix_item=1&matrix_parent_id=" +
                component_x.profileId,
              null
            );
            if (product_compositions_data.total > 0) {
              component_x.has_matrix_item = true;
            }
          }

          const newKitData = [...component_x.kitData];
          component_x.kitCacheData = newKitData.map((item) => ({ ...item }));
        } else {
          component_x.errors = product_data["error"].split(",");
        }
      }
    }
    component_x.getSubBrandData(); // get sub brand for brands
    component_x.getProductGroupData(); // get product group option
    component_x.product.include_product_group_to_children = true;
    console.log(component_x.data)
    this.disablePriceCost = (this.profileId > 0) ? true : false;
    component_x.spinning = false;
    if (secureStorage.getItem("accountId") == 10 || secureStorage.getItem("accountId") == 11){
      this.short_name_length = 50
    }
  },
  props: ["productType"],
  data() {

    this.cacheData = data.map((item) => ({ ...item }));
    this.barcodeCacheData = barcodeData.map((item) => ({ ...item }));
    this.shelfCacheData = shelfData.map((item) => ({ ...item }));
    this.reorderCacheData = reorderData.map((item) => ({ ...item }));
    this.priceCacheData = priceData.map((item) => ({ ...item }));
    this.productCacheData = productData.map((item) => ({ ...item }));
    this.kitCacheData = kitData.map((item) => ({ ...item }));
    return {
      isSiteProductEnabled:false,
      mallGroupOptions: [],
      disablePriceCost: false,
      sitePricingEnabled: false,
      data,
      columns,
      barcodeData,
      barcodeColumns,
      shelfData,
      shelfColumns,
      reorderData,
      reorderColumns,
      priceData,
      priceColumns,
      productData,
      productColumns,
      kitData,
      kitColumns,
      baseProductData,
      baseProductColumns,
      matrixData: [],
      basicSelectedKeys:[], // array for selectedKeys in a-menu basic
      advanceSelectedKeys:[], // array for selectedKeys in a-menu advanced

      customFormMode: 1,
      customForm: {},
      userForm: {},
      dynamicFormKey: 0,
      userDefinedFields: [],

      count: 1,
      barcodeCount: 1,
      shelfCount: 1,
      reorderCount: 1,
      priceCount: 1,
      kitCount: 1,

      fetching: false,
      spinning: false,
      formSettings: { isAdmin: false },
      searchFilter: "name",

      updateKey: 0,
      activeKey: ["1"],
      advanceSelectedKey: ["1"],
      basicKey: "1",
      advanceKey: "1",
      userKey: "1",
      accordion: true,
      unitOptions: [],
      productLineOptions: [],
      colorOptions: [],
      is_enable_sales_commission: false,
      is_enable_supplier_commission: false,
      is_quantity_change: false,

      alternate_supplier_id: null,
      showAdvancedInfo: false,
      selectedRowKeys: [],
      targetData: [],
      targetKey: 0,
      tax_type: "V",

      perSiteCheckMinMax: null,
      perSiteMinMaxMsg: "",
      checkMinMax: null,
      checkMinMaxMsg: "",
      persiteKey: 0,

      modalPackageQuantity: false,
      selectProduct: false, // selected a product on autocomplete

      product: {
        tax_type: "V",
        status: "A",
        landed_cost: "0",
        landed_cost_no_vat: 0,
        original_cost: "",
        ordering_cost: "0",
        last_discount_text: "",
        original_price: "0",
        retail_price: "",
        special_price: "",
        least_price: "",
        wholesale_price: "",
        markup_percent: "0",
        piml_price1: "",
        piml_price2: "",
        piml_price3: "",
        price4: "",
        price5: "",
        sc_discount_percent: "",
        pnstm_discount_percent: "",
        pwd_discount_percent: "",
        is_inventory: true,
        salesman_commission: 0,
        supplier_commission: 0,
        product_type: this.productType,
        content_quantity: 1,
        is_non_trade: false,
        is_non_saleable: false,
        sub_brand_id: null,
        include_product_group_to_children: true,
        include_product_grade_to_children: false,
        stock_no: "Auto",
        max_percent_discount: "",
        max_amount_discount: "",
        is_senior_vatex: false,
        is_senior_nolimit: false,
        is_pnstm_vatex: false,
        is_pnstm_nolimit: false,
        blended_cost: 0,
      },

      formattedRetailPrice: "",
      formattedOriginalPrice: "",
      formattedWholesalePrice: "",
      formattedLeastPrice: "",
      formattedSpecialPrice: "",
      formattedPimlPrice1: "",
      formattedPimlPrice2: "",
      formattedPimlPrice3: "",
      formattedPrice4: "",
      formattedPrice5: "",
      formattedMarkupPercent: "",
      formattedOriginalCost: "",
      formattedOrderingCost: "",
      formattedLandedCost: "",
      formattedBlendedCost: "",
      formattedStandbyLandedCost: "",

      costing_method: 'FIFO',

      //  product series data
      productSeriesOptions: [
        {key: "new", name: "New"},
        {key: "repeat", name: "Repeat"},
        {key: "repeat_1", name: "Repeat 1"},
        {key: "repeat_2", name: "Repeat 2"},
        {key: "repeat_3", name: "Repeat 3"},
        {key: "repeat_4", name: "Repeat 4"},
        {key: "repeat_5", name: "Repeat 5"},
        {key: "repeat_6", name: "Repeat 6"},
        {key: "repeat_7", name: "Repeat 7"},
        {key: "repeat_8", name: "Repeat 8"},
        {key: "repeat_9", name: "Repeat 9"},
        {key: "repeat_10", name: "Repeat 10"},
      ],
      productseriesKey: "",
      productseriesButton: "add", //change button to add and delete
      productseriesCount: 1, // temporary key
      productseriesData, // array item to push objects
      productseriesColumns, // table columns
      product_series: {
        key: null,
        series_name: "",
        series_date: null,
        status: "",
      },
      // end product series data
      // product group data
      productGradeCount: 1,
      productGradeData,
      productGradeColumns,
      productLevelCount: 0,

      product_grade: {
        key: null,
        level: 0,
        effectivity_date: null,
        status: "A",
      },
      // end product group data

      // packages columns
      loading: false,
      packages: [],
      packagesColumns,
      selectedOrderingUnitId: null,
      selectedOrderingUnit:{},
      is_saved:false,
      is_updating:false,

      subbrandOptions: [], // sub brand data
      productGroupOptions: [], // product group data

      markup_wholesale_price: "",
      markup_special_price: "",
      markup_least_price: "",
      markup_price4: "",
      markup_price5: "",

      allow_zero: false,

      costing_mode: "1",
      shelf_code_mode: "1",
      reorder_mode: "1",
      product_properties: {},
      site_products: {},
      is_site_price: false,
      regular_product_id: 0,
      base_product_name: "", //view for package product base.

      regular_name: 0,
      regular_short_name: 0,

      costingOptions: [
        { key: "1", value: "Basic (Default)" },
        { key: "2", value: "Advanced" },
      ],

      shelfCodeOptions: [
        { key: "1", value: "For all sites" },
        { key: "2", value: "For multiple sites" },
      ],

      reorderOptions: [
        { key: "1", value: "For all sites" },
        { key: "2", value: "For multiple sites" },
      ],

      statusOptions: [
        { key: "A", value: "Active" },
        { key: "I", value: "Inactive" },
      ],

      cascader_category: [],
      categoryOptions: [],
      alternateBarcodeCategoryOptions: [],
      brandOptions: [],
      supplierOptions: [],
      propertyOptions: [],
      dateFormat: "YYYY-MM-DD",
      authHeaders: {
        Authorization: "Bearer " + secureStorage.getItem("accessToken"),
        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
      },
      errors: [],
      warnings: [],
      tableErrors: [],

      previewVisible: false,
      previewImage: "",
      fileList: [],
      fileListTemp: [],
      imageLoaded: true,

      componentKey: 0,
      visible: false,
      priceId: 0,

      tmp_original_cost: 0,
      tmp_ordering_cost: 0,
      tmp_landed_cost: 0,
      tmp_retail_price: 0,
      tmp_original_price: 0,
      tmp_wholesale_price: 0,
      tmp_least_price: 0,
      tmp_special_price: 0,
      tmp_price4: 0,
      tmp_price5: 0,

      prev_original_cost: 0,
      prev_ordering_cost: 0,
      prev_landed_cost: 0,
      prev_retail_price: 0,
      prev_wholesale_price: 0,
      prev_least_price: 0,
      prev_special_price: 0,
      prev_price4: 0,
      prev_price5: 0,

      has_package: false,
      has_matrix_item: false,
      modalVisible: false,

      recompute_cost: false,
      recompute_price: false,

      //set value
      default_vat_rate: 12,
      markup_computation: "2",
      short_name_length: "250",
      enable_auto_compute_price_on_markup: false,
      default_markup: "0",
      markup_roundup: ".05",
      cost_decimal_places: 4,
      change_price_cost_package_on_regular_update: false,
      package_name_format_base: false,
      package_name_format: "1",
      lock_refcode: false,
      enable_multiple_price: false,
      warn_at_zero_cost_px: false,
      warn_at_zero_price_px: false,
      warn_at_price_below_cost_px: false,
      warn_at_kit_cost_change: false,
      warn_at_kit_price_change: false,
      warn_at_package_cost_change: false,
      warn_at_package_price_change: false,
      disable_blank_division: false,
      disable_blank_department: false,
      disable_blank_section: false,
      disable_blank_category: false,
      disable_blank_product_line: false,
      disable_blank_supplier: false,
      disable_blank_brand: false,
      disable_blank_wholesale_price: false,
      disable_blank_least_price: false,
      disable_blank_special_price: false,
      disable_blank_price4: false,
      disable_blank_price5: false,
      disable_blank_refcode: false,
      btnValue: 0,
      combo_detail: {},
      comboDetailFetch: {},
      cleanSiteIds: [],
      disable_width_and_length_validation:false,

      // modal dialogue for site_price
      sitePriceModalVisible: false,
      // FS Products
      foreign_supplier_products: {
        foreign_supplier_id: null,
        product_id:null 
      },
      requiredCustomFields: [],
      enableAutoBarcodeAndStock: false,
      accessCostRights: [],
    };
  },
  watch: {
    // set format values in item viewing (costs and prices)
    'product.retail_price'(newVal) {
      this.formattedRetailPrice = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.original_price'(newVal) {
      this.formattedOriginalPrice = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.wholesale_price'(newVal) {
      this.formattedWholesalePrice = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.least_price'(newVal) {
      this.formattedLeastPrice = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.special_price'(newVal) {
      this.formattedSpecialPrice = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.piml_price1'(newVal) {
      this.formattedPimlPrice1 = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.piml_price2'(newVal) {
      this.formattedPimlPrice2 = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.piml_price3'(newVal) {
      this.formattedPimlPrice3 = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.price4'(newVal) {
      this.formattedPrice4 = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.price5'(newVal) {
      this.formattedPrice5 = (this.addMaskValidation(newVal, 'Y') == '***') ? '***' : this.formatNumber(newVal, 2);
    },
    'product.markup_percent'(newVal) {
      this.formattedMarkupPercent = this.formatNumber(newVal, 2);
    },
    'product.original_cost'(newVal) {
      this.formattedOriginalCost = (this.addMaskValidation(newVal, 'Z') == '***') ? '***' : this.formatNumber(this.fixedCostDecimal(newVal), this.cost_decimal_places);
    },
    'product.ordering_cost'(newVal) {
      this.formattedOrderingCost = (this.addMaskValidation(newVal, 'Z') == '***') ? '***' : this.formatNumber(this.fixedCostDecimal(newVal), this.cost_decimal_places);
    },
    'product.landed_cost'(newVal) {
      this.formattedLandedCost = (this.addMaskValidation(newVal, 'Z') == '***') ? '***' : this.formatNumber(this.fixedCostDecimal(newVal), this.cost_decimal_places);
    },
    'product.blended_cost'(newVal) {
      this.formattedBlendedCost = (this.addMaskValidation(newVal, 'Z') == '***') ? '***' : this.formatNumber(this.fixedCostDecimal(newVal), this.cost_decimal_places);
    },
    'product.standby_landed_cost'(newVal) {
      this.formattedStandbyLandedCost = (this.addMaskValidation(newVal, 'Z') == '***') ? '***' : this.formatNumber(this.fixedCostDecimal(newVal), this.cost_decimal_places);
    },
    tax_type: function () {
      this.computeLandedCostNoTax();
    },
    recompute_cost: function () {
      this.computeCostAction();
    },
    recompute_price: function () {
      this.computePriceAction();
    },
    is_site_price: function(){
      if(!this.is_site_price){
        this.sitePriceModalVisible = true;
      }
    }
  },
  methods: {
    // formatting method for inputting values on prices fields
    formatValue(field) {
      let value;
      switch (field) {
        case 'retail_price':
          value = parseFloat(this.formattedRetailPrice.replace(/,/g, ''));
          this.product.retail_price = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedRetailPrice = this.formatNumber(this.product.retail_price, 2);
          break;
        case 'original_price':
          value = parseFloat(this.formattedOriginalPrice.replace(/,/g, ''));
          this.product.original_price = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedOriginalPrice = this.formatNumber(this.product.original_price, 2);
          break;
        case 'wholesale_price':
          value = parseFloat(this.formattedWholesalePrice.replace(/,/g, ''));
          this.product.wholesale_price = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedWholesalePrice = this.formatNumber(this.product.wholesale_price, 2);
          break;
        case 'least_price':
          value = parseFloat(this.formattedLeastPrice.replace(/,/g, ''));
          this.product.least_price = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedLeastPrice = this.formatNumber(this.product.least_price, 2);
          break;
        case 'special_price':
          value = parseFloat(this.formattedSpecialPrice.replace(/,/g, ''));
          this.product.special_price = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedSpecialPrice = this.formatNumber(this.product.special_price, 2);
          break;
        case 'piml_price1':
          value = parseFloat(this.formattedPimlPrice1.replace(/,/g, ''));
          this.product.piml_price1 = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedPimlPrice1 = this.formatNumber(this.product.piml_price1, 2);
          break;
        case 'piml_price2':
          value = parseFloat(this.formattedPimlPrice2.replace(/,/g, ''));
          this.product.piml_price2 = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedPimlPrice2 = this.formatNumber(this.product.piml_price2, 2);
          break;
        case 'piml_price3':
          value = parseFloat(this.formattedPimlPrice3.replace(/,/g, ''));
          this.product.piml_price3 = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedPimlPrice3 = this.formatNumber(this.product.piml_price3, 2);
          break;
        case 'price4':
          value = parseFloat(this.formattedPrice4.replace(/,/g, ''));
          this.product.price4 = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedPrice4 = this.formatNumber(this.product.price4, 2);
          break;
        case 'price5':
          value = parseFloat(this.formattedPrice5.replace(/,/g, ''));
          this.product.price5 = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedPrice5 = this.formatNumber(this.product.price5, 2);
          break;
        case 'markup_percent':
          value = parseFloat(this.formattedMarkupPercent.replace(/,/g, ''));
          this.product.markup_percent = !isNaN(value) ? value.toFixed(2) : '';
          this.formattedMarkupPercent = this.formatNumber(this.product.markup_percent, 2);
          break;
      }
    },
    formatNumber(value, decimalPlaces) {
      if (value === undefined || value === null || value === '') return "";
      // format number with localized thousand separator and decimal places
      return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
    },
    // parse formatted markup prices
    parseFormattedPrice(value) {
      const numericValue = parseFloat(
        String(value).replace(/,/g, '')
      );
      return isNaN(numericValue) ? 0 : numericValue; // handle NaN cases
    },
    onFocus(field) {
      if (this[field] !== '') {
        this[field] = this.parseFormattedPrice(this[field]);
      }
    },
    onBlur(field) {
      if (this[field] !== '') {
        this[field] = this.formatNumber(this.parseFormattedPrice(this[field]), 2);
      }
    },
    addMaskValidation(value, rights) {
      if (!this.accessCostRights.includes(rights)) {
        return '***';
      } else {
        return value;
      }
    },
    async setOrderingUnit(){
      // set is_ordering_unit of selected packaged product = true
      this.loading = true;
      let payload = {
          packaged_product_id: this.selectedOrderingUnitId,
          regular_product_id: this.profileId
        }
        await HTTPRequest.postRequest(
          this.endPoint + "products/update_packaged_product",
          null,
          payload
        );
        this.is_saved = true
        this.loading = false
    },
    updateIsOrderingUnit(record){
     let { id } = record
      if(this.selectedOrderingUnitId == null || this.selectedOrderingUnitId !== id){
        this.selectedOrderingUnitId = id
        this.selectedOrderingUnit = record
      }else{
        this.is_saved = false
        this.selectedOrderingUnitId = null
        this.selectedOrderingUnit = {}
      }
    },
    moment,
    // get sub brand data method
    async getSubBrandData() {
      if (this.product.brand_id != null) {
        var subbrand_data = await HTTPRequest.getRequest(
          this.endPoint +
            "sub_brands/get_valid_sub_brands?brand_id=" +
            this.product.brand_id,
          null
        );
        // console.log("sub_brand[index]:",subbrand_data);
        this.subbrandOptions = subbrand_data;
      }
    },

    closeModal(action){
      if (action == 'ok') {
        this.sitePriceModalVisible = false;
        this.$notification['info']({
          message: 'Notification',
          description: "Changes will take effect on update."
        });
      } else {
        this.sitePriceModalVisible = false;
        this.is_site_price = true;
      }
    },
    async clearSubBrand() {
      this.product.sub_brand_id = null;
    },

    scrollTop() {
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      this.spinning = false;
    },

    // will set a class: ant-menu-item-selected on menu item
    selectedBasicKey(key){
      if(this.basicSelectedKeys[0] == key){
        return 'ant-menu-item-selected'
      }
    },
    selectedAdvanceKey(key){
      if(this.advanceSelectedKeys[0] == key){
        return 'ant-menu-item-selected'
      }
    },
    // show the correct tab to display when Back/Next button is click
    handleBackButton(){
      let tempBasicKey = Number(this.basicKey);
      let tempAdvanceKey = Number(this.advanceKey);

      if (this.activeKey == '1'){
        if(tempBasicKey > 1){
          tempBasicKey -= 1;
          this.basicSelectedKeys  = [tempBasicKey]
          this.basicKey = tempBasicKey.toString();
        }
      } else if(this.activeKey == '2'){
        if(tempAdvanceKey > 1){
         tempAdvanceKey -= 1;
         this.advanceSelectedKeys = [tempAdvanceKey]
         this.advanceKey = tempAdvanceKey.toString();
        }
      }
    },

    handleNextButton(){
      let tempBasicKey = Number(this.basicKey);
      let tempAdvanceKey = Number(this.advanceKey);

      if (this.activeKey == '1'){
         if(tempBasicKey < 5){
          tempBasicKey += 1;
          this.basicSelectedKeys  = [tempBasicKey]
          this.basicKey = tempBasicKey.toString();
        }
      } else if(this.activeKey == '2'){
        if(tempAdvanceKey < 12){
         tempAdvanceKey += 1;
         this.advanceSelectedKeys  = [tempAdvanceKey]
         this.advanceKey = tempAdvanceKey.toString();
        }
      }
    },

    computeCostAction() {
      if (this.recompute_cost == true) {
        this.product.original_cost = 0;
        this.product.ordering_cost = 0;
        this.product.landed_cost = 0;

        this.kitData.forEach((element) => {
          var original_cost = this.computeKit(
            this.product.original_cost,
            element.original_cost,
            element.quantity
          );
          this.product.original_cost = original_cost;

          var ordering_cost = this.computeKit(
            this.product.ordering_cost,
            element.ordering_cost,
            element.quantity
          );
          this.product.ordering_cost = ordering_cost;

          var landed_cost = this.computeKit(
            this.product.landed_cost,
            element.cost,
            element.quantity
          );
          this.product.landed_cost = landed_cost;
        });
      }
    },
    computePriceAction() {
      if (this.recompute_price == true) {
        this.product.retail_price = 0;
        this.product.wholesale_price = 0;
        this.product.least_price = 0;
        this.product.special_price = 0;
        this.product.price4 = 0;
        this.product.price5 = 0;

        this.kitData.forEach((element) => {
          var retail_price = this.computeKit(
            this.product.retail_price,
            element.retail_price,
            element.quantity
          );
          this.product.retail_price = retail_price;

          var wholesale_price = this.computeKit(
            this.product.wholesale_price,
            element.wholesale_price,
            element.quantity
          );
          this.product.wholesale_price = wholesale_price;

          var least_price = this.computeKit(
            this.product.least_price,
            element.least_price,
            element.quantity
          );
          this.product.least_price = least_price;

          var special_price = this.computeKit(
            this.product.special_price,
            element.special_price,
            element.quantity
          );
          this.product.special_price = special_price;

          var price4 = this.computeKit(
            this.product.price4,
            element.price4,
            element.quantity
          );
          this.product.price4 = price4;

          var price5 = this.computeKit(
            this.product.price5,
            element.price5,
            element.quantity
          );
          this.product.price5 = price5;
        });
      }
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.product;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;

      if (this.userFormMode == 3) {
        this.errors = errors;
      }
// Get all keys from the extras object
      Object.keys(mergedHash.extras).forEach(key => {
        // Check if the key exists in the main object
        if (mergedHash.hasOwnProperty(key)) {
          // Set the value of the key in the main object to the value in extras
          mergedHash.extras[key] = mergedHash[key];
        }
      });

      this.product = mergedHash;
      // console.log(this.product)
    },
    computeKit(key, value, qty) {
      var x = key + value * qty;
      return x;
    },
    async handleSearch(value) {
      this.fetching = true;
      var brands = await HTTPRequest.getRequest(
        this.endPoint + "/brands/get_valid_brands?name=" + value,
        null,
        null
      );
      this.brandOptions = brands;
      this.fetching = false;
    },

    //alternate supplier table
    onDelete(key) {
      const dataSource = [...this.data];
      this.data = dataSource.filter((item) => item.key !== key);
    },
    validateForm() {
      if (this.tableErrors.length) {
        return this.tableErrors.length;
      } else {
        this.errors = [];
  
        if(this.selectedOrderingUnitId === null  && this.is_updating && this.packages.length > 0){
          this.errors.push('Is Ordering Column on Packages Tab cannot be empty!')
        }

        if(this.is_saved === false && this.is_updating && this.packages.length > 0){
          this.errors.push('Changes on Packages Tab has not yet been saved !')
        }
        this.errors.push(ValidateField.required("Name", this.product.name));
        this.errors.push( ValidateField.charMinAndMax("Name", this.product.name, 0, 255));
        this.errors.push(
          ValidateField.required("Short Name", this.product.short_name)
        );

        if(this.requiredCustomFields){
          this.requiredCustomFields.forEach(item => {
            let label = item.label ? item.label : ''
            this.errors.push(ValidateField.required(label, this.product[item.code]))
          })
        }

        this.errors.push(
          ValidateField.charMinAndMax(
            "Short Name",
            this.product.short_name,
            0,
            parseInt(this.short_name_length)
          )
        );

        if(Number(this.product.min_quantity) > Number(this.product.max_quantity)){
          var msg = "Minimum Quantity should not be greater than Maximum Quantity";
          this.errors.push(msg);
        }

        if(Number(this.product.min_quantity) == Number(this.product.max_quantity)
        && Number(this.product.min_quantity) != 0 && Number(this.product.max_quantity) != 0 )
        {
            this.errors.push("Minimum Quantity should not be equal to Maximum Quantity");
        }

        if(this.reorderData){
          for(let i = 0 ; i < this.reorderData.length; i++){
            var min = Number(this.reorderData[i].min_quantity)
            var max = Number(this.reorderData[i].max_quantity)
            var site_name = this.reorderData[i].site_name
            if(min > max ){
              this.errors.push("SITE:"+ " " +site_name+ " " +"Minimum Quantity should not be greater than Maximum Quantity")
            }else if(min == max && max != 0 && min != 0 ){
              this.errors.push("SITE:"+ " " +" "+site_name+ " " + "Minimum Quantity should not be equal to Maximum Quantity")
            } else if ( min == 0 && max == 0){
              this.errors.push("SITE:"+ " " +" "+site_name+ " " + "Both quantity is zero")
            }
          }
        }

        this.errors.push(
          ValidateField.required("Stock No.", this.product.stock_no)
        );
        this.errors.push(
            ValidateField.greaterThanZero(
              "Length",
              this.product.length
            )
          );
        this.errors.push(
          ValidateField.required("Width", this.product.width)
        );
        this.errors.push(
            ValidateField.greaterThanZero(
              "Width",
              this.product.width
            )
          );
        this.errors.push(
          ValidateField.required("Height", this.product.height)
        );
        this.errors.push(
            ValidateField.greaterThanZero(
              "Height",
              this.product.height
            )
         );
         this.errors.push(
          ValidateField.required("Weight", this.product.weight)
        );
        this.errors.push(
            ValidateField.greaterThanZero(
              "Weight",
              this.product.weight
            )
         );
        this.errors.push(
          ValidateField.required("Length", this.product.length)
        );
        this.errors.push(
          ValidateField.charMinAndMax("Stock No.", this.product.stock_no, 0, 30)
        );
        if(this.enableAutoBarcodeAndStock == false){
          // this.errors.push(ValidateField.required("Barcode", this.product.barcode))
        }
        // this.errors.push(ValidateField.required('Barcode', this.product.barcode));
        this.errors.push(
          ValidateField.charMinAndMax("Barcode", this.product.barcode, 0, 20)
        );
        this.errors.push(ValidateField.required("Unit", this.product.unit_id));
        if (this.productType == "P") {
          this.errors.push(
            ValidateField.required("Quantity", this.product.content_quantity)
          );
          this.errors.push(
            ValidateField.decimalFormat(
              "Quantity",
              this.product.content_quantity
            )
          );
          this.errors.push(
            ValidateField.greaterThanZero(
              "Quantity",
              this.product.content_quantity
            )
          );
        } else {
          if (this.disable_blank_supplier == true) {
            this.errors.push(
              ValidateField.required("Supplier", this.product.supplier_id)
            );
          }
          if (this.disable_blank_division == true) {
            this.errors.push(
              ValidateField.required("Division", this.product.division_id)
            );
          }
          if (this.disable_blank_department == true) {
            this.errors.push(
              ValidateField.required("Department", this.product.department_id)
            );
          }
          if (this.disable_blank_section == true) {
            this.errors.push(
              ValidateField.required("Section", this.product.section_id)
            );
          }
          if (this.disable_blank_category == true) {
            this.errors.push(
              ValidateField.required("Category", this.product.category_id)
            );
          }
          if (this.disable_blank_brand == true) {
            this.errors.push(
              ValidateField.required("Brand", this.product.brand_id)
            );
          }
          if (this.disable_blank_product_line == true) {
            this.errors.push(
              ValidateField.required(
                "Product Line",
                this.product.product_line_id
              )
            );
          }
        }

        if (this.disable_blank_refcode == true) {
          this.errors.push(
            ValidateField.required(
              "Reference Code",
              this.product.erp_code
            )
          );
        }

        this.errors.push(
          ValidateField.requiredButAllowZero(
            "Ordering Cost",
            this.product.ordering_cost
          )
        );
        this.errors.push(
          ValidateField.requiredButAllowZero(
            "Landed Cost",
            this.product.landed_cost
          )
        );
        this.errors.push(
          ValidateField.requiredButAllowZero(
            "Markup Percent",
            this.product.markup_percent
          )
        );

        if (this.allow_zero == true) {
          this.errors.push(
            ValidateField.requiredButAllowZero(
              "Retail Price",
              this.product.retail_price
            )
          );
        } else {
          if (this.product.retail_price == "") {
            this.errors.push(
              ValidateField.required("Retail Price", this.product.retail_price)
            );
          } else {
            this.errors.push(
              ValidateField.greaterThanZero(
                "Retail Price",
                this.product.retail_price
              )
            );
          }
        }

        if (this.product.ordering_cost == "") {
            this.errors.push(
              ValidateField.required("Ordering Cost", this.product.ordering_cost)
            );
          } else {
            this.errors.push(
              ValidateField.greaterThanZero(
                "Ordering Cost",
                this.product.ordering_cost
              )
            );
        }

        if (this.enable_multiple_price == true) {
          if (this.disable_blank_wholesale_price == true) {
            if (this.allow_zero == true) {
              this.errors.push(
                ValidateField.requiredButAllowZero(
                  "Wholesale Price",
                  this.product.wholesale_price
                )
              );
            } else {
              if (this.product.wholesale_price == "") {
                this.errors.push(
                  ValidateField.required(
                    "Wholesale Price",
                    this.product.wholesale_price
                  )
                );
              } else {
                this.errors.push(
                  ValidateField.greaterThanZero(
                    "Wholesale Price",
                    this.product.wholesale_price
                  )
                );
              }
            }
          }
          if (this.disable_blank_least_price == true) {
            if (this.allow_zero == true) {
              this.errors.push(
                ValidateField.requiredButAllowZero(
                  "Least Price",
                  this.product.least_price
                )
              );
            } else {
              if (this.product.least_price == "") {
                this.errors.push(
                  ValidateField.required(
                    "Least Price",
                    this.product.least_price
                  )
                );
              } else {
                this.errors.push(
                  ValidateField.greaterThanZero(
                    "Least Price",
                    this.product.least_price
                  )
                );
              }
            }
          }
          if (this.disable_blank_special_price == true) {
            if (this.allow_zero == true) {
              this.errors.push(
                ValidateField.requiredButAllowZero(
                  "Special Price",
                  this.product.special_price
                )
              );
            } else {
              if (this.product.special_price == "") {
                this.errors.push(
                  ValidateField.required(
                    "Special Price",
                    this.product.special_price
                  )
                );
              } else {
                this.errors.push(
                  ValidateField.greaterThanZero(
                    "Special Price",
                    this.product.special_price
                  )
                );
              }
            }
          }
          if (this.disable_blank_price4 == true) {
            if (this.allow_zero == true) {
              this.errors.push(
                ValidateField.requiredButAllowZero(
                  "Price4",
                  this.product.price4
                )
              );
            } else {
              if (this.product.price4 == "") {
                this.errors.push(
                  ValidateField.required("Price4", this.product.price4)
                );
              } else {
                this.errors.push(
                  ValidateField.greaterThanZero("Price4", this.product.price4)
                );
              }
            }
          }
          if (this.disable_blank_price5 == true) {
            if (this.allow_zero == true) {
              this.errors.push(
                ValidateField.requiredButAllowZero(
                  "Price5",
                  this.product.price5
                )
              );
            } else {
              if (this.product.price5 == "") {
                this.errors.push(
                  ValidateField.required("Price5", this.product.price5)
                );
              } else {
                this.errors.push(
                  ValidateField.greaterThanZero("Price5", this.product.price5)
                );
              }
            }
          }
        }

        if (this.productType == "M") {
          if (this.matrixData.length == 0) {
            this.errors.push(
              "There are no variants selected for this matrix item."
            );
          }
        } else if (this.productType == "V" || this.productType == "K") {
          if (this.kitData.length == 0) {
            let type = "";
            if (this.productType == "V") {
              type = "virtual ";
            }
            this.errors.push(
              `There are no components selected for this ${type}kit item.`
            );
          }
        }

        if(this.product.is_alternate_supplier === true){
          if(this.data.find((x) => x.supplier_id === this.product.supplier_id)){
            this.errors.push("Primary supplier cannot be Alternate Supplier")
          }
        }

        if(this.formSettings.disable_blank_product_group){
          if(this.product.product_group_id == null){
            this.errors.push("Product Group is required")
          }
        }

        if(this.formSettings.disable_blank_product_grade){
          if(this.productGradeData.length <= 0 ){
            this.errors.push("Product Grade is required")
          }
        }

        //Validation for Package Products: Regular product is required to avoid error in invoice processing
        if (this.productType == "P" && this.regular_product_id == 0) {
            this.errors.push("Regular product for Packing is required")
        }

        this.errors = this._.compact(this.errors);
        return this.errors.length;
      }
    },
    checkWarning() {
      this.warnings = [];
      if (
        (this.product.barcode == null || this.product.barcode == "" || this.product.barcode == undefined) && this.enableAutoBarcodeAndStock == true
      ) {
        this.warnings.push(
          "There is no barcode, Barter XI will generate auto barcode."
        );
      }

      if (this.warn_at_zero_cost_px == true) {
        if (
          this.product.original_cost == 0 ||
          this.product.original_cost == undefined
        ) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 1, "Original Cost")
          );
        }
      }

      if (this.enable_multiple_price == true) {
        if (this.warn_at_zero_price_px == true) {
          if (
            this.product.wholesale_price == 0 ||
            this.product.wholesale_price == undefined
          ) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 2, "Wholesale Price")
            );
          }

          if (
            this.product.least_price == 0 ||
            this.product.least_price == undefined
          ) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 2, "Least Price")
            );
          }

          if (
            this.product.special_price == 0 ||
            this.product.special_price == undefined
          ) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 2, "Special Price")
            );
          }

          if (this.product.price4 == 0 || this.product.price4 == undefined) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 2, "Price4")
            );
          }

          if (this.product.price5 == 0 || this.product.price5 == undefined) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 2, "Price5")
            );
          }
        }
      }

      if (this.warn_at_price_below_cost_px == true) {
        if (Number(this.product.retail_price) < Number(this.product.landed_cost)) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 3, "Retail Price")
          );
        }

        if (this.enable_multiple_price == true) {
          if (this.product.wholesale_price < this.product.landed_cost) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 3, "Wholesale Price")
            );
          }

          if (this.product.least_price < this.product.landed_cost) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 3, "Least Price")
            );
          }

          if (this.product.special_price < this.product.landed_cost) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 3, "Special Price")
            );
          }

          if (this.product.price4 < this.product.landed_cost) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 3, "Price4")
            );
          }

          if (this.product.price5 < this.product.landed_cost) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 3, "Price5")
            );
          }
        }
      }

      if (
        this.warn_at_package_cost_change == true &&
        this.product.product_type == "" &&
        this.profileId > 0
      ) {
        if (this.prev_original_cost != this.product.original_cost) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 4, "Original Cost")
          );
        }

        if (this.prev_ordering_cost != this.product.ordering_cost) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 4, "Ordering Cost")
          );
        }

        if (this.prev_landed_cost != this.product.landed_cost) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 4, "Landed Cost")
          );
        }
      }

      if (
        this.warn_at_package_price_change == true &&
        this.product.product_type == "" &&
        this.profileId > 0
      ) {
        if (this.prev_retail_price != this.product.retail_price) {
          this.warnings.push(
            this.openNotificationWithIcon("warn", 4, "Retail Price")
          );
        }

        if (this.enable_multiple_price == true) {
          if (this.prev_wholesale_price != this.product.wholesale_price) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 4, "Wholesale Price")
            );
          }

          if (this.prev_least_price != this.product.least_price) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 4, "Least Price")
            );
          }

          if (this.prev_special_price != this.product.special_price) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 4, "Special Price")
            );
          }

          if (this.prev_price4 != this.product.price4) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 4, "Price4")
            );
          }

          if (this.prev_price5 != this.product.price5) {
            this.warnings.push(
              this.openNotificationWithIcon("warn", 4, "Price5")
            );
          }
        }
      }
    },
    handleAdd() {
      const { count } = this;
      if (this.data.find((x) => x.supplier_id === this.alternate_supplier_id)) {
        alert("Supplier Already Exist");
      } else if (this.product.supplier_id === this.alternate_supplier_id) {
        alert("Primary Supplier cannot be Alternate Supplier ");
      } else {
        if (
          this.supplierOptions.find((x) => x.id === this.alternate_supplier_id)
        ) {
          this.data.push({
            key: count,
            supplier_id: this.alternate_supplier_id,
            supplier_name: this.supplierOptions.find(
              (x) => x.id === this.alternate_supplier_id
            ).name,
            supplier_code: this.supplierOptions.find(
              (x) => x.id === this.alternate_supplier_id
            ).code,
            ordering_cost: 0,
            status: "A",
          });

          this.edit(count);
          this.count = count + 1;
        } else {
          alert("Please select supplier");
        }
      }
    },
    constructName(field) {
      //  2 <unit> (<quantity>) <Based Product Name>
      //  3 <Based Product Name> <unit>
      //  4 <unit>: <Based Product Name>
      //  1 <Based Product Name> <unit> (<quantity>)
      if (this.package_name_format == "2") {
        if (field == "short_name") {
          this.product.short_name =
            this.product.unit_code +
            " (" +
            this.product.content_quantity +
            ") " +
            this.regular_short_name;
        } else {
          this.product.name =
            this.product.unit_code +
            " (" +
            this.product.content_quantity +
            ") " +
            this.regular_name;
        }
      } else if (this.package_name_format == "3") {
        if (field == "short_name") {
          this.product.short_name =
            this.regular_short_name + " " + this.product.unit_code;
        } else {
          this.product.name = this.regular_name + " " + this.product.unit_code;
        }
      } else if (this.package_name_format == "4") {
        if (field == "short_name") {
          this.product.short_name =
            this.product.unit_code + ": " + this.short_name;
        } else {
          this.product.name = this.product.unit_code + ": " + this.regular_name;
        }
      } else {
        if (field == "short_name") {
          this.product.short_name =
            this.regular_short_name +
            " " +
            this.product.unit_code +
            " " +
            this.product.content_quantity;
        } else {
          if( this.regular_name == "0" ){
            this.regular_name = this.base_product_name
          }
          this.product.name =
            this.regular_name +
            " " +
            this.product.unit_code +
            " " +
            this.product.content_quantity;
        }
      }
    },
    handleChangeTable(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        delete target.editable;
        this.data = newData;
        this.cacheData = newData.map((item) => ({ ...item }));
      }
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    //end alternate supplier table

    //kit table
    kitOnDelete(key) {
      const dataSource = [...this.kitData];
      this.kitData = dataSource.filter((item) => item.key !== key);

      this.computeCostAction();
      this.computePriceAction();
    },
    kitHandleChangeTable(value, key, column) {
      const newData = [...this.kitData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.kitData = newData;
      }
    },
    kitEdit(key) {
      const newData = [...this.kitData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.editable = true;
        this.kitData = newData;
      }
    },
    kitSave(key) {
      const newData = [...this.kitData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        this.tableErrors = [];
        if (target.quantity == "") {
          this.tableErrors.push("Please input quantity");
          this.tableErrors = this._.compact(this.tableErrors);
          return this.tableErrors.length;
        } else {
          delete target.editable;

          this.kitData = newData;
          this.kitCacheData = newData.map((item) => ({ ...item }));

          this.computeCostAction();
          this.computePriceAction();
        }
      }
    },
    kitCancel(key) {
      const newData = [...this.kitData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        if (target.kit_code == "") {
          const dataSource = [...this.kitData];
          this.kitData = dataSource.filter((item) => item.key !== key);
        } else {
          Object.assign(
            target,
            this.kitCacheData.filter((item) => key === item.key)[0]
          );
          delete target.editable;
          this.kitData = newData;
        }

        this.computeCostAction();
        this.computePriceAction();
      }
    },

    //barcodes
    barcodeOnDelete(key) {
      const dataSource = [...this.barcodeData];
      this.barcodeData = dataSource.filter((item) => item.key !== key);
    },
    barcodeHandleAdd() {
      const { barcodeCount } = this;
      this.barcodeData.push({
        key: barcodeCount,
        company_code: this.product.company_code,
        stock_no: this.product.stock_no,
        barcode: "",
        mall_group_code: "",
        supplier_code: this.product.supplier_code,
        brand_code: this.product.brand_code,
        description: "",
        item_price: this.product.retail_price,
        dept: "",
        sub_dept: "",
        class_code: "",
        sub_class: "",
        mall_group_id: "",
        pel: "",
        vendpart: "",
        quantity: "",
        status: "A",
      });

      this.barcodeEdit(barcodeCount);
      this.barcodeCount = barcodeCount + 1;
    },
    barcodeHandleChangeTable(value, key, column) {
      if (column == "status") {
        if (value == true) {
          value = "A";
        } else {
          value = "I";
        }
      }

      const newData = [...this.barcodeData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        if (column == "mall_group_id") {
          target.mall_group_code = this.alternateBarcodeMallCode(value);
          this.clearDisallowedAlternateBarcodeFields(target);
        }
        this.barcodeData = newData;
      }
    },
    alternateBarcodeMallKey(mallGroupId) {
      const mallGroup = this.mallGroupOptions.find(
        ({ id }) => parseInt(id) === parseInt(mallGroupId)
      );
      if (!mallGroup) return null;

      const values = [mallGroup.code, mallGroup.name]
        .filter(Boolean)
        .map((value) => value.toString().toLowerCase().replace(/[^a-z0-9]/g, ""));

      if (values.some((value) => value.includes("fashionrack"))) return "fashion_rack";
      if (values.some((value) => value.includes("robinsons") || value.includes("robinson"))) return "robinsons";
      if (values.some((value) => value.includes("rustans") || value.includes("rustan"))) return "rustans";
      if (values.some((value) => value.includes("landmark"))) return "landmark";
      if (values.some((value) => value.startsWith("sm"))) return "sm";

      return null;
    },
    allowedAlternateBarcodeFields(record) {
      const mallKey = this.alternateBarcodeMallKey(record.mall_group_id);
      const commonFields = ["barcode", "mall_group_id", "description", "quantity", "status"];
      const fieldsByMall = {
        fashion_rack: commonFields,
        robinsons: [...commonFields, "supplier_code", "pel", "sub_dept"],
        sm: [...commonFields, "supplier_code", "dept", "sub_dept", "class_code", "sub_class"],
        rustans: [...commonFields, "vendpart"],
        landmark: [...commonFields, "supplier_code", "sub_dept"],
      };

      return fieldsByMall[mallKey] || [
        ...commonFields,
        "pel",
        "supplier_code",
        "dept",
        "sub_dept",
        "class_code",
        "sub_class",
        "vendpart",
      ];
    },
    isAlternateBarcodeFieldAllowed(record, field) {
      return this.allowedAlternateBarcodeFields(record).includes(field);
    },
    isReadOnlyAlternateBarcodeField(field) {
      return ["supplier_code"].includes(field);
    },
    missingAlternateBarcodeFormatFields(record) {
      const mallKey = this.alternateBarcodeMallKey(record.mall_group_id);
      if (mallKey !== "sm") return [];

      return [
        ["dept", "DEPT"],
        ["sub_dept", "SUB DEPT"],
        ["class_code", "CLASS"],
        ["sub_class", "SUB CLASS"],
      ].reduce((missingFields, [field, label]) => {
        if (!record[field]) missingFields.push(label);
        return missingFields;
      }, []);
    },
    alternateBarcodeDescriptionLimit(mallKey) {
      if (["sm", "rustans", "fashion_rack"].includes(mallKey)) return 50;
      if (["landmark", "robinsons"].includes(mallKey)) return 18;
      return null;
    },
    invalidAlternateBarcodeTemplateFields(record) {
      if (record.status !== "A") return [];

      const invalidFields = [];
      const mallKey = this.alternateBarcodeMallKey(record.mall_group_id);
      const primerSku = (record.stock_no || "").toString();
      const barcode = (record.barcode || "").toString();
      const description = (record.description || "").toString();
      const descriptionLimit = this.alternateBarcodeDescriptionLimit(mallKey);

      if (!/^(\d{7}|\d{10})$/.test(primerSku)) {
        invalidFields.push("PRIMER SKU must be 10 digits or 7 digits only.");
      }

      if (mallKey === "sm" && !/^\d{12}$/.test(barcode)) {
        invalidFields.push("MALL CODE / UPC / ROBITEM must be 12 digits only for SM.");
      }

      if (descriptionLimit && description.length > descriptionLimit) {
        invalidFields.push("DESCRIPTION maximum character count for " + mallKey.replace("_", " ").toUpperCase() + " is " + descriptionLimit + ".");
      }

      return invalidFields;
    },
    notifyInvalidAlternateBarcodeTemplateFields(invalidFields) {
      this.$notification['error']({
        message: 'Warning',
        description: invalidFields.join(' ')
      });
    },
    firstInvalidAlternateBarcodeTemplateFields(dataSource = this.barcodeData) {
      for (let index = 0; index < dataSource.length; index++) {
        const invalidFields = this.invalidAlternateBarcodeTemplateFields(dataSource[index]);
        if (invalidFields.length) return invalidFields;
      }

      return [];
    },
    invalidAlternateBarcodeCategoryFields(record) {
      const categories = this.alternateBarcodeCategoryOptions.length
        ? this.alternateBarcodeCategoryOptions
        : this.categoryOptions;
      if (!this.hasAlternateBarcodeCategoryMetadata(categories)) return [];

      const categoryFields = [
        ["dept", "DEPT", 1],
        ["sub_dept", "SUB DEPT", 2],
        ["class_code", "CLASS", 3],
        ["sub_class", "SUB CLASS", 4],
      ];

      return categoryFields.reduce((invalidFields, [field, label, level]) => {
        if (!record[field]) return invalidFields;

        if (!this.findAlternateBarcodeCategory(record[field], level, categories)) {
          invalidFields.push(label);
        }

        return invalidFields;
      }, []);
    },
    findAlternateBarcodeCategory(code, level, categories = this.alternateBarcodeCategoryOptions) {
      const findCategory = (categoryList, depth = 0) => {
        const expectedCode = code.toString().toUpperCase();

        for (let index = 0; index < categoryList.length; index++) {
          const category = categoryList[index];
          const categoryCode = this.alternateBarcodeCategoryCode(category);
          const categoryLevel = this.alternateBarcodeCategoryLevel(category, depth);
          if (
            categoryCode &&
            categoryCode.toString().toUpperCase() == expectedCode &&
            categoryLevel == level
          ) return category;

          const children = category.children || [];
          const match = findCategory(children, depth + 1);
          if (match) return match;
        }

        return null;
      };

      return findCategory(categories || []);
    },
    hasActiveAlternateBarcodeForMallGroup(record, dataSource = this.barcodeCacheData) {
      if (record.status !== "A" || !record.mall_group_id) return false;

      return dataSource.some((barcode) =>
        barcode.key !== record.key &&
        barcode.mall_group_id &&
        barcode.mall_group_id.toString() === record.mall_group_id.toString() &&
        barcode.status === "A"
      );
    },
    hasDuplicateActiveAlternateBarcodeMallGroup(dataSource = this.barcodeData) {
      const activeMallGroupIds = {};

      return dataSource.some((barcode) => {
        if (barcode.status !== "A" || !barcode.mall_group_id) return false;

        const mallGroupId = barcode.mall_group_id.toString();
        if (activeMallGroupIds[mallGroupId]) return true;

        activeMallGroupIds[mallGroupId] = true;
        return false;
      });
    },
    notifyDuplicateActiveAlternateBarcodeMallGroup() {
      this.$notification['error']({
        message: 'Warning',
        description: "An active barcode already exists for this mall group. Only one active alternate barcode is allowed per mall group."
      });
    },
    alternateBarcodeCategoryCode(category) {
      if (category.code) return category.code;
      if (category.scopedSlots && category.scopedSlots.code) return category.scopedSlots.code;
      if (typeof category.value === "string") return category.value;
      return null;
    },
    alternateBarcodeCategoryLevel(category, depth = null) {
      if (category.level != null) return category.level;
      if (category.scopedSlots && category.scopedSlots.level) return category.scopedSlots.level;
      if (depth != null && typeof category.value === "string") return depth;
      return null;
    },
    hasAlternateBarcodeCategoryMetadata(categories = this.categoryOptions || []) {
      for (let index = 0; index < categories.length; index++) {
        const category = categories[index];
        if (
          this.alternateBarcodeCategoryCode(category) &&
          this.alternateBarcodeCategoryLevel(category, 0) != null
        ) {
          return true;
        }

        if (this.hasAlternateBarcodeCategoryMetadata(category.children || [])) {
          return true;
        }
      }

      return false;
    },
    clearDisallowedAlternateBarcodeFields(record) {
      ["pel", "dept", "sub_dept", "class_code", "sub_class", "vendpart"].forEach((field) => {
        if (!this.isAlternateBarcodeFieldAllowed(record, field)) {
          record[field] = "";
        }
      });
    },
    sanitizedAlternateBarcode(barcode) {
      const sanitized = { ...barcode };
      this.clearDisallowedAlternateBarcodeFields(sanitized);
      sanitized.quantity = this.formatAlternateBarcodeQuantity(sanitized.quantity);
      return {
        ...sanitized,
        dept_code: sanitized.dept,
        sub_dept_code: sanitized.sub_dept,
        sub_class_code: sanitized.sub_class,
      };
    },
    formatAlternateBarcodeQuantity(value) {
      if (value === null || value === undefined || value === "") return "";

      const normalizedValue = value.toString().replace(/,/g, "").trim();
      const numericValue = Number(normalizedValue);
      if (Number.isNaN(numericValue)) return value;

      return Number.isInteger(numericValue) ? numericValue.toString() : normalizedValue;
    },
    alternateBarcodeMallCode(mallGroupId) {
      const mallGroup = this.mallGroupOptions.find(
        ({ id }) => parseInt(id) === parseInt(mallGroupId)
      );
      return mallGroup ? mallGroup.code : "";
    },
    alternateBarcodeMallName(mallGroupId) {
      const mallGroup = this.mallGroupOptions.find(
        ({ id }) => parseInt(id) === parseInt(mallGroupId)
      );
      return mallGroup ? `${mallGroup.code} - ${mallGroup.name}` : "-";
    },
    barcodeEdit(key) {
      const newData = [...this.barcodeData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.editable = true;
        this.barcodeData = newData;
      }
    },
    barcodeSave(key) {
      const newData = [...this.barcodeData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        this.tableErrors = [];
        if (target.barcode == "") {
          this.tableErrors.push("Please input alternate barcode");
          this.tableErrors = this._.compact(this.tableErrors);
          return this.tableErrors.length;
        } else {
          if (target.mall_group_id == "") {
            this.$notification['error']({
              message: 'Warning',
              description: "Please select mall group."
            });
          } else if (this.missingAlternateBarcodeFormatFields(target).length) {
            this.$notification['error']({
              message: 'Warning',
              description: "SM format requires values in " + this.missingAlternateBarcodeFormatFields(target).join(', ') + "."
            });
          } else if (this.invalidAlternateBarcodeTemplateFields(target).length) {
            this.notifyInvalidAlternateBarcodeTemplateFields(this.invalidAlternateBarcodeTemplateFields(target));
          } else if (this.barcodeCacheData.find((x) => x.key !== target.key && x.status === "A" && x.barcode === target.barcode && x.mall_group_id && x.mall_group_id.toString() === target.mall_group_id.toString())) {
            this.$notification['error']({
              message: 'Warning',
              description: "Barcode already exists as an active barcode."
            });
          } else if (this.hasActiveAlternateBarcodeForMallGroup(target, newData)) {
            this.notifyDuplicateActiveAlternateBarcodeMallGroup();
          } else if (this.invalidAlternateBarcodeCategoryFields(target).length) {
            this.$notification['error']({
              message: 'Warning',
              description: this.invalidAlternateBarcodeCategoryFields(target).join(', ') + " category code is inactive or does not exist."
            });
          } else {
            target.quantity = this.formatAlternateBarcodeQuantity(target.quantity);
            delete target.editable;
            this.barcodeData = newData;
            this.barcodeCacheData = newData.map((item) => ({ ...item }));
          }
        }
      }
    },
    barcodeCancel(key) {
      const newData = [...this.barcodeData];
      const targetIndex = newData.findIndex((item) => key === item.key);
      const target = newData[targetIndex];
      this.tableErrors = [];
      if (target) {
        const cachedTarget = this.barcodeCacheData.find((item) => key === item.key);
        if (cachedTarget) {
          newData.splice(targetIndex, 1, { ...cachedTarget });
          this.barcodeData = newData;
        } else if (target.barcode == "" || target.mall_group_id == "") {
          const dataSource = [...this.barcodeData];
          this.barcodeData = dataSource.filter((item) => item.key !== key);
        } else {
          delete target.editable;
          this.barcodeData = newData;
        }
      }
    },
    //end barcodes

    //shelfcode
    shelfOnDelete(key) {
      const dataSource = [...this.shelfData];
      this.shelfData = dataSource.filter((item) => item.key !== key);
    },
    shelfHandleAdd() {
      const { shelfCount } = this;
      if (
        this.shelfData.find((x) => x.site_id === this.site_products.site_id)
      ) {
        alert("Site Already Exist");
      } else {
        if (this.siteOptions.find((x) => x.id === this.site_products.site_id)) {
          this.shelfData.push({
            key: shelfCount,
            site_id: this.site_products.site_id,
            site_name: this.siteOptions.find(
              (x) => x.id === this.site_products.site_id
            ).name,
            shelf_code: "",
          });

          this.shelfEdit(shelfCount);
          this.shelfCount = shelfCount + 1;
        } else {
          alert("Please select site");
        }
      }
    },
    shelfHandleChangeTable(value, key, column) {
      const newData = [...this.shelfData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.shelfData = newData;
      }
    },
    shelfEdit(key) {
      const newData = [...this.shelfData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.editable = true;
        this.shelfData = newData;
      }
    },
    shelfSave(key) {
      const newData = [...this.shelfData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        this.tableErrors = [];
        if (target.shelf_code == "") {
          this.tableErrors.push("Please input site shelf code");
          this.tableErrors = this._.compact(this.tableErrors);
          return this.tableErrors.length;
        } else {
          delete target.editable;
          this.shelfData = newData;
          this.shelfCacheData = newData.map((item) => ({ ...item }));
        }
      }
    },
    shelfCancel(key) {
      const newData = [...this.shelfData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        if (target.shelf_code == "") {
          const dataSource = [...this.shelfData];
          this.shelfData = dataSource.filter((item) => item.key !== key);
        } else {
          Object.assign(
            target,
            this.shelfCacheData.filter((item) => key === item.key)[0]
          );
          delete target.editable;
          this.shelfData = newData;
        }
      }
    },
    //end shelfcode

    //reorder
    reorderOnDelete(key) {
      const dataSource = [...this.reorderData];
      this.reorderData = dataSource.filter((item) => item.key !== key);
    },
    reorderHandleAdd() {
      const { reorderCount } = this;
      if (
        this.reorderData.find((x) => x.site_id === this.site_products.site_id)
      ) {
        alert("Site Already Exist");
      } else {
        if (this.siteOptions.find((x) => x.id === this.site_products.site_id)) {
          this.reorderData.push({
            key: reorderCount,
            site_id: this.site_products.site_id,
            site_name: this.siteOptions.find(
              (x) => x.id === this.site_products.site_id
            ).name,
            min_quantity: 0,
            max_quantity: 0,
          });
          this.reorderEdit(reorderCount);
          this.reorderCount = reorderCount + 1;
        } else {
          alert("Please select site");
        }
      }
    },
    reorderHandleChangeTable(value, key, column) {
      const newData = [...this.reorderData];
      const target = newData.filter((item) => key === item.key)[0];
      this.persiteKey = newData.findIndex((element) => element.key === target.key)
      if (target) {
        target[column] = value;
        this.reorderData = newData;
      }
    },
    reorderEdit(key) {
      const newData = [...this.reorderData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.editable = true;
        this.reorderData = newData;
      }
    },
    reorderSave(key) {
      var msg = "SITE: Please review your inputs"
      if(this.perSiteCheckMinMax == null){
        const newData = [...this.reorderData];
        const target = newData.filter((item) => key === item.key)[0];
        if (target) {
          delete target.editable;
          this.reorderData = newData;
          this.reorderCacheData = newData.map((item) => ({ ...item }));
          if(this.errors.includes(msg)){
            this.errors = this.errors.filter(error => error !== msg);
          }
        }
      }else{
        if(!this.errors.includes(msg)){
          this.errors.push(msg);
        }
      }
    },
    reorderCancel(key) {
      const newData = [...this.reorderData];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        if(this.reorderCacheData.filter((item) => key === item.key)[0]){
          Object.assign(
            target,
            this.reorderCacheData.filter((item) => key === item.key)[0]
          );
          delete target.editable;
          this.reorderData = newData;
        }else {
          this.reorderData = this.reorderData.filter(item => item.key !== key);
        }
      }
    },
    //end reorder

    //pricing
    priceOnDelete(key) {
      const dataSource = [...this.priceData];
      this.priceData = dataSource.filter((item) => item.key !== key);
    },
    //end pricing

    formattedDisplay(result) {
      return result.name;
    },
    productsEndpoint(input) {
      return (
        this.endPoint +
        "products?search_type=P&" +
        this.searchFilter +
        "=" +
        input
      );
    },
    getProductForKit: async function (group) {
      var searchProduct = group.selectedObject;
      this.kitData.push({
        key: this.kitCount,
        regular_product_id: searchProduct.id,
        quantity: 1,
        barcode: searchProduct.barcode,
        short_name: searchProduct.short_name,
        stock_no: searchProduct.stock_no,
        product_type: searchProduct.product_type,
        original_cost: searchProduct.original_cost,
        ordering_cost: searchProduct.ordering_cost,
        cost: searchProduct.landed_cost,
        retail_price: searchProduct.retail_price,
        wholesale_price: searchProduct.wholesale_price,
        least_price: searchProduct.least_price,
        special_price: searchProduct.special_price,
        price4: searchProduct.price4,
        price5: searchProduct.price5,
        status: "A",
        unit_code: searchProduct.unit_code,
      });

      this.kitEdit(this.kitCount);
      this.kitCount++;
      // console.log(this.kitData);
    },
    getProduct: async function (group) {
      var searchProduct = group.selectedObject;
      this.product = searchProduct;
      this.product.product_type = this.productType;
      this.product.barcode = '';
      this.regular_product_id = searchProduct.id;
      this.regular_name = searchProduct.name;
      this.regular_short_name = searchProduct.short_name;

      this.tmp_original_cost = group.selectedObject.original_cost;
      this.tmp_ordering_cost = group.selectedObject.ordering_cost;
      this.tmp_landed_cost = group.selectedObject.landed_cost;
      this.tmp_retail_price = group.selectedObject.retail_price;
      this.tmp_original_price = group.selectedObject.original_price;
      this.tmp_wholesale_price = group.selectedObject.wholesale_price;
      this.tmp_least_price = group.selectedObject.least_price;
      this.tmp_special_price = group.selectedObject.special_price;
      this.tmp_price4 = group.selectedObject.price4;
      this.tmp_price5 = group.selectedObject.price5;

      this.product_properties = {
        property_id: [],
      };

      this.selectProduct = true;

      // Object.assign(this.product, {
      //   original_cost: "",
      //   ordering_cost: "",
      //   landed_cost: "",
      //   retail_price: "",
      //   wholesale_price: "",
      //   least_price: "",
      //   special_price: "",
      //   price4: "",
      //   price5: "",
      // });

      var product_properties_data = await HTTPRequest.getRequest(
        this.endPoint +
          "product_properties?product_id=" +
          this.regular_product_id,
        null
      );
      product_properties_data.data.forEach((element) => {
        this.product_properties.property_id.push(element.property_id);
      });

      if (searchProduct.landed_cost > 0) {
        this.product.landed_cost_no_vat =
          searchProduct.landed_cost / (1 + this.default_vat_rate / 100);
      } else {
        this.product.landed_cost_no_vat = 0;
      }
      var landed_cost_no_vat = Number(this.product.landed_cost_no_vat);
      this.product.landed_cost_no_vat = landed_cost_no_vat.toFixed(
        this.cost_decimal_places
      );

      if (searchProduct.intro_date == null) {
        this.product.intro_date = null;
      } else {
        this.product.intro_date = moment(searchProduct.intro_date);
      }

      if (searchProduct.reference_date == null) {
        this.product.reference_date = null;
      } else {
        this.product.reference_date = moment(searchProduct.reference_date);
      }

      if (searchProduct.category_id > 0) {
        var parent_cat = this.categoryOptions[0].value;
        this.cascader_category = [
          parent_cat,
          searchProduct.division_id,
          searchProduct.department_id,
          searchProduct.section_id,
          searchProduct.category_id,
        ];
      }

      if (searchProduct.salesman_commission > 0) {
        this.is_enable_sales_commission = true;
      }

      if (searchProduct.supplier_commission > 0) {
        this.is_enable_supplier_commission = true;
      }
    },
    updatePackagePrice() {
      this.is_quantity_change = true;
      if (this.change_price_cost_package_on_regular_update == true) {
        let qty = Number(this.product.content_quantity);
        Object.assign(this.product, {
          original_cost: Number(this.tmp_original_cost) * qty,
          ordering_cost: Number(this.tmp_ordering_cost) * qty,
          landed_cost: Number(this.tmp_landed_cost) * qty,
          retail_price: Number(this.tmp_retail_price) * qty,
          wholesale_price: Number(this.tmp_wholesale_price) * qty,
          least_price: Number(this.tmp_least_price) * qty,
          special_price: Number(this.tmp_special_price) * qty,
          price4: Number(this.tmp_price4) * qty,
          price5: Number(this.tmp_price5) * qty,
        });
      }else{
        // show modal if quantity in pack change
        if((this.is_quantity_change && this.selectProduct) || (this.is_quantity_change && this.base_product_name)){
        this.modalPackageQuantity = true;
        }
      }

      if (this.productType == "P") {
        if(this.product.name != undefined && this.product.name.includes(` ${this.product.unit_code} `)){
          this.constructName("name");
        }
        if (this.package_name_format_base == true) {
          this.constructName("short_name");
        }
      }
    },

    confirmPackageQuantityModal() {
       this.modalPackageQuantity = false;
      //  recompute cost and price
      let qty = Number(this.product.content_quantity);
      Object.assign(this.product, {
          original_cost: Number(this.tmp_original_cost) * qty,
          ordering_cost: Number(this.tmp_ordering_cost) * qty,
          landed_cost: Number(this.tmp_landed_cost) * qty,
          retail_price: Number(this.tmp_retail_price) * qty,
          original_price: Number(this.tmp_original_price) * qty,
          wholesale_price: Number(this.tmp_wholesale_price) * qty,
          least_price: Number(this.tmp_least_price) * qty,
          special_price: Number(this.tmp_special_price) * qty,
          price4: Number(this.tmp_price4) * qty,
          price5: Number(this.tmp_price5) * qty,
        });
        this.computeLandedCostNoTax();
    },

    closeDrawer() {
      this.onClose();
    },
    setTargetData(value) {
      if (this.productType == "P") {
        //do nothing
      } else {
        var selectedRowKeys = this.selectedRowKeys.filter(
          (x) => typeof x === "number"
        );
        if (selectedRowKeys.filter((item) => item === value.site_id)) {
          this.selectedRowKeys.push(value.site_id);
        }
      }

      this.priceData.push(value);
    },
    setMatrixData(value) {
      this.matrixData = value;
    },
    updateTargetData(value) {
      this.priceData = value;
    },

    onClose() {
      this.visible = false;
    },
    showDrawer(key) {
      this.componentKey++;
      this.targetKey = key;
      this.visible = true;
    },

    handleCancel() {
      this.previewVisible = false;
      this.modalPackageQuantity = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      let check_image = fileList.findIndex(x=> x.status == "uploading")
      if (check_image>=0){
        fileList.splice(check_image, 1);
      }
      this.fileList = fileList;
      this.fileListTemp = this.fileList;
    },
    async beforeUpload(file) {
      let img_height,img_width;
      var canvas = document.createElement('canvas');
      canvas.id = "canvas123";
      canvas.style.visibility = 'hidden';
      document.body.appendChild(canvas);
      var quality = file.size * 100 || 70;
      const reader = new FileReader();
      reader.onload = (theFile) => {
        const image = new Image();
        image.src = theFile.target.result;
        image.onload = () => {
          img_height = image.height
          img_width = image.width
          var width_ratio = img_width < 330 ? 330 / img_width : 1;
          var height_ratio = img_height < 330 ? 330 / img_height : 1;
          canvas.width = img_width * width_ratio;
          canvas.height = img_height * height_ratio;
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.height,canvas.width);
        };
      };
      reader.readAsDataURL(file);
     setTimeout(async function(scope){
      const isIH = img_height>=330,isIW = img_width>=330;
      if (!scope.disable_width_and_length_validation){
        if (!isIH) {
          scope.$notification['error']({
            message: 'Failed',
            description: "Image height must at least 330px."
          });
        }
        if (!isIW) {
          scope.$notification['error']({
            message: 'Failed',
            description: "Image width must at least 330px."
          });
        }
      }else{
        if (!isIW || !isIH){
          try {
            var newImageData = canvas.toDataURL(file.type,quality / 100);
            var arr = newImageData.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
            u8arr[n] = bstr.charCodeAt(n);
            }
            file = new File([u8arr], file.uid+"-"+file.name, {type:file.type});
          } catch (error) {
            
          }
        }
      }
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        scope.$notification['error']({
          message: 'Failed',
          description: "You can only upload JPG file!"
        });
      }
      var isLt1M = file.size / 1024 / 1024 <= 1;
      if (!isLt1M) {
        scope.$notification['error']({
          message: 'Failed',
          description: "Image must smaller than 1MB!"
        });
      }
      if(isLt1M && isJpgOrPng && isIW && isIH){
        let data = new FormData();
        var s3_endpoint;
        data.append('file', file);
        if (secureStorage.getItem("s3Endpoint")==null){
          var uploader_endpoint = await HTTPRequest.getRequest(scope.endPoint + 'settings/api_s3_uploader', null, null)
          secureStorage.setItem("s3Endpoint", uploader_endpoint.endpoint);
          s3_endpoint = uploader_endpoint.endpoint
        }else{
          s3_endpoint = secureStorage.getItem("s3Endpoint")
        }
        var config = {
          method: 'post',
          url: s3_endpoint+'?profile=products&account_name='+secureStorage.getItem("accountName"),
          // headers: {'Authorization': 'Bearer ' + "6YcIGdla2saa6mkJxUw9cyxIknATd-TuJ2bs7k_VPmI"},
          headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
          data : data,
        };
        var response_data,err;
        await axios(config)
          .then(function (response) {
              response_data = response.data
          })
          .catch(function (error) {
              console.log(error)
              err = error
        });
        if (err==null || err==undefined){
          let check_image = scope.fileList.findIndex(x=> x.name == file["name"])
          if(check_image>=0){
            scope.fileList[check_image] = {uid:scope.fileList.length,url:response_data.path || '',status:'done',name:file["name"]}
          }else{
            scope.fileList.push({uid:scope.fileList.length,url:response_data.path || '',status:'done',name:file["name"]})
          }
        }else{
          scope.$notification['error']({
            message: 'Failed',
            description: err.toString()
          });
        }
      }
      }, 1000,this);
    },

    // Advanced Info
    showAdvancedInfoDiv() {
      this.showAdvancedInfo
        ? (this.showAdvancedInfo = false)
        : (this.showAdvancedInfo = true);
    },
    computeLandedCostNoTax() {
      if (this.tax_type == "V") {
        var x = this.product.landed_cost;
        var z = this.default_vat_rate;
        var y = 0;

        if (x > 0) {
          y = x / (1 + z / 100);
        }

        this.product.landed_cost_no_vat = this.fixedCostDecimal(y);
      } else {
        this.product.landed_cost_no_vat = this.product.landed_cost;
      }

      if (
        this.product.markup_percent != 0 &&
        this.product.markup_percent != ""
      ) {
        if (this.product.retail_price !== 0 && this.product.retail_price !== "") {
          this.computeMarkup(null)
        } else {
          this.computePrice(null);
        }
      }
    },
    computeMarkup(e) {
      let name;
      if (e == null) {
        name = e;
      } else {
        name = e.target.name;
      }

      let y = 0;
      let z = 0;
      if (this.enable_auto_compute_price_on_markup == true) {
        if (name == "percent_special") {
          y = this.product.special_price;
          z = this.percentBaseComputation(y);
          this.markup_special_price = parseFloat(z).toFixed(2);
        } else if (name == "percent_least") {
          y = this.product.least_price;
          z = this.percentBaseComputation(y);
          this.markup_least_price = parseFloat(z).toFixed(2);
        } else if (name == "percent_wholesale") {
          y = this.product.wholesale_price;
          z = this.percentBaseComputation(y);
          this.markup_wholesale_price = parseFloat(z).toFixed(2);
        } else if (name == "percent_price4") {
          y = this.product.price4;
          z = this.percentBaseComputation(y);
          this.markup_price4 = parseFloat(z).toFixed(2);
        } else if (name == "percent_price5") {
          y = this.product.price5;
          z = this.percentBaseComputation(y);
          this.markup_price5 = parseFloat(z).toFixed(2);
        } else {
          y = this.product.retail_price;
          z = this.percentBaseComputation(y);
          this.product.markup_percent = parseFloat(z).toFixed(2);
        }
      }
    },
    computePrice(e) {
      let name;
      if (e == null) {
        name = e;
      } else {
        name = e.target.name;
      }

      let y = 0;
      let z = 0;
      if (this.enable_auto_compute_price_on_markup == true) {
        if (name == "special") {
          y = this.markup_special_price;
          // if (this.product.special_price == "") {
          z = this.baseComputation(y);
          this.product.special_price = parseFloat(z).toFixed(2);
          // }
        } else if (name == "least") {
          y = this.markup_least_price;
          // if (this.product.least_price == "") {
          z = this.baseComputation(y);
          this.product.least_price = parseFloat(z).toFixed(2);
          // }
        } else if (name == "wholesale") {
          y = this.markup_wholesale_price;
          // if (this.product.wholesale_price == "") {
          z = this.baseComputation(y);
          this.product.wholesale_price = parseFloat(z).toFixed(2);
          // }
        } else if (name == "price4") {
          y = this.markup_price4;
          // if (this.product.price4 == "") {
          z = this.baseComputation(y);
          this.product.price4 = parseFloat(z).toFixed(2);
          // }
        } else if (name == "price5") {
          y = this.markup_price5;
          // if (this.product.price5 == "") {
          z = this.baseComputation(y);
          this.product.price5 = parseFloat(z).toFixed(2);
          // }
        } else {
          y = this.product.markup_percent;
          // if (this.product.retail_price == "") {
          z = this.baseComputation(y);
          this.product.retail_price = parseFloat(z).toFixed(2);
          // }
        }
      }
    },
    baseComputation(y) {
      var x = this.product.landed_cost;
      var z = 0;
      var based_on = this.markup_computation;

      if (based_on == "1") {
        z = x / (1 - y / 100);
      } else {
        z = x * (1 + y / 100);
      }

      var val = Number(z);
      var fixedVal = val.toFixed(6); //to eliminate float errors

      var cons =
        Math.ceil(fixedVal / this.markup_roundup) * this.markup_roundup;
      var fixedCons = this.fixedCostDecimal(cons);

      return fixedCons;
    },
    percentBaseComputation(z) {
      var x = this.product.landed_cost;
      var y = 0;
      var based_on = this.markup_computation;

      if (based_on == "1") {
        y = (1 - x / z) * 100;
      } else {
        y = (z / x - 1) * 100;
      }

      var val = Number(y);
      var fixedVal = val.toFixed(4); //to eliminate float errors

      return fixedVal;
    },
    changeAmount(e) {
      let name = e.target.name;
      let x = 0;
      if (name == "original") {
        x = this.fixedCostDecimal(this.formattedOriginalCost);
        this.product.original_cost = x;

        if (this.product.ordering_cost == "") {
          this.product.original_cost = this.product.original_cost;
          this.product.ordering_cost = this.product.original_cost;
        }
      } else if (name == "ordering") {
        x = this.fixedCostDecimal(this.formattedOrderingCost);
        this.product.ordering_cost = x;

        if (this.product.original_cost == "") {
          this.product.original_cost = this.product.ordering_cost;
        }
      } else if (name == "landed") {
        x = this.fixedCostDecimal(this.formattedLandedCost);
        this.product.landed_cost = x;
        this.computeLandedCostNoTax();
      }
    },
    fixedCostDecimal(value) {
      let val = Number(value);
      let x = val.toFixed(this.cost_decimal_places);
      return x;
    },
    getUnitCode: async function (value) {
      var unit = await HTTPRequest.getRequest(
        this.endPoint + "units/" + value,
        null
      );
      this.product.unit_code = unit.name;
      this.updateKey++;

      if (this.productType == "P") {
        this.constructName("name");

        if (this.package_name_format_base == true) {
          this.constructName("short_name");
        }
      }
    },
    getIntroDate: async function (value) {
      var product_line = await HTTPRequest.getRequest(
        this.endPoint + "product_lines/" + value,
        null
      );
      if (product_line.intro_at == null) {
        this.product.intro_date = null;
      } else {
        this.product.intro_date = moment(product_line.intro_at);
      }
      this.updateKey++;
    },
    onSetVatex(e) {
      let discount = e.target.value;
      let name = e.target.name;
      if (discount >= 20) {
        if (name == "sc_discount") {
          this.product.is_senior_vatex = true;
          this.product.is_senior_nolimit = true;
        } else if (name == "sp_discount"){
          this.product.is_sp_vatex = true;
        } else if (name == "na_discount"){
          this.product.is_pnstm_vatex = true;
          this.product.is_pnstm_nolimit = true;
        } else {
          this.product.is_pwd_vatex = true;
          this.product.is_pwd_nolimit = true;
        }
      } else {
        if (name == "sc_discount") {
          this.product.is_senior_vatex = false;
          this.product.is_senior_nolimit = false;
        } else if (name == "sp_discount"){
          this.product.is_sp_vatex = true;
        } else if (name == "na_discount"){
          this.product.is_pnstm_vatex = false;
          this.product.is_pnstm_nolimit = false;
        } else {
          this.product.is_pwd_vatex = false;
          this.product.is_pwd_nolimit = false;
        }
      }

    },
    updateIntroDate(date) {
      if (date == null) {
        this.product.intro_date = null;
      } else {
        this.product.intro_date = date;
      }
      this.updateKey++;
    },
    updateRefDate(date) {
      if (date == null) {
        this.product.reference_date = null;
      } else {
        this.product.reference_date = date;
      }
      this.updateKey++;
    },

    handleClick(e) {
      if (this.activeKey == "1") {
        this.basicKey = e.key;
        this.basicSelectedKeys = [e.key]
      } else if (this.activeKey == "3") {
        this.userKey = e.key;
      } else {
        this.advanceKey = e.key;
        this.advanceSelectedKeys = [e.key]
      }
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    updateParams(value) {
      switch (value.length) {
        case 5:
          Object.assign(this.product, {
            category_id: value[4]
          })
        case 4:
          Object.assign(this.product, {
            section_id: value[3]
          })
        case 3:
          Object.assign(this.product, {
            department_id: value[2]
          })
        case 2:
          Object.assign(this.product, {
            division_id: value[1]
          })
          break
        default:
          Object.assign(this.product, {
            division_id: null,
            department_id: null,
            section_id: null,
            category_id: null,
          })
      }
    },
    onCheckSiteId(selectedRowKeys) {
      // console.log(selectedRowKeys)
      if (this.productType == "P") {
        this.selectedRowKeys = this.selectedRowKeys;
        // console.log(this.productType);
        // console.log(this.selectedRowKeys);
      } else {
        this.selectedRowKeys = selectedRowKeys;
      }
    },
    openNotificationWithIcon(type, num, field) {
      if (num == 1) {
        return "This product has Zero " + field;
      } else if (num == 2) {
        return "This product has Zero " + field;
      } else if (num == 3) {
        return field + " is below Cost (landed)";
      } else if (num == 4) {
        return field + " has changed and it contains a package";
      }
    },
    limit(e) {
      let dimension = e.target.value;
      let max_chars = 20;
      if (dimension.length > max_chars) {
        this.product[e.target.name] = dimension.substr(0, max_chars);
      }
    },
    updateAlternateSupplier: async function (value) {
      var suppliers = await HTTPRequest.getRequest(
        this.endPoint + "suppliers/get_valid_suppliers?supplier_id=" + value,
        null
      );
      this.supplierOptions = suppliers;
      this.sort(this.supplierOptions);

      this.alternate_supplier_id = null;
    },
    updateAlternateForeignSupplier: async function (value) {
      var foreign_suppliers = await HTTPRequest.getRequest(
        this.endPoint + "foreign_suppliers/get_valid_foreign_suppliers?foreign_supplier_id=" + value,
        null
      );
      this.foreignSupplierOptions = foreign_suppliers;
      this.sort(this.supplierOptions);

    },


    updateProductSeriesSeriesDate(date) {
      if (date != null) {
        this.product_series.series_date = moment(date).format("MMMM DD, YYYY");
      }
      // use for changing delete button on product_series
      if (this.productseriesButton == "delete") {
        this.productseriesButton = "add";
      }
    },

    changeProductSeriesButton(record) {
      return {
        on: {
          click: () => {
            this.productseriesButton = "delete";
            this.productseriesKey = record.key;
          },
        },
      };
    },

    productseriesDelete(key) {
      const dataSource = [...this.productseriesData];
      this.productseriesData = dataSource.filter((item) => item.key !== key);
      this.productseriesButton = "add";
    },

    productseriesHandleAdd: async function () {
      const productseriesCount = this.productseriesCount;

      this.tableErrors = [];
      const product_series = this.product_series;

      // product series validation

      if (!this.product_series.series_name) {
        this.tableErrors.push("Series Name Required");
      }


      if (!product_series.series_date) {
        this.tableErrors.push("Series Date Required");
      }

      if (
        this.productseriesData.find(
          (object) =>
            object.series_name.toLowerCase() ===
            product_series.series_name.toLowerCase()
        )
      ) {
        this.tableErrors.push("Series Name already exists");
      }

      if (this.tableErrors.length <= 0) {
        product_series.key = productseriesCount;
        product_series.status = "A";
        this.productseriesData.push({ ...product_series });

        this.productseriesCount = productseriesCount + 1;
        this.product_series = [];
      }
    },
    // end of product series methods

    // product group methods

    // get product group data method
    async getProductGroupData() {
      var product_group_data = await HTTPRequest.getRequest(
        this.endPoint + "product_groups/get_valid_product_groups",
        null
      );

      this.productGroupOptions = product_group_data;
    },

    updateProductGradeEffectivityDate(date) {
      if (date != null) {
        this.product_grade.effectivity_date =
          moment(date).format("MMMM DD, YYYY");
      }

      this.tableErrors = [];
    },

    disabledDate(current) {
      return current < moment().startOf("day");
    },

    productGradeHandleAdd: async function () {
      this.tableErrors = [];
      const product_grade = this.product_grade;
      const productGradeCount = this.productGradeCount;
      var last_level = 0;
      var last_effectivity_date;

      var last_product_grade = this.productGradeData.slice(-1)[0];
      if (last_product_grade != null) {
        // console.log(last_product_group.effectivity_date);
        last_effectivity_date = new Date(last_product_grade.effectivity_date);
        last_level = last_product_grade.level;
        // console.log(last_effectivity_date, last_level);
      }

      // console.log(last_effectivity_date);

      if (!product_grade.effectivity_date) {
        this.tableErrors.push("Effectivity Date Required");
      }

      if (last_effectivity_date != null) {
        if (
          moment(product_grade.effectivity_date).isSameOrBefore(
            last_effectivity_date,
            "day"
          ) &&
          product_grade.effectivity_date != null
        ) {
          this.tableErrors.push(
            "Effectivity Date Cannot be before " +
              last_effectivity_date.toLocaleDateString()
          );
        }
      }

      if (this.tableErrors.length <= 0) {
        // console.log(last_level);
        product_grade.status = "A";
        // product_grade.key = productGradeCount;
        // let date_level = new Date(product_grade.effectivity_date)
        // let dateLevel = date_level.getDate()
        // if(dateLevel >= 1 && dateLevel <= 4){
        //   last_level = 1
        // }
        // else if(dateLevel >= 5 && dateLevel <= 9){
        //   last_level = 2
        // }
        // else if(dateLevel >= 10 && dateLevel <= 31){
        //   last_level = 3
        // }
        // else {
        //   last_level = null
        // }

        product_grade.level = last_level + 1;
        this.productGradeData.push({ ...product_grade });
        // console.log(product_group);
        this.productGradeCount = productGradeCount + 1;
        this.product_grade = [];
      }
    },
    areArraysEqualSets(array1, array2) {
        const superSet = {};
        for (const i of array1) {
          const e = i + typeof i;
          superSet[e] = 1;
        }
        for (const i of array2) {
          const e = i + typeof i;
          if (!superSet[e]) {
            return false;
          }
          superSet[e] = 2;
        }
        for (let e in superSet) {
          if (superSet[e] === 1) {
            return false;
          }
        }
        return true;
    },
    create: async function () {
      this.spinning = true;
      if (!this.validateForm()) {

        this.product.tax_type = this.tax_type;

        //removal of CLP points
        if (this.product.is_reward_item == false) {
          this.product.reward_required_points = 0;
        }

        //removal of Commissions
        if (this.product.is_enable_sales_commission == false) {
          this.product.salesman_commission = 0;
        }

        if (this.product.is_enable_supplier_commission == false) {
          this.product.supplier_commission = 0;
        }

        //for image
        let file = null;
        if (this.fileList.length > 0) {
          if (this.fileList[0].response == undefined) {
            file = this.fileList[0].name;
          } else {
            file = this.fileList[0].response;
          }
        }
        this.product.filename = file;
        this.product.images_url = this.fileList;

        //for properties
        if (this.product_properties.property_id != undefined) {
          var property_ids = this.product_properties.property_id;
          var product_properties = [];
          property_ids.forEach((element) => {
            product_properties.push({
              property_id: element,
              status: "A",
            });
          });
          this.product.product_properties = product_properties;
        }

        if (this.product.product_type == "V") {
          this.product.is_inventory = false;
        }

        //for alternate supplier
        if (this.data.length > 0) {
          var supplier_products = this.data;
          this.product.supplier_products = supplier_products;
        }

        //for alternate barcode
        if (this.barcodeData.length > 0) {
          if (this.hasDuplicateActiveAlternateBarcodeMallGroup()) {
            this.notifyDuplicateActiveAlternateBarcodeMallGroup();
            this.spinning = false;
            return;
          }
          const invalidAlternateBarcodeTemplateFields = this.firstInvalidAlternateBarcodeTemplateFields();
          if (invalidAlternateBarcodeTemplateFields.length) {
            this.notifyInvalidAlternateBarcodeTemplateFields(invalidAlternateBarcodeTemplateFields);
            this.spinning = false;
            return;
          }

          var alternate_barcodes = this.barcodeData.map((barcode) =>
            this.sanitizedAlternateBarcode(barcode)
          );
          this.product.product_barcodes = alternate_barcodes;
        }

        // for product series create
        if (this.productseriesData.length > 0) {
          var product_series = this.productseriesData;
          this.product.product_series = product_series;
        }

        // for product group create
        if (this.productGradeData.length > 0) {
          var product_grades = this.productGradeData;
          this.product.product_grades = product_grades;
        }

        //for shelf code
        if (this.shelfData.length > 0) {
          var site_shelf_codes = this.shelfData;
          this.product.site_shelf_codes = site_shelf_codes;
        }

        //for reorder
        if (this.reorderData.length > 0) {
          var site_reorders = this.reorderData;
          this.product.site_reorders = site_reorders;
        }

        this.product.is_dirty_site_product = 1

        if (this.selectedRowKeys.length > 0) {
          // use to filter string from number
          var site_ids = this.selectedRowKeys.filter(
            (x) => typeof x === "number"
          );
          var site_products = [];
          site_ids.forEach((element) => {
            site_products.push({
              site_id: element,
              status: "A",
            });
          });
          this.product.site_products = site_products;
        }

        //for site_pricing
        if (this.priceData.length > 0) {
          var site_prices = []
          if(this.is_site_price == true){
            site_prices = this.priceData;
          }
          this.product.site_prices = site_prices;
        }

        let product_compositions = [];
        if (this.productType == "P" || this.product.product_type == "P") {
          product_compositions.push({
            regular_product_id: this.regular_product_id,
            cost: this.product.landed_cost,
            status: "A",
            remark: this.product.remark,
            quantity: this.product.content_quantity,
          });
          // this.product.barcode = "";
          this.product.product_compositions = product_compositions;
        } else if (
          this.productType == "K" ||
          this.productType == "V" ||
          this.product.product_type == "K" ||
          this.product.product_type == "V"
        ) {
          product_compositions = this.kitData;
          this.product.product_compositions = product_compositions;

          //save kitSettings
          var userSettingHash = {};
          var userId = secureStorage.getItem("userId");
          userSettingHash["recompute_kit_cost"] = this.recompute_cost;
          userSettingHash["recompute_kit_price"] = this.recompute_price;

          var response;
          response = await HTTPRequest.getRequest(
            this.endPoint + "/user_settings?module_name=kit&user_id=" + userId,
            null
          );
          if (response.data.length == 0) {
            var createParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash),
              },
            };
            await HTTPRequest.postRequest(
              this.endPoint + "/user_settings",
              null,
              createParams
            );
          } else {
            var updateParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash),
              },
            };
            await HTTPRequest.putRequest(
              this.endPoint + "/user_settings/" + response.data[0].id,
              null,
              updateParams
            );
          }
        } else if (
          this.productType == "M" ||
          this.product.product_type == "M"
        ) {
          var product_matrixes = this.matrixData;
          this.product.product_matrixes = product_matrixes;
        }

        // set default tax type
        if(this.tax_type == "V"){
          this.product.tax_type = "V"
        }

        var product_hash = {};
        product_hash.product = this.product;
        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "products",
          null,
          product_hash
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(",");
          }
        }
      }
      // method to call this function after 1 second
      setTimeout(this.scrollTop, 1000);
    },
    update: async function () {
      this.spinning = true;
      // bryan
      // this.is_updating = true
      this.is_updating = this.packages.length === 0? false : true;
      if (!this.validateForm()) {
        //removal of CLP points

        this.product.tax_type = this.tax_type;

        if (this.product.is_reward_item == false) {
          this.product.reward_required_points = 0;
        }

        //removal of Commissions
        if (this.product.is_enable_sales_commission == false) {
          this.product.salesman_commission = 0;
        }

        if (this.product.is_enable_supplier_commission == false) {
          this.product.supplier_commission = 0;
        }

        if (this.change_price_cost_package_on_regular_update == true) {
          this.product.change_price_cost_package_on_regular_update =
            this.change_price_cost_package_on_regular_update;
        }

        let file = null;
        if (this.fileList.length > 0) {
          if (this.fileList[0].response == undefined) {
            file = this.fileList[0].name;
          } else {
            file = this.fileList[0].response;
          }
        }
        this.product.filename = file;
        this.product.images_url = this.fileList;

        //for properties
        if (this.product_properties.property_id != undefined) {
          var property_ids = this.product_properties.property_id;
          var product_properties = [];
          property_ids.forEach((element) => {
            product_properties.push({
              property_id: element,
              status: "A",
            });
          });
          this.product.product_properties = product_properties;
        }

        if (this.product.product_type == "V") {
          this.product.is_inventory = false;
        }

        //for alternate supplier
        if (this.data.length > 0) {
          var supplier_products = this.data;
          this.product.supplier_products = supplier_products;
        }

        //for alternate barcode
        if (this.barcodeData.length > 0) {
          if (this.hasDuplicateActiveAlternateBarcodeMallGroup()) {
            this.notifyDuplicateActiveAlternateBarcodeMallGroup();
            this.spinning = false;
            return;
          }

          var alternate_barcodes = this.barcodeData.map((barcode) =>
            this.sanitizedAlternateBarcode(barcode)
          );
          this.product.product_barcodes = alternate_barcodes;
        }
        
    //     var fsp_product = foreign_suppliers.find(fsp => fsp.product_id === this.productId);
    // console.log('fsps',fsp_product.id )
    // component_x.foreignSupplierProduct.foreign_supplier_id = fsp_product.id
    
        if (this.foreign_supplier_products.foreign_supplier_id != null) {
          this.foreign_supplier_products.product_id = this.profileId;
          var fs_product_params = {
            foreign_supplier_id: this.foreign_supplier_products.foreign_supplier_id,
            product_id: this.foreign_supplier_products.product_id
          }
          await HTTPRequest.postRequest(
                this.endPoint + "foreign_supplier_products",
                null,
                fs_product_params
              );
        }
        // for product series update
        if (this.productseriesData.length > 0) {
          var product_series = this.productseriesData;
          this.product.product_series = product_series;
        }

        // for product group update
        if (this.productGradeData.length > 0) {
          var product_grades = this.productGradeData;
          this.product.product_grades = product_grades;
        }

        //for shelf code
        if (this.shelfData.length > 0) {
          var site_shelf_codes = this.shelfData;
          this.product.site_shelf_codes = site_shelf_codes;
        }

        //for reorder
        if (this.reorderData.length > 0) {
          var site_reorders = this.reorderData;
          this.product.site_reorders = site_reorders;
        }

        let isNoChanges = this.areArraysEqualSets(this.selectedRowKeys, this.cleanSiteIds)
        if(isNoChanges == true){
          this.product.is_dirty_site_product = 0
        } else {
          this.product.is_dirty_site_product = 1
        }

        //for site_products
        if (this.selectedRowKeys.length > 0) {
          var site_ids = this.selectedRowKeys.filter(
            (x) => typeof x === "number"
          );
          var site_products = [];
          site_ids.forEach((element) => {
            site_products.push({
              site_id: element,
              status: "A",
            });
          });
          this.product.site_products = site_products;
        }

        //for site_pricing
        if (this.priceData.length > 0) {
          var site_prices = []
          if(this.is_site_price == true){
            site_prices = this.priceData;
          }

          this.product.site_prices = site_prices;
        }

        if (this.productType == "P" || this.product.product_type == "P") {
          let product_compositions = [];
          product_compositions.push({
            regular_product_id: this.regular_product_id,
            cost: this.product.landed_cost,
            status: "A",
            remark: this.product.remark,
            quantity: this.product.content_quantity,
          });

          this.product.product_compositions = product_compositions;
        } else if (
          this.productType == "K" ||
          this.productType == "V" ||
          this.product.product_type == "K" ||
          this.product.product_type == "V"
        ) {
          let product_compositions = this.kitData;
          this.product.product_compositions = product_compositions;

          //save kitSettings
          var userSettingHash = {};
          var userId = secureStorage.getItem("userId");
          userSettingHash["recompute_kit_cost"] = this.recompute_cost;
          userSettingHash["recompute_kit_price"] = this.recompute_price;

          var response;
          response = await HTTPRequest.getRequest(
            this.endPoint + "/user_settings?module_name=kit&user_id=" + userId,
            null
          );
          if (response.data.length == 0) {
            var createParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash),
              },
            };
            await HTTPRequest.postRequest(
              this.endPoint + "/user_settings",
              null,
              createParams
            );
          } else {
            var updateParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash),
              },
            };
            await HTTPRequest.putRequest(
              this.endPoint + "/user_settings/" + response.data[0].id,
              null,
              updateParams
            );
          }
        } else if (
          this.productType == "M" ||
          this.product.product_type == "M"
        ) {
          var product_matrixes = this.matrixData;
          this.product.product_matrixes = product_matrixes;
        }

        var product_hash = {};
        console.log(this.product)
        product_hash.product = this.product
        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "products/" + this.profileId,
          null,
          product_hash
        );

        await this.setOrderingUnit()
        this.is_updating = false
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event, 'update');
          } else {
            this.errors = put_request["error"].split(",");
          }
        }

        if (!this.is_site_price) {
          let payload = {
            product_id: this.profileId,
            site_product: {
              landed_cost: null,
              least_price: null,
              ordering_cost: null,
              original_cost: null,
              retail_price: null,
              special_price: null,
              wholesale_price: null
            }
          }
          await HTTPRequest.putRequest(
            this.endPoint +
            "site_products/update_is_site_price_product",
            null,
            payload
          );
        }
      }
      setTimeout(this.scrollTop, 1000);
    },
    showModal: async function () {
      this.checkWarning();

      if (this.warnings.length > 0) {
        this.modalVisible = true;
      } else {
        if (this.profileId == 0) {
          this.create();
        } else {
          this.update();
        }
      }
    },
    handleOk: async function () {
      if (this.profileId == 0) {
        this.create();
      } else {
        this.update();
      }
      this.modalVisible = false;
    },
  },
};
</script>

<style scope>
.has-success:after {
  display: none;
}

.has-danger:after {
  display: none;
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 90%;
    color: #fb6340;
}

.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: hidden;
}

.ant-collapse > .ant-collapse-item-active > .ant-collapse-header {
  background-color: #32325d;
  color: white;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 0px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.editable-row-operations a {
  margin-right: 8px;
}

.alternate-barcode-actions span {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.alternate-barcode-actions a {
  margin-right: 0;
  min-width: 58px;
  text-align: center;
}
</style>
